export const QUESTIONS = [
  {
    "id": 1,
    "question": "Seth’s organization recently experienced a security incident where an attacker was able to place offensive content on the homepage of his organization’s website. Seth would like to implement a series of security controls to prevent this type of attack from occurring in the future. What goal of information security is Seth most directly addressing?",
    "choice_a": "Integrity",
    "choice_b": "Availability",
    "choice_c": "Nonrepudiation",
    "choice_d": "Confidentiality",
    "correct_answer": "A",
    "explanation": "The three main goals of information security are confidentiality, integrity, and availability, so we can eliminate nonrepudiation right away. There is also no indication that there was any disclosure of sensitive information, so we can also eliminate confidentiality. We could consider this an availability breach if the attacker made legitimate information unavailable, but integrity is a better answer here because the attacker definitely altered the content of the website without authorization.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      136,
      40,
      32,
      84,
      80
    ],
    "source": "801931 Assessment test"
  },
  {
    "id": 2,
    "question": "Kevin is conducting a SWOT analysis for his organization’s cybersecurity program. He is especially proud of the talented and diverse team that exists within his organization. Where would he place this quality on the SWOT matrix?",
    "choice_a": "Upper-left quadrant",
    "choice_b": "Upper-right quadrant",
    "choice_c": "Lower-left quadrant",
    "choice_d": "Lower-right quadrant",
    "correct_answer": "A",
    "explanation": "This is an example of a strength. It is an internal force that is positive. Therefore, it would be placed in the upper-left quadrant. The upper-right quadrant is for internal negative forces or weaknesses. The lower-left quadrant is for external positive forces, or opportunities. The lower-right quadrant is for external negative forces or threats.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      11,
      14,
      10,
      12,
      4
    ],
    "source": "801931 Assessment test"
  },
  {
    "id": 3,
    "question": "Jen is building out a series of controls for her organization’s information security program and is categorizing those controls by type. She is updating the organization’s firewall to include next-generation capabilities. What type of control is she working on?",
    "choice_a": "Detective",
    "choice_b": "Preventive",
    "choice_c": "Compensating",
    "choice_d": "Deterrent",
    "correct_answer": "B",
    "explanation": "Firewalls are best described as preventive controls because their purpose is to block an attack from succeeding. Detective controls seek to identify attacks that are taking place and, though a firewall can detect some attacks, this is not the primary purpose of the device. Firewalls may also serve as compensating controls in a regulatory environment, but there is no indication in this question that the firewall is being used as a compensating control. Firewalls are not normally visible to an attacker until after they have attempted an attack, so they cannot serve as deterrent controls.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      40,
      119,
      35,
      42,
      107
    ],
    "source": "801931 Assessment test"
  },
  {
    "id": 4,
    "question": "Belinda recently assumed the CISO role at a publicly traded company. She is sorting through the corporate governance model and identifying the roles that different people and groups play in the organization. Which one of the following roles has ultimate authority for the corporation?",
    "choice_a": "CEO",
    "choice_b": "CIO",
    "choice_c": "Board",
    "choice_d": "Board chair",
    "correct_answer": "C",
    "explanation": "The board of directors, acting as a group, has ultimate authority over the organization. They are elected by the shareholders who own the company and serve as the owner’s representatives. They delegate much of their authority to the Chief Executive Officer (CEO) but retain ultimate control.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      26,
      27,
      3,
      2,
      10
    ],
    "source": "801931 Assessment test"
  },
  {
    "id": 5,
    "question": "Brandon leads the information security team for a large organization and is working with the software development team to provide them with application security testing services. He would like to document the roles and responsibilities of the two teams in a written agreement with the leader of the development team. What type of agreement would be most appropriate?",
    "choice_a": "MOU",
    "choice_b": "SLA",
    "choice_c": "BPA",
    "choice_d": "MSA",
    "correct_answer": "A",
    "explanation": "In this case, Brandon needs an agreement with another internal organization. These types of agreements most commonly take the form of memoranda of understanding (MOU). More formal master service agreements (MSAs) and service level agreements (SLAs) are normally used with external service providers. Business partnership agreements (BPAs) are used when two organizations are entering into a joint effort.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      29,
      4,
      36,
      27,
      10
    ],
    "source": "801931 Assessment test"
  },
  {
    "id": 6,
    "question": "Monica is conducting a quantitative risk assessment of the risk that a fire poses to her organization’s primary operating facility. She believes that a serious fire would destroy 50 percent of the facility, causing $10 million in damage. She expects that a fire of this nature would only occur once every 50 years, on average. What is the AV in this scenario?",
    "choice_a": "$200,000",
    "choice_b": "$5 million",
    "choice_c": "$10 million",
    "choice_d": "$20 million",
    "correct_answer": "D",
    "explanation": "The asset value (AV) is the total value of the asset being analyzed. In this case, we know that the data center would be 50 percent destroyed by a fire and that the damage caused by the fire would be valued at $10 million. We can then work backward to determine that if $10 million is 50 percent of the asset value, then the asset value is $20 million.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      46,
      45,
      51,
      54,
      56
    ],
    "source": "801931 Assessment test"
  },
  {
    "id": 7,
    "question": "After assessing the risk of fire, Monica decides to install new sprinkler systems throughout the facility to reduce the likelihood of a serious fire. What type of risk treatment action is she taking?",
    "choice_a": "Risk avoidance",
    "choice_b": "Risk acceptance",
    "choice_c": "Risk transference",
    "choice_d": "Risk mitigation",
    "correct_answer": "D",
    "explanation": "Monica is seeking to reduce the likelihood and/or impact of a risk. Therefore, she is engaging in risk mitigation activity. Risk avoidance involves changing business practices to make a risk irrelevant. Risk acceptance involves continuing business activities in the face of a risk. Risk transference involves shifting some of the impact of a risk to a third party, such as an insurance company.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      50,
      51,
      52,
      53,
      54
    ],
    "source": "801931 Assessment test"
  },
  {
    "id": 8,
    "question": "Victor is a security consultant who was recently hired to perform a penetration test of an organization. He is not an employee but an independent contractor. He is reporting his findings directly to the CIO, and the security team is not aware of the work he is doing. What term best describes Victor’s work?",
    "choice_a": "White hat",
    "choice_b": "Gray hat",
    "choice_c": "Black hat",
    "choice_d": "Red hat",
    "correct_answer": "A",
    "explanation": "Victor is working as an authorized tester and, therefore, his work is definitely white-hat hacking. It is not relevant whether he is an employee or a contractor or what groups within the organization are aware of his testing. The only relevant factor is that he is performing authorized security testing on behalf of the organization. Gray-hat hackers perform similar work and report their results to the organization but do so without authorization. Black-hat hackers perform testing for malicious purposes. Red-hat hackers are not a common category of attacker.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      110,
      109,
      108,
      107,
      112
    ],
    "source": "801931 Assessment test"
  },
  {
    "id": 9,
    "question": "Peihua is working on the organizing documents for her organization’s cybersecurity program. Her document will outline the parameters under which the organization will function. What type of document is she creating?",
    "choice_a": "Charter",
    "choice_b": "Scope statement",
    "choice_c": "Business purpose statement",
    "choice_d": "Statement of authority",
    "correct_answer": "A",
    "explanation": "Peihua is drafting the organization’s security program charter. This is the organizing document for the program, and it outlines the parameters under which the program will function. This is a tricky question because the scope statement, business purpose statement, and statement of authority are all common elements of the charter.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      27,
      36,
      30,
      10,
      26
    ],
    "source": "801931 Assessment test"
  },
  {
    "id": 10,
    "question": "Fred is helping his boss develop a set of metrics for the organization’s security program. After consulting the ITIL framework used by his organization, he decides to track the number of major security incidents that occur each year. What type of metric is this?",
    "choice_a": "KGI",
    "choice_b": "KPI",
    "choice_c": "KSI",
    "choice_d": "KRI",
    "correct_answer": "B",
    "explanation": "This metric is directly out of the ITIL framework’s nine key performance indicators (KPIs) for a security program. KPIs are metrics that demonstrate the success of the program in achieving its objects and are a look at historical performance. Key goal indicators (KGIs) are similar but track progress toward a defined goal and there is no clear goal in this scenario. Key risk indicators (KRIs) look forward at risks that may jeopardize future security.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      81,
      83,
      40,
      79,
      80
    ],
    "source": "801931 Assessment test"
  },
  {
    "id": 11,
    "question": "Tim recently entered into an agreement with a service provider to perform weekly vulnerability scanning of his organization. The contract will last for three years. What type of expense best describes this purchase?",
    "choice_a": "Budgeted expense",
    "choice_b": "Nonbudgeted expense",
    "choice_c": "Capital expense",
    "choice_d": "Operational expense",
    "correct_answer": "D",
    "explanation": "There is no indication in the question of whether this expense is budgeted or nonbudgeted, so we can eliminate those two answer choices. Capital expenses are used to acquire and maintain large assets, whereas operational expenses cover day-to-day business costs. Tom is signing a services agreement and not purchasing an asset, so this agreement would best be classified as an operational expense.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      28,
      27,
      2,
      10,
      30
    ],
    "source": "801931 Assessment test"
  },
  {
    "id": 12,
    "question": "Carl is conducting a review of his system’s security. He is assuming that an attacker has already compromised the system and searching for signs of that compromise. What term best describes this work?",
    "choice_a": "Penetration testing",
    "choice_b": "Security assessment",
    "choice_c": "Threat hunting",
    "choice_d": "Black-box testing",
    "correct_answer": "C",
    "explanation": "Carl is conducting a security assessment, but that is not the best answer here because there is a more specific correct answer. The presumption of compromise is the hallmark of threat hunting, a type of security assessment.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      113,
      112,
      108,
      107,
      114
    ],
    "source": "801931 Assessment test"
  },
  {
    "id": 13,
    "question": "Lisa’s team is participating in a security exercise. They are testing the security of systems and attempting to break into systems controlled by others in the organization. What type of team is Lisa leading?",
    "choice_a": "Blue team",
    "choice_b": "White team",
    "choice_c": "Purple team",
    "choice_d": "Red team",
    "correct_answer": "D",
    "explanation": "During a security exercise, teams like Lisa’s who attempt to gain access to systems are classified as the red team. Blue team members are the defenders who secure systems from attack. White team members are observers and judges. Purple team events bring together members of the red and blue teams.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      84,
      85,
      114,
      112,
      79
    ],
    "source": "801931 Assessment test"
  },
  {
    "id": 14,
    "question": "Cindy is concerned that users in her organization might take sensitive data and email it to their personal email accounts for access after they leave the organization. Which one of the following security technologies would best protect against this risk?",
    "choice_a": "Firewall",
    "choice_b": "IPS",
    "choice_c": "DLP",
    "choice_d": "Configuration management",
    "correct_answer": "C",
    "explanation": "While it is possible that any security technology could play an indirect role in preventing the unauthorized exfiltration of information, data loss prevention (DLP) technology is specifically designed to protect against this threat, so that is the best possible answer to this question.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      116,
      64,
      63,
      77,
      79
    ],
    "source": "801931 Assessment test"
  },
  {
    "id": 15,
    "question": "Andrea is placing a new server onto her organization’s network. The server is a web server that will be accessible only by internal employees. What network zone would be the most appropriate location for this server?",
    "choice_a": "Internet",
    "choice_b": "Intranet",
    "choice_c": "Extranet",
    "choice_d": "DMZ",
    "correct_answer": "B",
    "explanation": "Servers intended for internal use should only be placed on the intranet, where they are accessible only to other internal systems. The DMZ would be an appropriate location for this server if it permitted public access. An extranet would be appropriate if the server was being accessed by business partners. The Internet is generally never a good location for a server.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      119,
      41,
      95,
      39,
      80
    ],
    "source": "801931 Assessment test"
  },
  {
    "id": 16,
    "question": "Matthew is responsible for managing the cloud infrastructure supporting his organization’s website. As demand for the site increases, Matthew would like to scale the infrastructure’s computing capability. Which one of the following is an example of horizontal scaling?",
    "choice_a": "Adding memory and processing power to the server",
    "choice_b": "Adding additional network bandwidth",
    "choice_c": "Adding additional servers",
    "choice_d": "Adding new load balancers",
    "correct_answer": "C",
    "explanation": "Any one of these solutions is an example of scaling the environment to meet increased demand. However, the question is specifically asking about computing capability. Adding computing capability requires modifying the servers, so we can eliminate the options about adding network bandwidth or load balancers. We’re also asking specifically about horizontal scaling, which is adding additional servers, making that our correct answer. Adding additional memory or processing power to the existing server would be vertical scaling.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      127,
      126,
      130,
      134,
      132
    ],
    "source": "801931 Assessment test"
  },
  {
    "id": 17,
    "question": "Danielle is revising her organization’s cybersecurity incident response plan and would like a consistent scale for rating the severity of an incident. What organization produces a widely used severity rating scale?",
    "choice_a": "NIST",
    "choice_b": "FBI",
    "choice_c": "NSA",
    "choice_d": "CIA",
    "correct_answer": "A",
    "explanation": "The National Institute for Standards and Technology (NIST) produces a widely used rating scale that categorizes security incidents based on the scope of their impact and the types of data involved.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      174,
      173,
      168,
      158,
      161
    ],
    "source": "801931 Assessment test"
  },
  {
    "id": 18,
    "question": "Ricky is collecting evidence as part of an investigation that his organization believes will lead to a civil lawsuit against one of their suppliers. What is the standard of evidence that would normally be applied in this type of lawsuit?",
    "choice_a": "Beyond a reasonable doubt",
    "choice_b": "Beyond the shadow of doubt",
    "choice_c": "Preponderance of the evidence",
    "choice_d": "Absolute proof",
    "correct_answer": "C",
    "explanation": "Most civil cases do not follow the beyond-a-reasonable-doubt standard of proof. Instead, they use the weaker <i>preponderance of the evidence </i>standard. Meeting this standard simply requires that the evidence demonstrate that the outcome of the case is more likely than not. For this reason, evidence collection standards for civil investigations are not as rigorous as those used in criminal investigations.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      37,
      27,
      26,
      29,
      22
    ],
    "source": "801931 Assessment test"
  },
  {
    "id": 19,
    "question": "Wally is assessing the controls used to protect his organization against the risk of data loss. Which one of the following controls would be the best defense against the accidental deletion of data by an authorized user?",
    "choice_a": "RAID 1",
    "choice_b": "RAID 5",
    "choice_c": "Backups",
    "choice_d": "Access controls",
    "correct_answer": "C",
    "explanation": "Backups allow the organization to recover data that was accidentally deleted. RAID technology is used to protect against the failure of a hard drive and would not protect against the loss of data by user action. Access controls would be effective to prevent an unauthorized user from deleting data but would not stop an authorized user from doing so.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      116,
      35,
      97,
      40,
      81
    ],
    "source": "801931 Assessment test"
  },
  {
    "id": 20,
    "question": "Melissa is preparing to test her organization’s disaster recovery plan. During the test, she will activate the organization’s backup processing facility and use it to process data as a test, but normal operations will continue in the primary facility. What type of test is she running?",
    "choice_a": "Parallel test",
    "choice_b": "Full interruption test",
    "choice_c": "Simulation test",
    "choice_d": "Structured walk-through",
    "correct_answer": "A",
    "explanation": "This type of test, where the alternate processing facility is activated but the primary site retains operational control, is known as a parallel test. In a full interruption test, the primary site is shut down and operational control moves to the alternate site. Simulations and structured walk-throughs do not affect normal operations and do not activate the alternate site.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      226,
      220,
      202,
      225,
      184
    ],
    "source": "801931 Assessment test"
  },
  {
    "id": 21,
    "question": "Norm is evaluating the security of his organization’s data centers and notices that there is a hole in the barbed wire fence protecting the facility. What type of control flaw has Norm identified?",
    "choice_a": "Detective",
    "choice_b": "Physical",
    "choice_c": "Corrective",
    "choice_d": "Compensating",
    "correct_answer": "B",
    "explanation": "A fence is an example of a physical control. Norm has identified a deficiency in a physical control that may be remediated by repairing the fence.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      40,
      125,
      42,
      79,
      81
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 22,
    "question": "When creating a process for information asset classification, the measures taken to protect assets should be proportional to their _____________.",
    "choice_a": "Vulnerability",
    "choice_b": "Size",
    "choice_c": "Creation cost",
    "choice_d": "Business value",
    "correct_answer": "D",
    "explanation": "When establishing a process for information asset classification, information security managers should design the process so that it ensures that measures taken to protect assets are proportional to their business value.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      63,
      40,
      32,
      77,
      80
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 23,
    "question": "Which of the following individuals are generally not responsible for preserving the chain of custody of evidence?",
    "choice_a": "Evidence technicians",
    "choice_b": "Police investigators",
    "choice_c": "Attorneys",
    "choice_d": "Court reporters",
    "correct_answer": "D",
    "explanation": "Police investigators, evidence technicians, attorneys, and anyone else involved in the collection, processing, analysis, and production of evidence must maintain the chain of custody. Court reporters generally do not handle evidence and are not subject to maintaining the chain of custody.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      163,
      178,
      179,
      169,
      182
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 24,
    "question": "Beth is the security administrator for a public school district. She is implementing a new student information system and is testing the code to ensure that students are not able to alter their own grades. What principle of information security is Beth enforcing?",
    "choice_a": "Denial",
    "choice_b": "Availability",
    "choice_c": "Confidentiality",
    "choice_d": "Integrity",
    "correct_answer": "D",
    "explanation": "Integrity controls, such as the one Beth is implementing in this example, are designed to prevent the unauthorized modification of information. Confidentiality controls are intended to protect information from unauthorized disclosure. Availability controls are intended to ensure that information remains accessible to authorized users and is not subject to denial attacks.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      136,
      150,
      140,
      40,
      32
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 25,
    "question": "Chris is worried that the laptops his organization has recently acquired were modified by a third party to include keyloggers before they were delivered. Where should he focus his efforts to prevent this?",
    "choice_a": "His vendor contracts",
    "choice_b": "His supply chain",
    "choice_c": "His post-purchase build process",
    "choice_d": "The original equipment manufacturer (OEM)",
    "correct_answer": "B",
    "explanation": "Supply chain management can help ensure the security of hardware, software, and services that an organization acquires. Chris should scrutinize each step that his laptops take from the original equipment manufacturer to delivery.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      90,
      91,
      32,
      77,
      80
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 26,
    "question": "Ryan is a security risk analyst for an insurance company. He is currently examining a scenario in which a malicious hacker might use a SQL injection attack to deface a web server due to a missing patch in the company’s web application. In this scenario, what is the threat?",
    "choice_a": "Malicious hacker",
    "choice_b": "Unpatched web application",
    "choice_c": "Web defacement",
    "choice_d": "Operating system",
    "correct_answer": "A",
    "explanation": "Risks are the combination of a threat and a vulnerability. Threats are the internal and external forces seeking to undermine security, such as the malicious hacker in this case. Vulnerabilities are the internal weaknesses that might allow a threat to succeed. In this case, the missing patch is the vulnerability. In this scenario, if the malicious hacker (threat) attempts a SQL injection attack against the unpatched server (vulnerability), the result could be website defacement.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      43,
      44,
      66,
      71,
      51
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 27,
    "question": "Frank is helping to develop a new chief information security officer (CISO) role at his organization, a health-care provider. He is trying to determine the appropriate reporting lines for this position. The organization recently suffered a security breach, and the board has directed that the CISO report to someone with as much relevant decision-making authority as possible. What would be the most common reporting relationship for a CISO?",
    "choice_a": "Reporting to the CFO",
    "choice_b": "Reporting to the CEO",
    "choice_c": "Reporting to the CIO",
    "choice_d": "Reporting to the COO",
    "correct_answer": "B",
    "explanation": "CISOs have many different reporting relationships and Frank should select one that is appropriate for the culture of his organization. While a common reporting relationship is for the CISO to report to the chief information officer (CIO), the board in this case has directed that the CISO report to the person with as much relevant decision-making as possible. Therefore the CISO should report to the chief executive officer (CEO).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      27,
      26,
      2,
      10
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 28,
    "question": "Which one of the following would not commonly be available as an IaaS service offering?",
    "choice_a": "Storage",
    "choice_b": "CRM",
    "choice_c": "Networking",
    "choice_d": "Computing",
    "correct_answer": "B",
    "explanation": "Customer relationship management (CRM) packages offered in the cloud would be classified as software-as-a-service (SaaS), since they are not infrastructure components. Storage, networking, and computing resources are all common IaaS offerings.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      128,
      129,
      131,
      134,
      126
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 29,
    "question": "Kim is designing a security awareness training program for her organization. What should be the primary goal of her efforts?",
    "choice_a": "To improve communications between the security team and other users",
    "choice_b": "To encourage the adoption of security technologies",
    "choice_c": "To reduce the likelihood of a security incident",
    "choice_d": "To increase awareness of security policy",
    "correct_answer": "C",
    "explanation": "The primary goal of the awareness program should be to reduce the likelihood and/or impact of a security incident. The awareness program may include efforts to increase awareness of security policy, improve communications, and increase adoption of security technologies, but the primary goal of the program should be to reduce the likelihood and impact of a security incident.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      84,
      81,
      83,
      77,
      80
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 30,
    "question": "Gary is the information security manager for a large corporation, and he has received a request from a business unit to waive a security control requirement. Which one of the following conditions would make Gary <i>most</i> comfortable with approving the request?",
    "choice_a": "Existence of a compensating control",
    "choice_b": "Small amount of money involved",
    "choice_c": "Statement from a senior executive that the waiver is important.",
    "choice_d": "Length of time the control will be missing",
    "correct_answer": "A",
    "explanation": "Compensating controls use alternative means to meet the same security objective and are important considerations when making exceptions to security control standards. Gary should take the needs of the business into account, but an executive assertion should not be sufficient to make him comfortable with the request. While financial implications are important to Gary’s decision, there are nonfinancial risks that waiving a security control could create. Gary should consider the length of time that the exception will be in place, but the fact that a waiver is needed only for a short period of time may not be sufficient to mitigate the risk.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      35,
      79,
      83,
      96,
      80
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 31,
    "question": "Which one of the following individuals is normally responsible for fulfilling the operational data protection responsibilities delegated by senior management, such as validating data integrity, testing backups, and enforcing security policies?",
    "choice_a": "Data owner",
    "choice_b": "Data custodian",
    "choice_c": "Data user",
    "choice_d": "Auditor",
    "correct_answer": "B",
    "explanation": "The data custodian role is assigned to an individual who is responsible for implementing the security controls defined by policy and senior management. The data owner does bear ultimate responsibility for these tasks, but the data owner is typically a senior leader who delegates operational responsibility to a data custodian.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      15,
      4,
      2,
      10,
      27
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 32,
    "question": "Susan is the lead investigator for a security incident and realizes that she will not be able to complete her investigation without causing severe disruption to the business. The action she feels she must take exceeds the authority granted to her under the incident response plan. What should Susan do?",
    "choice_a": "Consult with higher levels of management",
    "choice_b": "Discount the action as a possibility because it exceeds her authority",
    "choice_c": "Shut down all business operations immediately until she develops a plan",
    "choice_d": "Take the action immediately to protect the business",
    "correct_answer": "A",
    "explanation": "Susan should bring the decision to managers with the authority to authorize the activity and get their input. She should not take drastic actions on her own authority. She should only take actions that are based on a sound analysis and are within the scope of her authority.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      169,
      158,
      161,
      181,
      165
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 33,
    "question": "Which one of the following investigation types has the highest standard of evidence?",
    "choice_a": "Administrative",
    "choice_b": "Criminal",
    "choice_c": "Civil",
    "choice_d": "Regulatory",
    "correct_answer": "B",
    "explanation": "Criminal investigations may result in the imprisonment of individuals and, therefore, have the highest standard of evidence to protect the rights of the accused.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      175,
      177,
      178,
      179,
      182
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 34,
    "question": "Katie is planning to conduct a threat-hunting initiative and is building a database of common attack signatures that she will search for on her organization’s systems. What term best describes the type of information is Katie gathering?",
    "choice_a": "Vulnerability database",
    "choice_b": "Open source intelligence (OSINT)",
    "choice_c": "Indicators of compromise (IoC)",
    "choice_d": "Malware signatures",
    "correct_answer": "C",
    "explanation": "This question is a little tricky because several answers may be partially correct. Katie may be using open source intelligence (OSINT) sources to collect this information. She may also have information about vulnerabilities or malware signatures in her collection effort. However, the term that best describes this information is indicators of compromise (IoC). IoC may include information about malware and vulnerabilities, but it may also include other indicators, such as log entries or IP addresses. IoC may come from OSINT sources, but it may also come from proprietary sources.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      159,
      171,
      172,
      169,
      168
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 35,
    "question": "Tom enables an application firewall provided by his cloud infrastructure as a service provider that is designed to block many types of application attacks. When viewed from a risk management perspective, what metric is Tom attempting to lower by implementing this countermeasure?",
    "choice_a": "RPO",
    "choice_b": "MTO",
    "choice_c": "Impact",
    "choice_d": "Likelihood",
    "correct_answer": "D",
    "explanation": "Installing a device that will block attacks is an attempt to lower risk by reducing the likelihood of a successful application attack.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      51,
      45,
      50,
      54,
      43
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 36,
    "question": "Rebecca is a security manager for a subsidiary of a multinational corporation. The larger organization’s policy requires the use of two-factor authentication on all systems handling sensitive information, but a business case has arisen for disabling this control in one specific situation. What would be the best course of action for Rebecca?",
    "choice_a": "Remove the two-factor requirement if the business case justifies the action",
    "choice_b": "Refuse the request because it violates policy",
    "choice_c": "Escalate the issue to senior management",
    "choice_d": "Switch to a different two-factor mechanism",
    "correct_answer": "C",
    "explanation": "Rebecca should escalate the issue to senior management for resolution because it involves taking actions outside her scope of control. Changing systems is likely to be expensive and require management approval. There is also no evidence that this would resolve the situation. Rebecca does not have the authority to remove the two-factor requirement on her own since it comes from the parent corporation. Refusing the request outright is not sensitive to business needs and would likely alienate the requestor.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      50,
      52,
      56,
      57,
      49
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 37,
    "question": "Renee is responding to a cybersecurity incident at her organization where the attackers used a botnet to disrupt access to the organization’s website, preventing legitimate customers from placing orders. What type of attack took place?",
    "choice_a": "Integrity",
    "choice_b": "Destruction",
    "choice_c": "Alteration",
    "choice_d": "Denial",
    "correct_answer": "D",
    "explanation": "This is an example of a denial-of-service attack that disrupted the availability of the website for legitimate users.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      51,
      50,
      43,
      44,
      59
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 38,
    "question": "Which one of the following indicators suggests that a security standard may require modification?",
    "choice_a": "The standard contains information that conflicts with security procedures.",
    "choice_b": "An audit identified that many users are following practices that do not comply with the standard.",
    "choice_c": "An audit discovered a control gap on systems that fully implemented the standard.",
    "choice_d": "The standard contains information that conflicts with security guidelines.",
    "correct_answer": "C",
    "explanation": "Standards that do not achieve the organization’s control objectives should be modified to meet those objectives. Standards are of higher precedence than guidelines and procedures. If there is a conflict between the two, it most likely indicates that the guideline or procedure must be modified. If users are not complying with the standard, they should be educated on how to better meet their security responsibilities. This does not necessarily indicate needed change in the standard.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      32,
      80,
      81,
      35,
      84
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 39,
    "question": "Norm is conducting a penetration test and has gained access to an organization’s database server. He then creates a user account for himself on that system in the hope that he can use this account to access the system at a later date, even if the original exploit that he used is patched. What term best describes Norm’s activity?",
    "choice_a": "Lateral movement",
    "choice_b": "Persistence",
    "choice_c": "Maneuver",
    "choice_d": "Pivoting",
    "correct_answer": "B",
    "explanation": "Persistence includes any technique used to maintain access to a system, even after the attack is discovered. Norm is creating this user account for this purpose, so his activity is best described as persistence.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      69,
      67,
      70,
      66,
      43
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 40,
    "question": "Julie is developing a compensating control to help her organization mitigate the risk of downtime due to hardware failure. What control would best meet this need?",
    "choice_a": "Business interruption insurance",
    "choice_b": "Backups in a secure location",
    "choice_c": "Incident notification plan",
    "choice_d": "Fault-tolerant hardware",
    "correct_answer": "D",
    "explanation": "Fault-tolerant hardware will directly reduce the amount of downtime in the event of a hardware failure. Insurance may provide financial benefits in the event of a security incident but it will not reduce downtime. An incident notification plan may reduce the length of downtime, but this reduction is not likely to be significant. Backups will reduce the likelihood of data loss but will not likely have a significant impact on downtime.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      35,
      40,
      95,
      81,
      33
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 41,
    "question": "Which one of the following components of an organization’s information security program would you expect to contain the highest-level information?",
    "choice_a": "Security strategies",
    "choice_b": "Security guidelines",
    "choice_c": "Security policies",
    "choice_d": "Security standards",
    "correct_answer": "A",
    "explanation": "An information security governance program typically includes all of the crucial documents that define the organization’s security activities. Security strategies are the highest-level documents listed here, as they contain the overall vision for the program. The other documents listed here contain more detailed guidance.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      27,
      30,
      13,
      10,
      36
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 42,
    "question": "Andrea is reviewing a draft of the Domer Doodads information security policy and finds that it contains the statement below. Which one of these statements would be more appropriately placed in a different document?",
    "choice_a": "Domer Doodads considers cybersecurity and compliance to be of critical importance to the business.",
    "choice_b": "Domer Doodads designates the Chief Information Security Officer as the individual with primary responsibility for information security.",
    "choice_c": "The Chief Information Security Officer is granted the authority to create specific requirements that implement this policy.",
    "choice_d": "All access to financial systems must use multifactor authentication for remote connections.",
    "correct_answer": "D",
    "explanation": "It is normal to find statements in an information security policy that declare the importance of cybersecurity to the organization, designate a specific individual as responsible for the cybersecurity function, and grant that individual authority over cybersecurity. Specific requirements, such as requiring multifactor authentication for financial systems, would be more appropriately placed in a standard than a policy.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      32,
      79,
      77,
      80,
      83
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 43,
    "question": "Nora recently learned of a new cybersecurity threat facing her organization from a group of attackers exploiting buffer overflow vulnerabilities. She deployed a new set of rules on the organization’s web application firewall to block these attacks. What risk management strategy is Nora using?",
    "choice_a": "Risk mitigation",
    "choice_b": "Risk avoidance",
    "choice_c": "Risk acceptance",
    "choice_d": "Risk transference",
    "correct_answer": "A",
    "explanation": "Risk mitigation strategies take actions designed to reduce the likelihood and/or impact of a security threat. In this case, Nora deployed firewall rules that will attempt to block the attack, reducing their likelihood of success. Risk avoidance strategies seek to remove the source of the risk, such as removing the applications entirely. Risk acceptance acknowledges that the risk exists and takes no other action. Risk transference shifts some or all of the risk to a third party, such as an insurance carrier.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      50,
      51,
      52,
      49,
      56
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 44,
    "question": "Jeff is concerned about the effects that a ransomware attack might have on his organization and is designing a backup methodology that would allow the organization to quickly restore data after such an attack. What type of control is Jeff implementing?",
    "choice_a": "Preventive",
    "choice_b": "Corrective",
    "choice_c": "Detective",
    "choice_d": "Deterrent",
    "correct_answer": "B",
    "explanation": "Corrective controls remediate security issues that have already occurred. Restoring backups after a ransomware attack is an example of a corrective control.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      40,
      81,
      83,
      42,
      32
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 45,
    "question": "What is the most important rule to follow when collecting evidence?",
    "choice_a": "Transfer all equipment to a secure storage location.",
    "choice_b": "List all people present while collecting evidence.",
    "choice_c": "Do not turn off a computer until you photograph the screen.",
    "choice_d": "Avoid the modification of evidence during the collection process.",
    "correct_answer": "D",
    "explanation": "Although the other options have some merit in individual cases, the most important rule is to never modify, or taint, evidence. If you modify evidence, it may be questioned by opposing attorneys and may even become inadmissible in court.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      163,
      178,
      177,
      165,
      164
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 46,
    "question": "Tim is a senior executive at a financial services firm, and he would like to ensure that the organization’s cybersecurity program is functioning effectively. What would be the best indicator for him to use as a measure of the program’s effectiveness?",
    "choice_a": "Policies and procedures are documented",
    "choice_b": "Control objectives are met",
    "choice_c": "Incidents are resolved quickly",
    "choice_d": "Audits do not contain repeat findings",
    "correct_answer": "B",
    "explanation": "This is a difficult question because all of these items are indicators of a healthy information security program. However, if Tim wanted to select one measure, the best one would be whether the program is meeting the organization’s control objectives. These objectives are the goals of the security program and would provide Tim with a big picture view of effectiveness. The other measures listed all cover specific areas and would not provide the same level of holistic view.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      81,
      83,
      80,
      79,
      40
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 47,
    "question": "Tom is the information security manager for a Fortune 500 company. A business manager recently approached him and asked him to approve an exception to the organization’s security procedures so that a critical business process may complete before an urgent deadline. What should Tom do first?",
    "choice_a": "Deny the request because it violates the organization’s security procedures.",
    "choice_b": "Implement a compensating control.",
    "choice_c": "Conduct a risk assessment",
    "choice_d": "Approve an exception to the policy because the business need is urgent.",
    "correct_answer": "C",
    "explanation": "Tom should conduct a risk assessment of the situation that will determine whether compensating controls are appropriate. Tom should not approve an exception to the policy until after he conducts a risk assessment. Tom should not deny the request outright. He should perform a risk assessment and determine whether a compensating control is needed and possible. While Tom may end up deploying a compensating control, he should first conduct a risk assessment to guide the process.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      50,
      46,
      47,
      51,
      54
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 48,
    "question": "What pillar of information security describes the wholeness and completeness of information without unauthorized modifications?",
    "choice_a": "Nonrepudiation",
    "choice_b": "Integrity",
    "choice_c": "Availability",
    "choice_d": "Confidentiality",
    "correct_answer": "B",
    "explanation": "Integrity ensures the wholeness and completeness of information and that it is not altered without authorization. Confidentiality ensures that sensitive information is not disclosed without authorization. Availability ensures that information and systems are available to authorized users when needed. Nonrepudiation ensures that the sender of a message cannot later disclaim authorship.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      136,
      139,
      140,
      137,
      143
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 49,
    "question": "Gina is working with leaders in her organization to implement a new information security program and is looking for a document that will help guide her in selecting the most appropriate objectives. Which one of the following documents would best assist her?",
    "choice_a": "GAPP",
    "choice_b": "PCI DSS",
    "choice_c": "GLBA",
    "choice_d": "COBIT",
    "correct_answer": "D",
    "explanation": "Gina should use a framework to help guide the objectives for her program. Common frameworks for cybersecurity programs include the Control Objectives for Information Technology (COBIT) and ISO 27001. The Gramm–Leach–Bliley Act (GLBA) and the Payment Card Industry Data Security Standard (PCI DSS) are regulations affecting cybersecurity and should be addressed by the objectives but do not provide a comprehensive set of objectives. The Generally Accepted Privacy Principles (GAPP) are a framework for designing a privacy program, rather than a security program.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      38,
      22,
      13,
      10,
      12
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 50,
    "question": "Brian encountered a set of documents containing employee Social Security numbers and would like to replace those values with alternate values that are not sensitive but that may be restored using a lookup table. What type of data protection is Brian considering applying to this report?",
    "choice_a": "Tokenization",
    "choice_b": "Masking",
    "choice_c": "Hashing",
    "choice_d": "Encryption",
    "correct_answer": "A",
    "explanation": "Brian is considering replacing the Social Security numbers with tokens, using a tokenization technique. Masking would obscure portions of the numbers with alternate characters, such as Xs. Encryption and hashing would both apply algorithms to the values to convert them to non-sensitive values, but do not replace them with values that may be found in a lookup table, as tokenization does.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      64,
      62,
      63,
      35,
      32
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 51,
    "question": "What security control can be used to clearly communicate to users the level of protection required for different data types?",
    "choice_a": "Retention standards",
    "choice_b": "Classification policies",
    "choice_c": "Lifecycle practices",
    "choice_d": "Compensating controls",
    "correct_answer": "B",
    "explanation": "Classification policies create different categories of data used within an organization and then specify the level of security control required for each classification level. Using classifications helps users understand the type of protection necessary for each data type they encounter.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      63,
      32,
      79,
      77,
      35
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 52,
    "question": "Barbara is updating the information security policy for her organization and needs to have it approved, but she is unsure what the appropriate approval process is for this type of document. Where should she turn to determine the correct process?",
    "choice_a": "External auditors",
    "choice_b": "Program charter",
    "choice_c": "Internal auditors",
    "choice_d": "Help desk",
    "correct_answer": "B",
    "explanation": "Barbara should be able to find the policy approval process in her organization’s information security charter. While other team members, such as internal/external auditors and help desk staff, may have information about the process, they are not the authoritative source for this information.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      27,
      36,
      30,
      4,
      38
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 53,
    "question": "Brian would like to reduce the probability of a data breach that affects sensitive personal information. Which one of the following controls is most likely to achieve that objective?",
    "choice_a": "Installing a new firewall",
    "choice_b": "Limiting the purposes for which data may be used",
    "choice_c": "Purchasing cyber risk insurance",
    "choice_d": "Minimizing the amount of data retained and the number of places where it is stored",
    "correct_answer": "D",
    "explanation": "This question forces you to choose from several good options, as do many questions on the exam. We can rule out insurance because that does not alter the probability of a risk occurring. The remaining three options all do reduce the likelihood, but the best choice is minimizing the amount of data retained and the number of locations where it is stored, as this removes that data from the potential of a breach.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      64,
      62,
      63,
      40,
      81
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 54,
    "question": "What type of evidence must be authenticated by a witness who can uniquely identify it or through a documented chain of custody?",
    "choice_a": "Testimonial evidence",
    "choice_b": "Documentary evidence",
    "choice_c": "Real evidence",
    "choice_d": "Hearsay evidence",
    "correct_answer": "C",
    "explanation": "Real evidence must be either uniquely identified by a witness or authenticated through a documented chain of custody.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      177,
      178,
      179,
      163,
      182
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 55,
    "question": "What individual in an organization bears direct responsibility for ensuring the protection of business information through risk management, user education, control implementation, incident management, and related tasks?",
    "choice_a": "CIO",
    "choice_b": "Board chair",
    "choice_c": "President/CEO",
    "choice_d": "CISO",
    "correct_answer": "D",
    "explanation": "The chief information security officer (CISO) is the individual appointed by organization leadership to have direct responsibility for information security matters. While the president or CEO of an organization does bear responsibility for everything that occurs within the organization, they are not directly responsible for information security activities. The CIO certainly plays an important role in information security but does not have direct responsibility for security issues. The CISO may or may not report to the CIO depending on the organization’s structure. The board chairperson is responsible for ensuring the effective operation of the organization’s governing body. That body should have oversight over information security matters but does not bear direct responsibility for action.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      3,
      27,
      2,
      4,
      10
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 56,
    "question": "Which one of the following disaster recovery test types provides the most thorough assessment of an organization’s ability to recover operations in the event of a disaster?",
    "choice_a": "Full interruption test",
    "choice_b": "Parallel test",
    "choice_c": "Structured walk-through",
    "choice_d": "Checklist review",
    "correct_answer": "A",
    "explanation": "The full interruption test is the most effective way to test an organization’s disaster recovery capabilities because it simulates a real disaster. It is also the most dangerous type of test because it could disrupt operations if it fails. Parallel tests are a very effective test mechanism, but they are not as effective as full interruption tests. Structured walk-throughs provide the organization with important insight into their disaster recovery capabilities, but they are not as effective as full interruption or parallel tests. During a checklist review, individuals review their disaster recovery responsibilities and provide input on the plan, but they do not gain the real-world practical test results that you would gain from a parallel or full interruption test.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      226,
      225,
      228,
      221,
      222
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 57,
    "question": "What type of evidence refers to written documents that are brought into court to prove a fact?",
    "choice_a": "Testimonial evidence",
    "choice_b": "Best evidence",
    "choice_c": "Parol evidence",
    "choice_d": "Documentary evidence",
    "correct_answer": "D",
    "explanation": "Written documents brought into court to prove the facts of a case are referred to as documentary evidence. The best evidence rule states that when a document is used as evidence in a court proceeding, the original document must be introduced. The parol evidence rule states that when an agreement between parties is put into written form, the written document is assumed to contain all the terms of the agreement and no verbal agreements may modify the written agreement. Testimonial evidence is evidence consisting of the testimony of a witness, either verbal testimony in court or written testimony in a recorded deposition.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      177,
      176,
      178,
      179,
      163
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 58,
    "question": "Carla would like to “future proof” her organization’s security program against changes in the operating environment. As she performs this work, which of the following is <i>not</i> a common external influence that she should consider?",
    "choice_a": "Corporate policies",
    "choice_b": "Regulatory requirements",
    "choice_c": "Social media",
    "choice_d": "Emerging technologies",
    "correct_answer": "A",
    "explanation": "Carla should consider all of these items when assessing her organization’s preparedness for the future. However, the question asks about common external influences. Regulatory requirements, social media, and emerging technologies clearly fit into this category. Corporate policies, on the other hand, are an internal influence and would not be covered by this definition.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      14,
      11,
      27,
      16,
      12
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 59,
    "question": "Which one of the following is not one of the core goals of an information security program?",
    "choice_a": "Integrity",
    "choice_b": "Confidentiality",
    "choice_c": "Authorization",
    "choice_d": "Availability",
    "correct_answer": "C",
    "explanation": "Authorization ensures that individuals can perform approved actions but are not able to exceed their own authority. While it is a security concept, it is not one of the three core goals of information security: confidentiality, integrity, and availability.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      136,
      151,
      77,
      79,
      40
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 60,
    "question": "Harold conducts a review of his organization’s disaster recovery plan and realizes that the maximum tolerable outage for a service may be shorter than the organization can recover the service. What should he do next?",
    "choice_a": "Notify the organization’s board of directors.",
    "choice_b": "Conduct a business impact assessment.",
    "choice_c": "Develop a plan to meet the MTO.",
    "choice_d": "Change the MTO.",
    "correct_answer": "B",
    "explanation": "Harold should first conduct a business impact assessment to determine whether the MTO and recovery time values are accurate and the impact on the business. Harold should not change the MTO without input from stakeholders and a business impact assessment. He may wind up developing a plan to meet the MTO, but he should only do so after conducting a business impact assessment. Harold should not immediately jump to notifying executives but rather develop a plan to determine whether the MTO is appropriate and/or modifications to the disaster recovery plan can bring the plan into acceptable parameters.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      191,
      190,
      197,
      202,
      184
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 61,
    "question": "Which one of the following regulatory schemes introduces information security requirements specific to the handling of credit cards?",
    "choice_a": "FERPA",
    "choice_b": "SOX",
    "choice_c": "HIPAA",
    "choice_d": "PCI DSS",
    "correct_answer": "D",
    "explanation": "The Payment Card Industry Data Security Standard (PCI DSS) introduces security requirements for the handling of credit and debit card information and transactions. The Sarbanes–Oxley Act (SOX) introduces security requirements governing the accuracy of financial statements from publicly traded companies. The Health Insurance Portability and Accountability Act (HIPAA) introduces security requirements for the handling of protected health information. The Family Educational Rights and Privacy Act (FERPA) introduces security requirements for the handling of student educational records.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      21,
      22,
      14,
      9,
      19
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 62,
    "question": "Brad works for a government agency that uses a fiscal year beginning on October 1. He is planning for an expense that will occur on November 15, 2024. During what calendar and fiscal years will this expense take place?",
    "choice_a": "CY24 and FY25",
    "choice_b": "CY24 and FY24",
    "choice_c": "CY25 and FY24",
    "choice_d": "CY25 and FY25",
    "correct_answer": "A",
    "explanation": "Brad’s organization uses a fiscal year beginning on October 1. This means that the fiscal year will be one year ahead of the calendar year during the months July through December. November 2024 is a month during calendar year 2024 and, because it is after the fiscal year changes, fiscal year 2025.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      38
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 63,
    "question": "Gavin is creating a report to management on the results of his most recent risk assessment. In his report, he would like to identify the remaining level of risk to the organization after adopting security controls. What term best describes this current level of risk?",
    "choice_a": "Residual risk",
    "choice_b": "Inherent risk",
    "choice_c": "Control risk",
    "choice_d": "Mitigated risk",
    "correct_answer": "A",
    "explanation": "The residual risk is the level of risk that remains after controls have been applied to mitigate risks. Inherent risk is the original risk that existed prior to the controls. Control risk is new risk introduced by the addition of controls to the environment. Mitigated risk is the risk that has been addressed by existing controls.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      54,
      56,
      51,
      50,
      45
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 64,
    "question": "Brandon is developing a set of risk metrics that will identify how much risk exists that may jeopardize the future security of the organization. What type of metric is he creating?",
    "choice_a": "KPIs",
    "choice_b": "KGIs",
    "choice_c": "KRIs",
    "choice_d": "KMIs",
    "correct_answer": "C",
    "explanation": "Key risk indicators (KRIs) are measures that are intended to quantify the security risk facing an organization. KRIs, unlike KPIs and KGIs, are a look forward. They attempt to show how much risk exists that may jeopardize the future security of the organization. Key performance indicators (KPIs) are metrics that demonstrate the success of the security program in achieving its objectives. KPIs are mutually agreed-upon measures that evaluate whether a security program is meeting its defined goals. Generally speaking, KPIs are a look backwards at historical performance, providing a measuring stick to evaluate the past success of the program. Key goal indicators (KGIs) are similar to KPIs but measure progress toward defined goals. For example, if an organization has a goal to eliminate all stored social security numbers, a KGI might track the percentage of SSNs removed. KMIs are not a standard metric for cybersecurity programs.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      81,
      83,
      82,
      80,
      79
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 65,
    "question": "Yuri is the new security manager at a mid-sized financial institution. When he takes the job, he inherits a list of two hundred pending projects, each designed to mitigate threats to the institution. What two criteria should he use first to prioritize them?",
    "choice_a": "Likelihood and impact",
    "choice_b": "Sensitivity and likelihood",
    "choice_c": "Control type and sensitivity",
    "choice_d": "Impact and sensitivity",
    "correct_answer": "A",
    "explanation": "While an organization may include control type and/or sensitivity in their prioritization process, the two most important characteristics to include in a threat response analysis are likelihood and impact.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      45,
      46,
      50,
      43,
      54
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 66,
    "question": "Casey is having difficulty convincing senior-level management to invest in a data loss prevention system that she believes is essential to protecting the organization’s interests. Which one of the following approaches would best support her case?",
    "choice_a": "Obtaining support from members of her team",
    "choice_b": "Identifying a funding source for the system",
    "choice_c": "Documenting clear success criteria for the implementation",
    "choice_d": "Describing how the system supports broader organizational goals",
    "correct_answer": "D",
    "explanation": "While all of these options are important to the success of the initiative, the fundamental point here is that Casey is making the case to senior leadership. The most important thing she can do is to tie the system acquisition to broader organizational goals, explaining how the DLP system will enhance the organization’s ability to meet those goals.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      28,
      2,
      27,
      10,
      17
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 67,
    "question": "Which one of the following frameworks provides a formal process for implementing security controls that is mandatory for use in U.S. government agencies?",
    "choice_a": "NIST RMF",
    "choice_b": "NIST CSF",
    "choice_c": "COBIT",
    "choice_d": "ISO 27001",
    "correct_answer": "A",
    "explanation": "NIST publishes both the CSF and RMF, and it can be a little confusing to keep them straight. The RMF is a formal process for implementing security controls and authorizing system use, whereas the CSF provides a broad structure for cybersecurity controls. Compliance with the NIST RMF is mandatory for U.S. government agencies. COBIT and ISO 27001 may also provide important advice, but their use is not mandatory.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      12,
      38,
      22,
      27,
      37
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 501,
    "question": "Gwen is exploring a customer transaction reporting system and discovers the table shown below. What type of data minimization has most likely been used on this table?<br><img src=\"/question_assets/CISM/801931_Practice_Exam_1_image1.png\"/>",
    "choice_a": "Destruction",
    "choice_b": "Masking",
    "choice_c": "Tokenization",
    "choice_d": "Hashing",
    "correct_answer": "B",
    "explanation": "In this case, the first 12 digits of the credit card have been removed and replaced with asterisks. This is an example of data masking.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      64,
      62,
      63,
      136,
      137
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 69,
    "question": "Gary is a system administrator and is testifying in court about a cybercrime incident. He brings server logs to support his testimony. What type of evidence are the server logs?",
    "choice_a": "Real evidence",
    "choice_b": "Documentary evidence",
    "choice_c": "Parol evidence",
    "choice_d": "Testimonial evidence",
    "correct_answer": "B",
    "explanation": "Server logs are an example of documentary evidence. Gary may ask that they be introduced in court and will then be asked to offer testimonial evidence about how he collected and preserved the evidence. This testimonial evidence authenticates the documentary evidence.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      177,
      178,
      179,
      182,
      176
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 70,
    "question": "Which one of the following statements is not a core principle of a governance framework?",
    "choice_a": "A governance framework should be based on a conceptual model, identifying the key components and relationships among components, to maximize consistency and allow automation.",
    "choice_b": "A governance framework should be open and flexible. It should allow the addition of new content and the ability to address new issue in the most flexible way, while maintaining integrity and consistency.",
    "choice_c": "A governance framework should be developed by industry groups and then used without modification by corporations within those industries.",
    "choice_d": "A governance framework should align to relevant major related standards, frameworks, and regulations",
    "correct_answer": "C",
    "explanation": "ISACA defines three principles for governance frameworks. They are:<br>“A governance framework should be open and flexible. It should allow the addition of new content and the ability to address new issue in the most flexible way, while maintaining integrity and consistency.”<br>“A governance framework should be based upon a conceptual model, identifying the key components and relationships among components, to maximize consistency and allow automation.”<br>“A governance framework should align to relevant major related standards, frameworks, and regulations.”<br>Governance frameworks may be developed by industry groups, but they may also be adapted by individual organizations to meet their specific needs.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      38,
      27,
      10,
      12,
      37
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 71,
    "question": "Seth is an information security manager who is working with a business user to design a new business process that will require an exception to company policy. Who automatically has the authority to approve this exception?",
    "choice_a": "Seth, as information security manager",
    "choice_b": "The senior-most leader in the user’s functional area",
    "choice_c": "The user’s manager",
    "choice_d": "Policy approver",
    "correct_answer": "D",
    "explanation": "The policy approver has the implicit authority to approve exceptions to a policy unless the policy specifically removes that authority. Other managers or leaders do not automatically have the authority to grant exception to policy, although this authority may be explicitly granted to the manager by the policy or delegation from the policy approver.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      35,
      79,
      77,
      80,
      96
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 72,
    "question": "Harold would like to implement a security solution that allows him to correlate information from a variety of security systems and identify potential security events. Which technology best meets this need?",
    "choice_a": "IPS",
    "choice_b": "SIEM",
    "choice_c": "DLP",
    "choice_d": "NAC",
    "correct_answer": "B",
    "explanation": "Security information and event management (SIEM) solutions collect information from many different security tools and correlate them to identify potential incidents. Intrusion prevention systems (IPSs) typically operate on a single source of information, such as a network tap or operating system, and do not correlate information from multiple sources. Data loss prevention (DLP) systems monitor systems and/or networks for the unauthorized exfiltration of sensitive information but do not correlate security information from multiple sources. Network access control (NAC) systems are used to determine what devices may be granted access to a network based on an organization’s security policies.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      123,
      116,
      94,
      82,
      40
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 73,
    "question": "What two elements go into the determination of the degree of a risk posed by an event?",
    "choice_a": "Threat environment and probability",
    "choice_b": "Probability and likelihood",
    "choice_c": "Impact and consequence",
    "choice_d": "Probability and consequence",
    "correct_answer": "D",
    "explanation": "The degree of risk posed by an event is determined by the probability (the likelihood that an event will occur) and the consequence (the impact of the event).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      45,
      46,
      47,
      50,
      54
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 74,
    "question": "Which one of the following documents is the most critical output of a corporate governance process?",
    "choice_a": "Strategic plan",
    "choice_b": "Performance reviews",
    "choice_c": "Operational plan",
    "choice_d": "Audit procedures",
    "correct_answer": "A",
    "explanation": "Corporate governance programs ensure that the organization sets an appropriate strategic direction, develops a plan to implement that strategy, and then executes on its strategic plan. Therefore, the strategic plan is the most important deliverable of a corporate governance process.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      26,
      27,
      10,
      38,
      17
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 75,
    "question": "Gwen is encrypting sensitive information for transmission to her business partner, Thomas. She is using an asymmetric encryption algorithm. What key would she use to encrypt the message to ensure its confidentiality?",
    "choice_a": "Gwen’s public key",
    "choice_b": "Gwen’s private key",
    "choice_c": "Thomas’s public key",
    "choice_d": "Thomas’s private key",
    "correct_answer": "C",
    "explanation": "When using an asymmetric encryption algorithm to achieve confidentiality, the sender of a message encrypts the message using the recipient’s public key. The recipient then decrypts the message using their own private key. As the sender of the message, Gwen should encrypt the message with the recipient (Thomas)’s public key.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      138,
      136,
      141,
      143,
      139
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 76,
    "question": "Which of the following cloud computing models places the most security burden on the vendor and the least security burden on the customer?",
    "choice_a": "SaaS",
    "choice_b": "PaaS",
    "choice_c": "IaaS",
    "choice_d": "FaaS",
    "correct_answer": "A",
    "explanation": "In the software-as-a-service (SaaS) model, the greatest burden is placed on the vendor while the customer has little ability to modify security controls. In the platform-as-a-service (PaaS) model, the customer and vendor share security responsibilities fairly evenly. The vendor has less responsibility under this approach than under SaaS. In the infrastructure-as-a-service (IaaS) model, the customer bears significant responsibility for the secure configuration of computing resources. The function-as-a-service (FaaS) model is a subset of the PaaS model, and the customer bears significant responsibility for the secure development of code.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      128,
      131,
      130,
      126,
      135
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 77,
    "question": "Which one of the following measures the actions that lead to an organization achieving its primary strategic direction?",
    "choice_a": "KGI",
    "choice_b": "KPI",
    "choice_c": "KRI",
    "choice_d": "KSI",
    "correct_answer": "B",
    "explanation": "Key performance indicators (KPIs) are metrics that show how well an organization is achieving its strategic direction. Key goal indicators (KGIs) are metrics that show how well an organization is achieving its stated goals for a given operating period. Key risk indicators (KRIs) are metrics that show an organization’s capability for effectively managing risk. KSIs are not a type of metric used in corporate governance programs.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      81,
      82,
      83,
      77,
      79
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 78,
    "question": "Lila is the information security officer for her organization, and she is having an initial meeting with the human resources department to build a relationship between the two groups. Which one of the following HR processes is <i>most</i> important that Lila integrate with her security program?",
    "choice_a": "Employee termination",
    "choice_b": "Employee orientation",
    "choice_c": "Employee hiring",
    "choice_d": "Employee benefits",
    "correct_answer": "A",
    "explanation": "The most important process for Lila should be the employee termination procedure to ensure that employee access is cut off as soon as possible after a termination action.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      92,
      80,
      84,
      83,
      79
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 79,
    "question": "Ben is responsible for the security of payment card information stored in a database. Policy directs that he remove the information from the database, but he cannot do this for operational reasons. He obtained an exception to policy and is seeking an appropriate compensating control to mitigate the risk. What would be his best option?",
    "choice_a": "Encrypting the database contents",
    "choice_b": "Purchasing insurance",
    "choice_c": "Removing the data",
    "choice_d": "Objecting to the exception",
    "correct_answer": "A",
    "explanation": "Ben should encrypt the data to provide an additional layer of protection as a compensating control. The organization has already made a policy exception, so he should not react by objecting to the exception or removing the data without authorization. Purchasing insurance may transfer some of the risk but is not a mitigating control.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      50,
      51,
      54,
      53,
      52
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 80,
    "question": "Brian is developing the risk reporting program for his organization. Which one of the following statements is correct about risk reporting approaches?",
    "choice_a": "Risk reporting mechanisms should provide information only when the situation changes.",
    "choice_b": "Risk reporting mechanisms should use a strict schedule.",
    "choice_c": "Risk reporting mechanisms should provide a method for emergency updates.",
    "choice_d": "Risk reporting mechanisms should not specify communications intervals.",
    "correct_answer": "C",
    "explanation": "Information security managers should establish a regular reporting rhythm with periodic risk reports delivered at a regular frequency as well as a mechanism for rapidly providing urgent updates. In all cases, risk managers should write their reports with a strong understanding of their audience, tailoring the content to the knowledge, needs, and specific concerns of each target group.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      56,
      57,
      49,
      50,
      54
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 81,
    "question": "Which one of the following is not a purging activity?",
    "choice_a": "Cryptographic erasure",
    "choice_b": "Overwriting",
    "choice_c": "Block erase",
    "choice_d": "Resetting to factory state",
    "correct_answer": "D",
    "explanation": "Resetting a device to factory state is an example of a data clearing activity. Data purging activities include overwriting, block erase, and cryptographic erase activities when performed through the use of dedicated, standardized device commands.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      64,
      145,
      35,
      116,
      90
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 82,
    "question": "Paul is concerned that network devices in his organization may have exposed management interfaces. Which one of the following tests is most likely to discover this vulnerability?",
    "choice_a": "Dynamic application test",
    "choice_b": "Static application test",
    "choice_c": "Network vulnerability scan",
    "choice_d": "Web application scan",
    "correct_answer": "C",
    "explanation": "Exposed management interfaces are a standard test conducted during network vulnerability scans. Application testing of any kind is unlikely to discover this type of vulnerability.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      101,
      105,
      97,
      100,
      119
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 83,
    "question": "Vincent is working with a contractor on the design of a new cybersecurity system. His organization has worked with this vendor in the past and has a master services agreement (MSA) in place. What type of document should Vincent prepare to describe the work that will be done in this particular engagement?",
    "choice_a": "MOU",
    "choice_b": "NDA",
    "choice_c": "SOW",
    "choice_d": "Contract",
    "correct_answer": "C",
    "explanation": "Because a master services agreement is already in place, Vincent can simply write a statement of work (SOW) describing this project and referencing the existing MSA. It is not appropriate subject matter for a nondisclosure agreement (NDA) that focuses on confidentiality or a less formal vehicle, such as a memorandum of understanding (MOU). It is also not necessary to create a full contract, since the MSA is already in place providing formal contract language.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      29,
      30,
      36,
      27,
      2
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 84,
    "question": "Katie is helping her organization enter into a new consulting arrangement with a cybersecurity firm that will provide them with assistance on a series of upcoming projects. She would like to create an umbrella agreement that provides the general terms and then create engagement-specific documents that detail the deliverables for each project under that umbrella agreement. What term best describes the umbrella agreement?",
    "choice_a": "BPA",
    "choice_b": "SOW",
    "choice_c": "MSA",
    "choice_d": "MOU",
    "correct_answer": "C",
    "explanation": "Master service agreements (MSA) provide an umbrella contract for the work that a vendor does with an organization over an extended period of time. The MSA typically includes detailed security and privacy requirements. Each time the organization begins a new project with the vendor, they may then create a statement of work (SOW) that contains project-specific details and references the MSA. A memorandum of understanding (MOU) is a letter written to document aspects of the relationship. MOUs are an informal mechanism that allows the parties to document their relationship to avoid future misunderstandings. Business partnership agreements (BPAs) exist when two organizations agree to do business with each other in a partnership. For example, if two companies jointly develop and market a product, the BPA might specify each partner’s responsibilities and the division of profits.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      29,
      30,
      36,
      27,
      4
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 85,
    "question": "Which one of the following statements about project management is correct?",
    "choice_a": "Project managers should conduct an initial risk assessment and may then use that assessment for the duration of the project.",
    "choice_b": "Project management rarely results in changes to business practices.",
    "choice_c": "Project management procedures should incorporate ongoing risk assessments.",
    "choice_d": "Risk management should be treated as a one-time project.",
    "correct_answer": "C",
    "explanation": "Project management procedures should incorporate risk assessments that identify new or changed risks that arise during the course of a project and address them appropriately. Mature organizations don’t treat risk management efforts as siloed projects but rather as an integral component of their day-to-day work.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      57,
      49,
      50,
      51,
      56
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 86,
    "question": "What data minimization technique replaces personal identifiers with unique identifiers that may be cross-referenced with a lookup table?",
    "choice_a": "Tokenization",
    "choice_b": "Masking",
    "choice_c": "Hashing",
    "choice_d": "Salting",
    "correct_answer": "A",
    "explanation": "Tokenization replaces personal identifiers that might directly reveal an individual’s identity with a unique identifier using a lookup table. Hashing uses a cryptographic hash function to replace sensitive identifiers with an irreversible alternative identifier. Salting these values with a random number prior to hashing them makes these hashed values resistant to a type of attack known as a rainbow table attack.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      64,
      62,
      139,
      63,
      116
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 87,
    "question": "Which one of the phases of incident response involves primarily active undertakings designed to limit the damage that an attacker might cause?",
    "choice_a": "Post-incident activity",
    "choice_b": "Preparation",
    "choice_c": "Containment, eradication, and recovery",
    "choice_d": "Detection and analysis",
    "correct_answer": "C",
    "explanation": "The containment, eradication, and recovery phase of incident response includes active undertakings designed to minimize the damage caused by the incident and restore normal operations as quickly as possible.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      157,
      161,
      160,
      162,
      165
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 88,
    "question": "Brian is reviewing the integration of his organization’s existing business processes with the organization’s enterprise risk management program. Which one of the following processes is <i>least</i> likely to involve activities that may trigger new risk assessments?",
    "choice_a": "Procurement",
    "choice_b": "Project management",
    "choice_c": "Software development",
    "choice_d": "Order processing",
    "correct_answer": "D",
    "explanation": "The software/systems development, procurement, and project management functions are all involved in creating and modifying systems and processes. Therefore, they are very likely to trigger the need for a risk assessment. The order processing function typically conducts routine work that does not change business activity and would be less likely to generate the need for a risk assessment.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      57,
      49,
      50,
      45,
      59
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 89,
    "question": "What type of security awareness exercise always provides a real-world assessment of the likelihood that users will fall victim to social engineering attacks?",
    "choice_a": "Gamification",
    "choice_b": "Capture the flag",
    "choice_c": "Phishing simulation",
    "choice_d": "Role-based training",
    "correct_answer": "C",
    "explanation": "While any security awareness effort may include real-world assessments, phishing simulations are a direct implementation of this idea. They send fake phishing messages to users and those who click on the message are sent to a training program to help them better detect fraudulent messages. The simulation also allows the organization to measure how well prepared its users are to defend themselves against phishing attacks.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      84,
      83,
      81,
      82,
      80
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 90,
    "question": "Bill is designing an information security governance strategy for his organization. His primary objective is to choose a strategy that minimizes the variability in control implementation across the organization. Which governance strategy would best meet this goal?",
    "choice_a": "Hybrid",
    "choice_b": "Centralized",
    "choice_c": "Flexible",
    "choice_d": "Distributed",
    "correct_answer": "B",
    "explanation": "Centralized approaches to security governance provide a single authority for information security activities and minimize variation. Distributed approaches to information security governance allow shared responsibility across business units and offer flexibility, which results in some variability. A hybrid governance approach combines elements of centralized and distributed models and does not provide as much consistency as a pure centralized approach. Flexibility may be a desired characteristic of some governance models, but it is not a governance strategy in and of itself.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      27,
      38,
      4,
      36,
      12
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 91,
    "question": "Jane is trying to determine the appropriate level of security controls for a resource. What factor should she weight most heavily in her analysis?",
    "choice_a": "Asset classification",
    "choice_b": "Asset replacement cost",
    "choice_c": "Control cost",
    "choice_d": "Threat environment",
    "correct_answer": "A",
    "explanation": "The primary factor used in determining the appropriate level of security control for an asset is the asset’s classification. The threat environment, replacement cost, and control cost may be considered as well, but Jane should focus primarily on selecting controls appropriate to the asset classification.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      63,
      35,
      97,
      79,
      83
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 92,
    "question": "What is the primary purpose of an incident management program?",
    "choice_a": "To alert essential individuals when an incident occurs",
    "choice_b": "To identify and assess incidents and prevent their recurrence",
    "choice_c": "To designate an individual responsible for information security",
    "choice_d": "To conduct lessons learned sessions after incidents",
    "correct_answer": "B",
    "explanation": "The goal of an incident response program is to identify and assess incidents that occur and use that information to prevent future incidents. While many incident management programs do include lessons learned sessions, notification procedures, and responsibility designations, these are not their primary purpose.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      157,
      159,
      165,
      162,
      169
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 93,
    "question": "Ann is designing a transaction processing system and would like to implement a control that can ensure the authenticity of orders received from customers. Which one of the following controls would best meet her goal?",
    "choice_a": "Encryption",
    "choice_b": "Digital certificates",
    "choice_c": "Hashing",
    "choice_d": "Digital signatures",
    "correct_answer": "D",
    "explanation": "Digital signatures are used to achieve the goal of nonrepudiation and may be used to verify the authenticity of an order. Encryption may be used to ensure the confidentiality of transmissions, but it does not, by itself, provide a means of verifying the authenticity of the transaction. Hashing may be used as a component of verifying authenticity through a digital signature process, but it is not sufficient to confirm the authenticity of an order.<br>Digital certificates may be used to share the public keys used to verify digital signatures when checking the authenticity of an order, but they are not sufficient to verify an order’s authenticity by themselves.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      140,
      136,
      138,
      139,
      141
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 94,
    "question": "What is the major disadvantage to running intrusive vulnerability scans?",
    "choice_a": "Intrusive scans may disrupt production systems.",
    "choice_b": "Intrusive scans may jeopardize personal privacy.",
    "choice_c": "Intrusive scans require expensive scanning tools.",
    "choice_d": "Intrusive scans require manual configuration.",
    "correct_answer": "A",
    "explanation": "Some plug-ins perform tests that may actually disrupt activity on a production system or, in the worst case, damage content on those systems. These intrusive plug-ins are a tricky situation. Administrators want to run these scans because they may identify problems that could be exploited by a malicious source. At the same time, cybersecurity professionals clearly don’t want to cause problems on the organization’s network, and as a result, they may limit their scans to nonintrusive plug-ins. Intrusive scans do not pose any risk to personal privacy, and they do not require any tools or configuration not required for nonintrusive scans.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      99,
      100,
      104,
      35,
      114
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 95,
    "question": "Chris is concerned about the possibility that former employees will disclose sensitive personal information about customers to unauthorized individuals. What is the best mechanism that Chris can use to manage this risk?",
    "choice_a": "AUP",
    "choice_b": "NDA",
    "choice_c": "Privacy policy",
    "choice_d": "Data ownership policy",
    "correct_answer": "B",
    "explanation": "All of the mechanisms listed here may be used to protect private information. However, acceptable use policies, privacy policies, and data ownership policies are internal policies that would not be binding on former employees. To manage this risk, Chris’s organization should have all employees sign nondisclosure agreements (NDAs) that remain binding after the end of the employment relationship.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      29,
      36,
      30,
      19,
      9
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 96,
    "question": "Acme Widgets is a publicly traded corporation that recently experienced a major security breach. As a result, the company is considering disciplinary action against senior executives. Who would be the appropriate group to consider action against the chief executive officer (CEO), including termination of that individual?",
    "choice_a": "Board of directors",
    "choice_b": "Senior leadership committee",
    "choice_c": "Shareholders",
    "choice_d": "Government regulators",
    "correct_answer": "A",
    "explanation": "In a publicly traded corporation, the board of directors exercises oversight of the CEO. The directors are elected by the shareholders to represent their interests, as the shareholders are not able to exercise direct operational control of the organization. Government regulators may take action against the firm but would generally not be involved in any decision regarding termination of the CEO. Other senior leaders may consider actions against other employees but would not have the authority to discipline the CEO.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      26,
      27,
      2,
      4,
      36
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 97,
    "question": "What ISO standard provides guidance on risk management practices?",
    "choice_a": "ISO 27001",
    "choice_b": "ISO 31000",
    "choice_c": "ISO 27002",
    "choice_d": "ISO 27701",
    "correct_answer": "B",
    "explanation": "The International Organization for Standardization (ISO) publishes ISO 31000, covering risk management. ISO 27001 and 27002 cover cybersecurity, and ISO 27701 covers privacy controls.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      22,
      12,
      38,
      10,
      19
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 98,
    "question": "Which one of the following individuals is normally responsible for fulfilling the operational data protection responsibilities delegated by senior management, such as validating data integrity, testing backups, and managing security policies?",
    "choice_a": "Data subject",
    "choice_b": "Data owner",
    "choice_c": "Data custodian",
    "choice_d": "Data user",
    "correct_answer": "C",
    "explanation": "The data custodian role is assigned to an individual who is responsible for implementing the security controls defined by policy and senior management. The data owner does bear ultimate responsibility for these tasks, but the data owner is typically a senior leader who delegates operational responsibility to a data custodian.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      15,
      4,
      2,
      10,
      27
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 99,
    "question": "Carl’s organization is subject to PCI DSS. He determines that he will be unable to meet one of the PCI DSS objectives due to technical limitations and has obtained permission from his merchant bank to implement an alternative mechanism in place of the PCI DSS requirement. What type of control is Carl implementing?",
    "choice_a": "Detective",
    "choice_b": "Preventive",
    "choice_c": "Compensating",
    "choice_d": "Corrective",
    "correct_answer": "C",
    "explanation": "The scenario does not tell us whether the control is preventive, detective, or corrective. We do know, however, that it is being used in place of another control requirement that Carl’s organization is unable to meet and is, therefore, a compensating control.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      35,
      79,
      80,
      42,
      77
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 100,
    "question": "Tina recently completed a risk management review and identified that the organization is susceptible to a man-in-the-middle attack. After review with her manager, they jointly decided that accepting the risk is the most appropriate strategy. What should Tina do next?",
    "choice_a": "Repeat the business impact assessment.",
    "choice_b": "Implement additional security controls.",
    "choice_c": "Design a remediation plan.",
    "choice_d": "Document the decision.",
    "correct_answer": "D",
    "explanation": "After accepting a risk, the organization takes no action other than to document the risk as accepted. Implementing additional security controls or designing a remediation plan would not be risk acceptance but would instead fit into the category of risk mitigation. There is no need to repeat the business impact assessment.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      50,
      52,
      56,
      49,
      54
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 101,
    "question": "Tony purchases virtual machines from Microsoft Azure and acquires them exclusively for use by his organization. What model of cloud computing is this?",
    "choice_a": "Community cloud",
    "choice_b": "Private cloud",
    "choice_c": "Hybrid cloud",
    "choice_d": "Public cloud",
    "correct_answer": "D",
    "explanation": "This is an example of public cloud computing because Tony is using a public cloud provider, Microsoft Azure. The fact that Tony is limiting access to virtual machines to his own organization is not relevant because the determining factor for the cloud model is whether the underlying infrastructure is shared, not whether virtualized resources are shared.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      129,
      126,
      128,
      130,
      131
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 102,
    "question": "Terri is reviewing her organization’s cybersecurity program and conducting external research. During this work, she discovers that there is a new hacking group with advanced capabilities targeting organizations in her industry. How should she classify this group when she performs a SWOT analysis?",
    "choice_a": "Threat",
    "choice_b": "Strength",
    "choice_c": "Weakness",
    "choice_d": "Opportunity",
    "correct_answer": "A",
    "explanation": "Terri should realize that a hacking group is an external force, rather than an internal force, so it should be classified as either an opportunity or a threat. Additionally, the presence of this hacking group would have a potentially negative impact on the organization, so it is either a threat or a weakness. Combining these two facts identifies that the hacking group is a threat and should be placed into the threat quadrant of the SWOT analysis.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      44,
      43,
      56,
      66,
      73
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 103,
    "question": "Alice is responding to a cybersecurity incident and notices a system that she suspects is compromised. She places this system on a quarantine VLAN with limited access to other networked systems. What containment strategy is Alice pursuing?",
    "choice_a": "Segmentation",
    "choice_b": "Removal",
    "choice_c": "Isolation",
    "choice_d": "Eradication",
    "correct_answer": "A",
    "explanation": "In a segmentation approach, the suspect system is placed on a separate network where it has very limited access to other networked resources.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      160,
      167,
      161,
      157,
      168
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 104,
    "question": "Jen is conducting a penetration test against a nonprofit organization where she volunteers. She didn’t want to bother their small staff with the details of the test but plans to share any findings she has with leadership to help them improve their security. What term best describes this test?",
    "choice_a": "Blue hat",
    "choice_b": "White hat",
    "choice_c": "Black hat",
    "choice_d": "Gray hat",
    "correct_answer": "D",
    "explanation": "You might be tempted to answer “white hat” to this question because Jen has good intentions, but that is not sufficient to meet the criteria for a white-hat test. Jen does not have explicit permission to perform the test, so it is not a white-hat exercise. Instead, it is a gray-hat exercise, a test executed without permission but for benevolent purposes. A black-hat exercise has malicious intent, and blue-hat exercises do not exist.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      36,
      27,
      4,
      10,
      16
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 105,
    "question": "What term describes an organization’s willingness to tolerate risk within its environment?",
    "choice_a": "Risk appetite",
    "choice_b": "Residual risk",
    "choice_c": "Control risk",
    "choice_d": "Inherent risk",
    "correct_answer": "A",
    "explanation": "An organization’s <i>risk appetite</i> is its willingness to tolerate risk within the environment. If an organization is extremely risk averse, it may choose to conduct scans more frequently to minimize the amount of time between when a vulnerability comes into existence and when it is detected by a scan.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      54,
      98,
      50,
      51,
      45
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 106,
    "question": "Which one of the following requirements is the <i>most</i> important for an access control system?",
    "choice_a": "Providing single sign-on",
    "choice_b": "Integrating with security logging systems",
    "choice_c": "Implementing two-factor authentication",
    "choice_d": "Preventing unauthorized access",
    "correct_answer": "D",
    "explanation": "The core requirement of any access control system is that it must prevent unauthorized access. Single sign-on technology is a major convenience for users but is less important than meeting the basic requirement of preventing unauthorized access. Two-factor authentication is an important security control for high-risk assets, but it is less important than meeting the basic requirement of preventing unauthorized access. Integration with security logging systems is an important requirement for access control systems, but it is less important than meeting the basic requirement of preventing unauthorized access.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      151,
      93,
      155,
      154,
      94
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 107,
    "question": "Don created a budget for his information security program and obtained funding from leadership. During the year, expenses fluctuate so that they do not directly align with the budget. When Don reports his final financial results, which one of the following situations would be the best for Don’s organization?",
    "choice_a": "The program is significantly over budget.",
    "choice_b": "The program is slightly over budget.",
    "choice_c": "The program is slightly under budget.",
    "choice_d": "The program is significantly under budget.",
    "correct_answer": "C",
    "explanation": "The best-case scenario is that expenses are close to the budgeted amount but do not exceed the actual budget. Budget overages are difficult because funds may not be available to cover all expenses. When expenses are significantly under budget, the organization suffers an opportunity cost because those funds could have been used for other purposes or returned to shareholders as profit.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      10,
      2,
      27,
      13
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 108,
    "question": "Ben wants to provide predictive information about his organization’s risk exposure in an automated way as part of an ongoing organizational risk management plan. What should he use to do this?",
    "choice_a": "Quantitative risk assessments",
    "choice_b": "KRIs",
    "choice_c": "KPIs",
    "choice_d": "Penetration tests",
    "correct_answer": "B",
    "explanation": "Key risk indicators (KRIs) are often used to monitor risk for organizations that establish an ongoing risk management program. Using automated data gathering and tools that allow data to be digested and summarized can provide predictive information about how organizational risks are changing. KPIs are key performance indicators, which are used to assess how an organization is performing. Quantitative risk assessments are good for point-in-time views with detailed valuation and measurement-based risk assessments, whereas a penetration test would provide details of how well an organization’s security controls are working.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      49,
      45,
      46,
      50,
      56
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 109,
    "question": "Juan is a forensic investigator collecting evidence that may be used in an upcoming criminal trial. Which one of the following concerns should be Juan’s highest priority?",
    "choice_a": "Preserving the chain of custody",
    "choice_b": "Proving Juan’s expertise",
    "choice_c": "Filming all evidence collection",
    "choice_d": "Using write blockers to collect evidence",
    "correct_answer": "A",
    "explanation": "The chain of custody requires that Juan be able to clearly document every change in control of the evidence from the time it is collected until it is presented at trial. Evidence may be thrown out if there is any question about the chain of custody. While Juan may be asked about his expertise at trial, it is more important to preserve the chain of custody for the evidence. While some investigators may choose to film their collection of evidence, this is not a requirement and is not as important as preserving the chain of custody. Although many forensic investigators do use write-blockers as a safety mechanism while collecting evidence, their use is not a requirement and is not as important as preserving the chain of custody.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      163,
      178,
      179,
      182,
      177
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 110,
    "question": "Gary discovers that his organization is storing some old files in a cloud service that are exposed to the world. He deletes those files. What type of risk management strategy is this?",
    "choice_a": "Risk mitigation",
    "choice_b": "Risk acceptance",
    "choice_c": "Risk avoidance",
    "choice_d": "Risk transference",
    "correct_answer": "C",
    "explanation": "Gary is changing business practices to eliminate the risk entirely. This is, therefore, an example of risk avoidance.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      50,
      52,
      51,
      53,
      54
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 111,
    "question": "What type of application testing analyzes code while a tester manipulates inputs to the application?",
    "choice_a": "Static testing",
    "choice_b": "Dynamic testing",
    "choice_c": "Interactive testing",
    "choice_d": "Footprinting",
    "correct_answer": "C",
    "explanation": "Interactive testing combines static and dynamic analysis, performing static code analysis while the attacker interacts with application inputs. Static analysis analyzes code but does not manipulate inputs. Dynamic analysis manipulates inputs without performing code analysis. Footprinting is a network reconnaissance technique and not an application testing technique.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      150,
      109,
      107,
      112,
      148
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 112,
    "question": "Helen designed a new payroll system that she offers to her customers. She hosts the payroll system in AWS and her customers access it through the web. What tier of cloud computing best describes Helen’s service?",
    "choice_a": "SaaS",
    "choice_b": "PaaS",
    "choice_c": "FaaS",
    "choice_d": "IaaS",
    "correct_answer": "A",
    "explanation": "Helen is using IaaS services to create her payroll product. She is then offering that payroll service to her customers as an SaaS solution.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      128,
      129,
      130,
      131,
      134
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 113,
    "question": "David is an IT professional responsible for applying, monitoring, and maintaining access controls to a filesystem containing sensitive information used by the human resources department. He works closely with the management of that department to identify appropriate permissions. What term best describes David’s role in relation to this data?",
    "choice_a": "Data custodian",
    "choice_b": "Data steward",
    "choice_c": "Data owner",
    "choice_d": "Data subject",
    "correct_answer": "A",
    "explanation": "Data custodians, or data processors, are the individuals who actually store and process sensitive information. As an IT professional implementing the directions of the data owners and stewards in the HR department, David is a data custodian. Data subjects are the individuals referred to in these records. Technically, David may also be a data subject because he is likely an employee of the organization and would be in the HR database. However, the question is asking for the role that <i>best</i> describes David, which is his primary role as the data custodian for the entire dataset rather than the incidental fact that he is one of many data subjects described in the records.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      15,
      4,
      9,
      2,
      27
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 114,
    "question": "Belinda is attempting to determine the RPO for a database server that she administers. Which piece of information will best help her determine this value?",
    "choice_a": "The amount of time required to recover a service.",
    "choice_b": "The cost to recover a service",
    "choice_c": "The amount of time that a service may be down",
    "choice_d": "The amount of data loss that the organization considers acceptable",
    "correct_answer": "D",
    "explanation": "The recovery point objective (RPO) is based on the amount of data loss that the organization considers acceptable in the event of a disaster, not the amount of time that a service may be down, the amount of time required to recover a service, or the cost to recover a service.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      191,
      184,
      193,
      201,
      194
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 115,
    "question": "Which one of the following is not a common use of formal incident reports?",
    "choice_a": "Assisting with legal action",
    "choice_b": "Training new team members",
    "choice_c": "Developing new security controls",
    "choice_d": "Sharing with other organizations",
    "correct_answer": "D",
    "explanation": "There are many potential uses for written incident reports. First, it creates an institutional memory of the incident that is useful when developing new security controls and training new security team members. Second, it may serve as an important record of the incident if there is ever legal action that results from the incident. These reports should be classified and not disclosed to external parties.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      166,
      168,
      157,
      183,
      175
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 116,
    "question": "Bev is developing a risk management strategy for the effects of a cybersecurity incident on her organization. She chooses to purchase an insurance policy to cover the financial risks. What risk management strategy is Bev pursuing?",
    "choice_a": "Risk mitigation",
    "choice_b": "Risk avoidance",
    "choice_c": "Risk acceptance",
    "choice_d": "Risk transference",
    "correct_answer": "D",
    "explanation": "Purchasing an insurance policy transfers some of the risk to a third party, the insurance company. This is an example of a risk transference approach.<br>Risk mitigation actions reduce the likelihood and/or impact of a risk if it occurs. Purchasing insurance does not reduce either the likelihood or impact, but it does transfer some of the risk to a third party.<br>Risk acceptance involves a business decision to take no action in response to a risk. Purchasing insurance is an action, so this is not an example of risk acceptance.<br>Risk avoidance alters business operations to eliminate a risk. There is no indication that Bev is changing any business operations, so this is not an example of risk avoidance.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      50,
      53,
      51,
      52,
      54
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 117,
    "question": "Ruth is reviewing her organization’s business continuity and disaster recovery plans. In it, she comes across the following statement: “In the event that the payroll system fails, the IT team must restore access within 48 hours to avoid unacceptable levels of damage to the business.” What type of statement is this?",
    "choice_a": "RTO",
    "choice_b": "RPO",
    "choice_c": "MTA",
    "choice_d": "SLA",
    "correct_answer": "A",
    "explanation": "The recovery time objective (RTO) is the amount of time that may elapse between when a system fails and when it is recovered before causing substantial harm to the business. The recovery point objective (RPO) is the amount of acceptable data loss in the event of a disaster, expressed as the period of time from which data may be lost. The service level agreement (SLA) is an agreement between a vendor and a customer regarding technology services. Mail transfer agents (MTAs) are a component of email infrastructure and are not related to disaster recovery.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      191,
      197,
      185,
      201,
      184
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 118,
    "question": "Which one of the following tools may be used to isolate an attacker so that they may not cause damage to production systems but may still be observed by cybersecurity analysts?",
    "choice_a": "DLP",
    "choice_b": "Playpen",
    "choice_c": "IDS",
    "choice_d": "Sandbox",
    "correct_answer": "D",
    "explanation": "Sandboxes are isolation tools used to contain attackers within an environment where they believe they are conducting an attack but, in reality, are operating in a benign environment.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      160,
      167,
      157,
      162,
      168
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 119,
    "question": "Betty is preparing to publish a new information security policy for her organization and is drafting an email message announcing the new policy and informing employees about their responsibilities. Who would be the most effective signatory for the message?",
    "choice_a": "CISO",
    "choice_b": "President/CEO",
    "choice_c": "CIO",
    "choice_d": "Policy administrator",
    "correct_answer": "B",
    "explanation": "The president or CEO is the senior-most person within an organization and has both name recognition and authority that lends credibility to the message. While the CISO bears ultimate responsibility for security, it is likely that most of the organization does not know them, making the CISO a less desirable choice for signing the message. The CIO is a senior executive who might sign the message, but it would be more effective if it originated from the president/CEO. Policy administrators are not well known throughout an organization and typically have very little authority, making them a poor choice for sending out the announcement.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      26,
      2,
      27,
      36,
      17
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 120,
    "question": "What phase of the Electronic Discovery Reference Model examines information to remove information subject to attorney-client privilege?",
    "choice_a": "Collection",
    "choice_b": "Processing",
    "choice_c": "Review",
    "choice_d": "Identification",
    "correct_answer": "C",
    "explanation": "Review examines the information resulting from the Processing phase to determine what information is responsive to the request and remove any information protected by attorney-client privilege. Identification locates the information that may be responsive to a discovery request when the organization believes that litigation is likely. Collection gathers the relevant information centrally for use in the eDiscovery process. Processing screens the collected information to perform a “rough cut” of irrelevant information, reducing the amount of information requiring detailed screening.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      37,
      37
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 121,
    "question": "Alan is concerned about the risk posed by attackers exploiting flaws in his organization’s web applications to gain access to the underlying database through a SQL injection attack. What would be the most effective control in this scenario?",
    "choice_a": "Performing input validation",
    "choice_b": "Installing a host firewall",
    "choice_c": "Installing a network firewall",
    "choice_d": "Patching the web server",
    "correct_answer": "A",
    "explanation": "Input validation limits the types of information that users may submit to the web application and can strip out SQL injection attacks before they are executed. Web server patches are an important security control, but they will affect the application’s access to the database. Network firewalls are an important security control, but they do not perform application filtering and would not be effective against a SQL injection attack. Host firewalls are important security controls, but they cannot identify SQL injection attacks.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      134,
      101,
      145,
      35,
      104
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 502,
    "question": "Lou mounted the sign below on the fence surrounding his organization’s datacenter. What control type best describes this control?<br><img src=\"/question_assets/CISM/801931_Practice_Exam_1_image2.png\"/>",
    "choice_a": "Deterrent",
    "choice_b": "Compensating",
    "choice_c": "Detective",
    "choice_d": "Physical",
    "correct_answer": "A",
    "explanation": "This question is a little tricky. The use of an actual guard dog could be considered a deterrent, physical, or detective control. It could even be a compensating control in some circumstances. However, the question asks about the presence of a sign and does not state that an actual dog is used. The sign only has value as a deterrent control. Be careful when facing exam questions like this to read the details of the question.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      35,
      40,
      79,
      81,
      42
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 123,
    "question": "Kevin is attempting to determine whether he can destroy a cache of old records that he discovered. What type of policy would most directly answer his question?",
    "choice_a": "Data ownership",
    "choice_b": "Data retention",
    "choice_c": "Data classification",
    "choice_d": "Data minimization",
    "correct_answer": "B",
    "explanation": "The most relevant policy here is the organization’s data retention policy, which should outline the standards for keeping records before destruction or disposal.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      64,
      63,
      40,
      79,
      35
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 124,
    "question": "What step of the Electronic Discovery Reference Model ensures that information that may be subject to discovery is not altered?",
    "choice_a": "Production",
    "choice_b": "Processing",
    "choice_c": "Preservation",
    "choice_d": "Presentation",
    "correct_answer": "C",
    "explanation": "Preservation ensures that potentially discoverable information is protected against alteration or deletion. Production places the information into a format that may be shared with others and delivers it to other parties, such as opposing counsel. Processing screens the collected information to perform a “rough cut” of irrelevant information, reducing the amount of information requiring detailed screening. Presentation displays the information to witnesses, the court, and other parties.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      37,
      6,
      19,
      25,
      24
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 125,
    "question": "Sean is developing a new information security policy for his organization. Which of the following statements is correct about the type of input he should solicit?",
    "choice_a": "Sean should gather input from all employees of his organization.",
    "choice_b": "Sean should only gather input from members of his own team.",
    "choice_c": "Sean only needs to gather input from senior leaders.",
    "choice_d": "Sean should gather input from all affected stakeholders",
    "correct_answer": "D",
    "explanation": "Sean should obtain input from a broad group of people, but only from relevant stakeholders. He doesn’t necessarily need to follow the advice he receives from everyone, but everyone who will be a stakeholder should feel that their input was solicited and heard during the process.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      36,
      27,
      4,
      2,
      31
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 126,
    "question": "Elise is helping her organization prepare to evaluate and adopt a new cloud-based human resource management (HRM) system vendor. What would be the most appropriate minimum security standard for her to require of possible vendors?",
    "choice_a": "Compliance with all laws and regulations",
    "choice_b": "Handling information in the same manner the organization would",
    "choice_c": "Compliance with the vendor’s own policies",
    "choice_d": "Elimination of all identified security risks",
    "correct_answer": "B",
    "explanation": "The most appropriate standard to use as a baseline when evaluating vendors is to determine whether the vendor’s security controls meet the organization’s own standards. Compliance with laws and regulations should be included in that requirement and are a necessary, but not sufficient, condition for working with the vendor. Vendor compliance with their own policies also fits into the category of necessary, but not sufficient, controls, as the vendor’s policy may be weaker than the organization’s own requirements. The elimination of all identified security risks is an impossible requirement for a potential vendor to meet.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      90,
      91,
      77,
      79,
      40
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 127,
    "question": "Linda is conducting a SWOT analysis of her organization’s information security program. She discovers that the organization does not have appropriate procedures in place to monitor and update firewall configurations. How should she classify this situation in her analysis?",
    "choice_a": "Threat",
    "choice_b": "Strength",
    "choice_c": "Opportunity",
    "choice_d": "Weakness",
    "correct_answer": "D",
    "explanation": "The firewall is a control operated by the organization, so this is an internal issue and would thus be classified as a strength or weakness. Opportunities and threats are external forces. The lack of configuration controls is a negative factor, so it is a weakness, rather than a strength.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      44,
      55,
      54,
      51,
      50
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 128,
    "question": "Jen is conducting a penetration test for a client. The client did not provide her with any details about their systems in advance of the test and Jen is determining this information using reconnaissance techniques. What type of test is Jen performing?",
    "choice_a": "White box",
    "choice_b": "Black box",
    "choice_c": "Gray box",
    "choice_d": "Blue box",
    "correct_answer": "B",
    "explanation": "Black-box tests are intended to replicate what an attacker would encounter. Testers are not provided with access to or information about an environment, and instead, they must gather information, discover vulnerabilities, and make their way through an infrastructure or systems like an attacker would. White-box tests are performed with full knowledge of the underlying technology, configurations, and settings that make up the target. Gray-box tests are a blend of black-box and white-box testing. Blue-box tests are not a type of penetration test.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      109,
      111,
      107,
      110,
      108
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 129,
    "question": "Morgan is configuring a new alarm system to protect her organization’s data center from physical intrusions. What type of control is she configuring?",
    "choice_a": "Detective",
    "choice_b": "Preventive",
    "choice_c": "Corrective",
    "choice_d": "Deterrent",
    "correct_answer": "A",
    "explanation": "This is an example of a detective control—one that identifies attacks that are in progress, such as a physical intrusion. Preventive controls seek to stop an attack from occurring in the first place. Corrective controls attempt to restore normal operations after an incident takes place. Deterrent controls seek to prevent attackers from attempting an attack.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      40,
      35,
      118,
      125,
      42
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 130,
    "question": "Gary is collecting evidence from the hard drive of a system that was involved in a security incident. What technology may Gary use to later demonstrate that the evidence was not tampered with after collection?",
    "choice_a": "Hash value",
    "choice_b": "Write blocker",
    "choice_c": "Digital certificate",
    "choice_d": "Backup",
    "correct_answer": "A",
    "explanation": "Hashes create a digital fingerprint of the evidence that may later be compared to the current version to demonstrate that no changes were made. Write blockers will prevent the alteration of evidence but do not provide a means to demonstrate to others that the evidence was not altered. Digital certificates are used to communicate public encryption keys and would not be useful in this scenario. Backups may serve as a source of evidence, but they do not provide the evidence that Gary needs.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      179,
      182,
      163,
      178,
      161
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 131,
    "question": "Ben is responding to a security incident and determines that the attacker is using systems on Ben’s network to attack a third party. Which one of the following containment approaches will prevent Ben’s systems from being used in this manner?",
    "choice_a": "Detection",
    "choice_b": "Isolation",
    "choice_c": "Removal",
    "choice_d": "Segmentation",
    "correct_answer": "C",
    "explanation": "Only removal of the compromised system from the network will stop the attack against other systems. Isolated and/or segmented systems are still permitted access to the Internet and could continue their attack. Detection is a purely passive activity that does not disrupt the attacker at all.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      160,
      161,
      157,
      162,
      159
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 132,
    "question": "Harold is the chief information security officer for his company. He is working on the resource requirements for his efforts. Where should those resource requirements be listed?",
    "choice_a": "Security team roster",
    "choice_b": "Security policy",
    "choice_c": "Security procedures",
    "choice_d": "Security strategy",
    "correct_answer": "D",
    "explanation": "The security strategy should include detailed resource requirements needed to implement the security strategy. Security policies should contain guiding principles for the security program and would not contain resource requirements. Security procedures should contain step-by-step instructions for security processes and would not include resource requirements. The security team roster would contain a listing of employees and is not the appropriate location for resource requirements.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      10,
      30,
      27,
      17
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 133,
    "question": "Kira would like to implement a security control that can implement access restrictions across all of the SaaS solutions used by her organization. What control would best meet her needs?",
    "choice_a": "CASB",
    "choice_b": "SWG",
    "choice_c": "Security group",
    "choice_d": "Resource policy",
    "correct_answer": "A",
    "explanation": "Cloud access security brokers (CASBs) are designed specifically for this situation: enforcing security controls across cloud providers. A secure web gateway (SWG) may be able to achieve Kira’s goal, but it would be more difficult to do so. Security groups and resource policies are controls used in IaaS environments.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      133,
      128,
      130,
      131,
      134
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 134,
    "question": "Brooke is a cybersecurity professional for a financial services firm. In her role, she is responsible for building and maintaining an inventory of the sensitive information used by the firm. Which one of the following categories of information is she <i>least</i> likely to encounter?",
    "choice_a": "PCI",
    "choice_b": "PII",
    "choice_c": "PHI",
    "choice_d": "Customer information",
    "correct_answer": "C",
    "explanation": "Financial firms are not likely to encounter protected health information (PHI), which are the HIPAA-regulated medical records maintained by health-care providers and other HIPAA-covered entities. They are quite likely to have personally identifiable information (PII), payment card information (PCI), and other customer-related information.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      62,
      63,
      64,
      116,
      90
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 135,
    "question": "Phil is investigating a security incident where the attackers shut down his organization’s database server. They do not appear to have actually gained access to the system, but they have shut it down using some type of remote exploit. What principle of cybersecurity was most directly violated during this incident?",
    "choice_a": "Confidentiality",
    "choice_b": "Availability",
    "choice_c": "Nonrepudiation",
    "choice_d": "Integrity",
    "correct_answer": "B",
    "explanation": "This is an example of an availability breach. By shutting down the database server, the attackers were able to deny authorized users access to the server.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      43,
      51,
      50,
      59,
      45
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 136,
    "question": "Seth works in an organization that uses a rigid hierarchical management structure. He frequently encounters the CIO in the hallway and engages her in conversation and considers her a friendly acquaintance. The CIO is Seth’s third-level supervisor. Seth has an idea for a new cybersecurity initiative. What would be the best way for Seth to gain approval for his idea?",
    "choice_a": "Schedule a meeting with the CIO, his direct supervisor, and the manager who sits between them to propose the idea",
    "choice_b": "Informally discuss the idea with the CIO during a chance encounter",
    "choice_c": "Schedule a meeting with the CIO and his direct supervisor to propose the idea",
    "choice_d": "Informally discuss the idea with his direct supervisor.",
    "correct_answer": "D",
    "explanation": "In a hierarchical organization, Seth should follow the chain-of-command. In this case, that means he should bring the idea to his direct supervisor before engaging anyone else in the organization, whether formally or informally.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      26,
      27,
      4,
      10,
      2
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 137,
    "question": "Which one of the following software development models focuses on the early and continuous delivery of software?",
    "choice_a": "Waterfall",
    "choice_b": "Agile",
    "choice_c": "Spiral",
    "choice_d": "Butterfly",
    "correct_answer": "B",
    "explanation": "One of the core principles of the Agile approach to software development is to ensure customer satisfaction via early and continuous delivery of software.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      147,
      148,
      145,
      150,
      80
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 138,
    "question": "Rob is the CISO of a mid-sized company and he is working on developing a strategic plan for the organization’s cybersecurity function. He will need a commitment of funding and staff time to complete his plan. What is the most important component of obtaining the resources he needs?",
    "choice_a": "Planning ahead for staff assignments",
    "choice_b": "Making clear requests for funding",
    "choice_c": "Obtaining ongoing commitment from senior leaders",
    "choice_d": "Communicating a clear timetable for initiatives",
    "correct_answer": "C",
    "explanation": "All of these items are important to Rob’s success, but we are asked to identify the most important component in this question. That would be obtaining ongoing commitment from senior leadership for his initiative. Without high-level support, Rob will not be able to obtain the resources that he needs.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      10,
      2,
      27,
      17,
      26
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 139,
    "question": "Which of the following is <i>not</i> an external factor that would normally prompt a review of the organization’s risk assessment?",
    "choice_a": "Geopolitical changes",
    "choice_b": "System configuration changes",
    "choice_c": "Threat landscape changes",
    "choice_d": "Regulatory changes",
    "correct_answer": "B",
    "explanation": "All of these factors may prompt a risk reassessment to ensure that changes to existing, or new, risk scenarios are identified and managed appropriately. However, a system configuration change is an internal factor, not an external factor. Changes in the geopolitical climate, threat landscape, or the regulatory regime are external factors.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      44,
      49,
      57,
      43,
      54
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 140,
    "question": "Jody is reviewing the results of a business impact assessment and attempting to determine which risk she should address first. Which one of the following should she select as her highest priority?",
    "choice_a": "The risk with the highest ALE",
    "choice_b": "The risk with the lowest ALE",
    "choice_c": "The risk with the highest SLE",
    "choice_d": "The risk with the lowest SLE",
    "correct_answer": "A",
    "explanation": "Jody should address the risk that is expected to cause the most damage to the organization. She can do this by identifying the risk with the highest annualized loss expectancy (ALE). The ALE is a measure of both likelihood and impact, describing the total damage expected in any given year. The single loss expectancy (SLE) is a measure of impact only, as it does not incorporate likelihood information.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      46,
      45,
      56,
      47,
      50
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 141,
    "question": "Who has primary responsibility for the governance of a publicly traded corporation?",
    "choice_a": "Shareholders",
    "choice_b": "Board of directors",
    "choice_c": "President",
    "choice_d": "Chief executive officer",
    "correct_answer": "B",
    "explanation": "Shareholders do own the organization, but they delegate governance of the organization to a board of directors that they elect. This board has primary responsibility for corporate governance. The president or CEO may be the most senior executive within an organization, but they are also subject to the governance of the board of directors.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      26,
      27,
      4,
      3,
      10
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 142,
    "question": "Which one of the following pieces of information is most critical to conducting a solid incident recovery effort?",
    "choice_a": "Attacks on other organizations",
    "choice_b": "Time of the attack",
    "choice_c": "Identity of the attacker",
    "choice_d": "Root cause of the attack",
    "correct_answer": "D",
    "explanation": "Understanding the root cause of an attack is critical to the incident recovery effort. Analysts should examine all available information to help reconstruct the attacker’s actions. This information is crucial to remediating security controls and preventing future similar attacks.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      162,
      181,
      166,
      161,
      168
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 143,
    "question": "Karl is developing an information security strategy for his organization. Which one of the following elements should be the most important consideration?",
    "choice_a": "Business goals",
    "choice_b": "Security technology solutions",
    "choice_c": "Encryption key management",
    "choice_d": "Threat analysis",
    "correct_answer": "A",
    "explanation": "All of the factors described here may affect an organization’s security strategy, but the highest priority of a strategy document is to align the security function with the business. Therefore, Karl should make aligning the document with business goals his highest priority. Strategy documents would generally not contain detailed information about technology solutions, threat analyses, or encryption key management.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      27,
      10,
      2,
      28,
      17
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 144,
    "question": "Shelly is writing a document that describes the steps that incident response teams will follow upon first notice of a potential incident. What type of document is she creating?",
    "choice_a": "Policy",
    "choice_b": "Standard",
    "choice_c": "Guideline",
    "choice_d": "Procedure",
    "correct_answer": "D",
    "explanation": "Procedures provide checklist-style sets of step-by-step instructions guiding how employees should react in a given circumstance. Procedures commonly guide the early stages of incident response.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      33,
      77,
      79,
      84,
      95
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 145,
    "question": "Gary is designing a security program and wants to reduce the risk that employees will share sensitive information accidentally via social media. What would be the most effective control against this risk?",
    "choice_a": "Content filtering",
    "choice_b": "Data loss prevention",
    "choice_c": "Education",
    "choice_d": "Blocking social media at the firewall",
    "correct_answer": "C",
    "explanation": "Employee use of social media requires tact and discretion. Employees are likely to access social media despite any technical controls put in place, so the most effective way to protect against the loss of sensitive information is education and awareness. Firewalls may block access to social media in some cases, but employees will likely continue to access social media on their personal devices. Data loss prevention technology may identify some unintended exposure of sensitive information, but employees are likely to access social media from their personal mobile devices or from home, where this control would not apply.<br>Content filtering may block access to social media in some cases, but employees will likely continue to access social media on their personal devices.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      77,
      79,
      85,
      80,
      82
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 146,
    "question": "Tim is using the NIST Cybersecurity Framework to perform a risk assessment of his organization’s current cybersecurity posture. As he reviews the state of affairs, he discovers that his organization has a risk management policy and formally approved practices but does not conduct lessons learned sessions. What tier best describes the organization’s status?",
    "choice_a": "Tier 3: Repeatable",
    "choice_b": "Tier 4: Adaptive",
    "choice_c": "Tier 2: Risk Informed",
    "choice_d": "Tier 1: Partial",
    "correct_answer": "A",
    "explanation": "The adoption of formal risk management policies is a hallmark of Tier 3: Repeatable under the NIST Cybersecurity Framework. Moving to the top tier, Tier 4: Adaptive, would require that the organization adapts its cybersecurity practices based on previous and current cybersecurity activities, including lessons learned and predictive indicators. Because the organization does not yet conduct lessons learned sessions, they have not reached this tier.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      57,
      49,
      50,
      56,
      54
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 147,
    "question": "Which statement best describes the purpose of an information security strategy?",
    "choice_a": "To provide senior leaders with the assurance that information security controls function effectively",
    "choice_b": "To measure the effectiveness of the information security organization",
    "choice_c": "To create a plan for moving from the current state of information security to a future desired state",
    "choice_d": "To identify weaknesses in the organization’s security posture that require remediation",
    "correct_answer": "C",
    "explanation": "The information security strategy begins with an assessment of the current state of the organization and a comparison to the desired state of security based on the organization’s control objectives. It then outlines a plan for working from that current state to achieve the desired state through clearly articulated goals.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      10,
      13,
      12,
      22,
      17
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 148,
    "question": "What phase of the vendor management process should include establishing procedures for security incident notification?",
    "choice_a": "Vendor monitoring",
    "choice_b": "Vendor maintenance",
    "choice_c": "Vendor onboarding",
    "choice_d": "Vendor offboarding",
    "correct_answer": "C",
    "explanation": "Security incident procedures should be established prior to beginning the operational phase of the relationship. Therefore, they should be created during the vendor onboarding process, rather than during any of the other phases that come after the vendor is already up and running.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      91,
      90,
      33,
      95,
      79
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 149,
    "question": "Which one of the following activities is not normally conducted during the recovery validation phase?",
    "choice_a": "Implement new firewall rules",
    "choice_b": "Verify the permissions assigned to each account",
    "choice_c": "Conduct vulnerability scans",
    "choice_d": "Verify logging is functioning properly",
    "correct_answer": "A",
    "explanation": "New firewall rules, if required, would be implemented during the eradication and recovery phase. The validation phase includes verifying accounts and permissions, verifying that logging is working properly, and conducting vulnerability scans.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      162,
      161,
      166,
      157,
      158
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 150,
    "question": "Dave is preparing a document for users that helps them encrypt their hard drives to protect sensitive information and comply with corporate policy. It includes step-by-step instructions. What type of document is he creating?",
    "choice_a": "Guideline",
    "choice_b": "Standard",
    "choice_c": "Policy",
    "choice_d": "Procedure",
    "correct_answer": "D",
    "explanation": "Procedures contain step-by-step instructions for completing a security-related activity. Policies contain high-level statements of security objectives. They do not contain step-by-step guidance. Standards provide the detailed configuration parameters necessary to implement security policy. They do not normally contain implementation instructions.<br>Guidelines provide best practices for users to follow but they are not mandatory and do not normally include step-by-step instructions.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      33,
      40,
      32,
      77,
      79
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 151,
    "question": "Which one of the following is not typically found in a cybersecurity incident report?",
    "choice_a": "Chronology of events",
    "choice_b": "Identity of the attacker",
    "choice_c": "Estimates of impact",
    "choice_d": "Documentation of lessons learned",
    "correct_answer": "B",
    "explanation": "Incident reports should include a chronology of events, estimates of the impact, and documentation of lessons learned, in addition to other information. Incident response efforts should not normally focus on uncovering the identity of the attacker, so this information would not be found in an incident report.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      166,
      165,
      163,
      162,
      227
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 152,
    "question": "Cindy is performing a risk assessment of her organization and would like to use an industry standard that will help her determine her current security posture for each of the major cybersecurity functions, describe a target state for those controls, and then develop a plan for achieving that target state. What framework is best suited for this task?",
    "choice_a": "NIST RMF",
    "choice_b": "NIST CSF",
    "choice_c": "ISO 27701",
    "choice_d": "ISO 31000",
    "correct_answer": "B",
    "explanation": "NIST publishes both a Cybersecurity Framework (CSF) and a Risk Management Framework (RMF). The RMF is a formal process for implementing security controls and authorizing system use, whereas the CSF provides a broad structure for cybersecurity controls. The CSF is intended to help organizations describe their current cybersecurity posture, describe their target state for cybersecurity, identify and prioritize opportunities for improvement within the context of a continuous and repeatable process, assess progress toward the target state, and communicate among internal and external stakeholders about cybersecurity risk.<br>ISO 27701 contains standard guidance for managing privacy controls. ISO 31000 provides guidelines for risk management programs. This document is not specific to cybersecurity or privacy but covers risk management in a general way so that it may be applied to any risk.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      39,
      40,
      77,
      83,
      81
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 153,
    "question": "Sondra determines that an attacker has gained access to a server containing critical business files and wishes to ensure that the attacker cannot delete those files. Which one of the following strategies would meet Sondra’s goal?",
    "choice_a": "Isolation",
    "choice_b": "None of these",
    "choice_c": "Segmentation",
    "choice_d": "Removal",
    "correct_answer": "B",
    "explanation": "Even removing a system from the network doesn’t guarantee that the attack will not continue. An attacker can run a script on the server that detects when it has been removed from the network and then proceeds to destroy data stored on the server.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      160,
      161,
      162,
      164,
      210
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 154,
    "question": "During an operational investigation, what type of analysis might an organization undertake to prevent similar incidents in the future?",
    "choice_a": "Network traffic analysis",
    "choice_b": "Forensic analysis",
    "choice_c": "Root cause analysis",
    "choice_d": "Fagan analysis",
    "correct_answer": "C",
    "explanation": "Root cause analysis seeks to identify the reason that an operational issue occurred. The root cause analysis often highlights issues that require remediation to prevent similar incidents in the future. Forensic analysis is used to obtain evidence from digital systems. Network traffic analysis is an example of a forensic analysis category. Fagan inspection is a software testing technique.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      181,
      162,
      166,
      182,
      168
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 155,
    "question": "Ron is the CISO of a U.S. company that is entering into a business partnership with a European firm. The European firm will be sending his company customer records to run through Ron’s firm’s proprietary credit scoring algorithm. What role will Ron’s company have relative to the customer data?",
    "choice_a": "Data owner",
    "choice_b": "Data controller",
    "choice_c": "Data processor",
    "choice_d": "Data subject",
    "correct_answer": "C",
    "explanation": "Ron’s company is a data processor in this instance, as it is receiving records from the European firm. The European firm is the data controller in this case, as they bear responsibility for the data. The individuals described in the records are the data subjects. Data owners are tasked with making decisions about data such as who receives access to it and how it is used.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      15,
      37,
      29,
      4,
      27
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 156,
    "question": "Xavier is a data custodian responsible for maintaining databases with sensitive information, including Social Security numbers. He would like to protect those SSNs from prying eyes but will need to be able to retrieve the original value on occasion. What data protection technique would be most appropriate for his use?",
    "choice_a": "Masking",
    "choice_b": "Hashing",
    "choice_c": "Tokenization",
    "choice_d": "Redaction",
    "correct_answer": "C",
    "explanation": "Tokenization replaces sensitive values in a table with a non-sensitive token value. Employees with access to the lookup table may use these tokens to retrieve the original value when necessary. Masking, redaction, and hashing are all techniques that destroy the original value, making it impractical to retrieve it.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      64,
      62,
      63,
      116,
      35
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 157,
    "question": "Which one of the following U.S. government classification levels requires the highest degree of security control?",
    "choice_a": "Secret",
    "choice_b": "Top Secret",
    "choice_c": "Confidential",
    "choice_d": "Unclassified",
    "correct_answer": "B",
    "explanation": "Top Secret is the highest level of classification under the U.S. system and, therefore, requires the highest level of security control.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      19,
      20,
      22,
      21,
      30
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 158,
    "question": "Robin is planning to conduct a risk assessment in her organization. She is concerned that it will be difficult to perform the assessment because she needs to include information about both tangible and intangible assets. What would be the most effective risk assessment strategy for her to use?",
    "choice_a": "Quantitative risk assessment",
    "choice_b": "Combination of quantitative and qualitative risk assessment",
    "choice_c": "Qualitative risk assessment",
    "choice_d": "Neither quantitative nor qualitative risk assessment",
    "correct_answer": "B",
    "explanation": "Robin would have achieved the best results by combining elements of quantitative and qualitative risk assessment. Quantitative risk assessment excels at analyzing tangible, financial risks, whereas qualitative risk assessment is good for intangible risks. Combining the two techniques provides a well-rounded risk picture.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      46,
      47,
      45,
      43,
      56
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 159,
    "question": "Jen is helping create a new cybersecurity policy for her organization. Her supervisor agrees with the policy approach but there is an influential engineer on her team who she thinks will disagree. What should Jen do next?",
    "choice_a": "Ask her manager to bring the policy to senior leadership for approval",
    "choice_b": "Ask her manager to approve the policy",
    "choice_c": "Discuss the policy with the engineer and try to build consensus",
    "choice_d": "Revise the policy before submitting it",
    "correct_answer": "C",
    "explanation": "Jen should certainly respect the formal chain of command within her organization, but it is also important to acknowledge informal power and influence. If possible, she should try to help the influential engineer become a supporter before moving forward.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      2,
      27,
      4,
      10,
      14
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 160,
    "question": "Seth is evaluating a new source of potential threat intelligence. Which one of the following questions would be <i>least</i> important to his evaluation?",
    "choice_a": "Is the information accurate?",
    "choice_b": "Is the information timely?",
    "choice_c": "Is the information proprietary?",
    "choice_d": "Is the information relevant?",
    "correct_answer": "C",
    "explanation": "Let’s eliminate the most important questions that a threat researcher can ask. First, it is important to know whether the information is timely or not. A feed that is operating on delay can cause you to miss a threat, or to react after the threat is no longer relevant. Second, you need to know whether the information is accurate. You must know whether you can you rely on what it says, and how likely is it that the assessment is valid. Finally, you must know whether the information is relevant to your organization. If it describes the wrong platform, software, or reason for the organization to be targeted, the data may be very timely, very accurate, and completely irrelevant to your organization. It is less important to know whether the information is proprietary or open source.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      74,
      73,
      76,
      66,
      69
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 503,
    "question": "Vincent discovered the vulnerability shown here when scanning a system on his network. What is the best action he can take to correct this vulnerability?<br><img src=\"/question_assets/CISM/801931_Practice_Exam_1_image3.png\"/>",
    "choice_a": "Remove the FTP server.",
    "choice_b": "Add multifactor authentication to the FTP server.",
    "choice_c": "Require the use of strong passwords.",
    "choice_d": "Add an intrusion prevention system.",
    "correct_answer": "A",
    "explanation": "The File Transfer Protocol (FTP) is an insecure protocol that should not be used today. Vincent’s best course of action is to remove the FTP server and replace this insecure protocol with a secure alternative, such as FTPS.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      118,
      105,
      97,
      104,
      35
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 162,
    "question": "Which one of the following technologies would be most helpful in managing the configuration of devices brought into an organization under a BYOD computing approach?",
    "choice_a": "MDM",
    "choice_b": "Firewall",
    "choice_c": "IPS",
    "choice_d": "DLP",
    "correct_answer": "A",
    "explanation": "Mobile device management (MDM) solutions manage the secure configuration of mobile devices, including those brought into the organization under a Bring Your Own Device (BYOD) policy. Data loss prevention (DLP) systems do protect the organization against the accidental or intentional exfiltration of data, but they do not manage system configurations.<br>Intrusion prevention systems (IPSs) do protect the organization against potentially malicious network traffic, but they do not manage system configurations. Firewalls do protect the organization against potentially malicious network traffic, but they do not manage system configurations.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      118,
      41,
      116,
      123,
      35
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 163,
    "question": "Which one of the following is not a common duty for an organization’s information security officer?",
    "choice_a": "Configuring firewall rules",
    "choice_b": "Assisting with audit requests",
    "choice_c": "Managing the security budget",
    "choice_d": "Communicating risks to the organization’s leaders",
    "correct_answer": "A",
    "explanation": "Information security officers are expected to communicate risks to leadership, are typically responsible for managing the information security budget, and often must respond to internal and external audit requests. Information security officers generally do not have direct operational responsibilities, such as configuring a firewall rule.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      2,
      3,
      4,
      27,
      28
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 164,
    "question": "Don would like to deploy a vulnerability scanner in his environment but does not have the budget to purchase a commercial solution. What scanning tool would best meet his needs?",
    "choice_a": "OpenVAS",
    "choice_b": "Qualys",
    "choice_c": "Nessus",
    "choice_d": "Nexpose",
    "correct_answer": "A",
    "explanation": "OpenVAS is a free, open source vulnerability scanner, whereas Qualys, Nessus, and Nexpose are all commercial products.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      101,
      99,
      100,
      103,
      97
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 165,
    "question": "Helen recently worked with business leaders to determine the longest amount of time that her organization’s website may be down before affecting important business functions. What metric has she captured?",
    "choice_a": "RPO",
    "choice_b": "RTO",
    "choice_c": "MTD",
    "choice_d": "MTBF",
    "correct_answer": "C",
    "explanation": "The maximum tolerable downtime (MTD) is the longest duration for which a resource may be unavailable before affecting a critical business function. The recovery time objective (RTO) is a similar measure identifying how quickly a system may be restored. The recovery point objective (RPO) is the amount of data loss that may occur during a recovery effort. The mean time between failures (MTBF) is the amount of time that elapses between failure events, on average.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      191,
      197,
      190,
      184,
      185
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 166,
    "question": "Tamara recently decided to purchase cyber-liability insurance to cover her company’s costs in the event of a data breach. What risk management strategy is she pursuing?",
    "choice_a": "Risk mitigation",
    "choice_b": "Risk acceptance",
    "choice_c": "Risk transference",
    "choice_d": "Risk avoidance",
    "correct_answer": "C",
    "explanation": "Risk transference involves shifting the impact of a potential risk from the organization incurring the risk to another organization. Insurance is a common example of risk transference.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      50,
      53,
      52,
      51,
      54
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 167,
    "question": "Which one of the following elements of an information security policy framework does <i>not</i> contain mandatory requirements for employees?",
    "choice_a": "Policy",
    "choice_b": "Guideline",
    "choice_c": "Standard",
    "choice_d": "Required procedure",
    "correct_answer": "B",
    "explanation": "Guidelines provide recommendations and best practices for achieving security objectives, but they are not mandatory. Policies provide high-level statements of management intent and are mandatory for all employees. Standards provide mandatory configuration information and other control requirements for security programs. Required procedures provide mandatory step-by-step instructions for performing a security task.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      35,
      79,
      32,
      33,
      39
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 168,
    "question": "In an organization subject to the General Data Protection Regulation, which one of the following roles must be filled by someone granted a significant degree of independent authority to enforce privacy requirements?",
    "choice_a": "Data custodian",
    "choice_b": "Data steward",
    "choice_c": "Data protection officer",
    "choice_d": "Data processor",
    "correct_answer": "C",
    "explanation": "The data protection officer (DPO) is an official role assigned by data processors subject to GDPR. The DPO is accountable to governmental authorities for the proper execution of an organization’s data protection and privacy program and must be granted the authority to carry out their work with autonomy.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      37,
      27,
      3,
      15,
      4
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 169,
    "question": "Bill recently accepted a new position as an information security manager after a career in other domains of risk management. His boss suggested to him that he quickly immerse himself in the world of information technology. What is the most important reason that an information security manager should be conversant in other areas of IT?",
    "choice_a": "Knowledge of other IT domains will help Bill better understand the business.",
    "choice_b": "Knowledge of other IT domains will provide Bill with the ability to modify system configurations.",
    "choice_c": "Knowledge of other IT domains will help Bill design and implement security controls.",
    "choice_d": "Knowledge of other IT domains would give Bill credibility with technical staff.",
    "correct_answer": "C",
    "explanation": "The primary reason that Bill needs IT knowledge is to understand the impact of different technologies on security decisions, such as the design and implementation of security controls. While IT knowledge would certainly add to Bill’s credibility, the primary reason he needs IT knowledge is to understand the impact of different technologies on security decisions. Technical knowledge will not necessarily contribute to Bill’s knowledge of the organization’s business. As an information security manager, Bill should not find himself modifying system configurations.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      77,
      78,
      85,
      95,
      126
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 170,
    "question": "Which one of the following elements would not normally be included in a business case?",
    "choice_a": "Cost analysis",
    "choice_b": "Project plan",
    "choice_c": "Evaluation of alternatives",
    "choice_d": "Strengths, weaknesses, opportunities, and threats",
    "correct_answer": "D",
    "explanation": "A business case normally includes a scope statement, a description of the strategic context, a cost analysis, an evaluation of alternatives, a project plan, and a management plan. It would not normally include a discussion of strengths, weaknesses, opportunities, and threats. Those items would be included in a SWOT analysis.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      28,
      11,
      27,
      10,
      2
    ],
    "source": "801931 Practice Exam 1"
  },
  {
    "id": 171,
    "question": "Fred recently received a directive from his organization’s leadership council that they will be moving to a Cloud First approach to computing. As the CISO, he is concerned about the security risks associated with this move. Fred advised against this move, but leadership chose to adopt this strategy anyway. What should be his primary objective at this stage?",
    "choice_a": "Advocate to reverse the decision",
    "choice_b": "Develop a cloud security strategy",
    "choice_c": "Hire cloud security specialists",
    "choice_d": "Implement cloud security controls",
    "correct_answer": "B",
    "explanation": "The business leadership has made a decision after receiving Fred’s advice. His role now is to support that decision and provide strong security around the deployment. He should begin by integrating cloud security into his organization’s security strategy. This may lead to the hiring of staff or the implementation of new controls, but any such decisions should be made in the context of the security strategy.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      10,
      27,
      17,
      2,
      14
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 172,
    "question": "Brian is developing the training program for his organization’s disaster recovery program and would like to make sure that participants understand when disaster activity concludes. Which one of the following events marks the completion of a disaster recovery process?",
    "choice_a": "Restoring operations in the primary facility",
    "choice_b": "Standing down first responders",
    "choice_c": "Restoring operations in an alternate facility",
    "choice_d": "Securing property and life safety",
    "correct_answer": "A",
    "explanation": "The end goal of the disaster recovery process is restoring normal business operations in the primary facility. All the other actions listed may take place during the disaster recovery process, but the process is not complete until the organization is once again functioning normally in its primary facilities.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      219,
      185,
      203,
      224,
      191
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 173,
    "question": "Ryan is selecting a new security control to meet his organization’s objectives. He would like to use it in their multicloud environment and would like to minimize the administrative work required from his fellow technologists. What approach would best meet his needs?",
    "choice_a": "Internally developed control",
    "choice_b": "Cloud-native control",
    "choice_c": "Third-party control",
    "choice_d": "Any of the above",
    "correct_answer": "C",
    "explanation": "Controls offered by cloud service providers have the advantage of direct integration with the provider’s offerings, often making them cost-effective and user-friendly. Third-party solutions are often more costly, but they bring the advantage of integrating with a variety of cloud providers, facilitating the management of multicloud environments.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      133,
      131,
      128,
      130,
      90
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 174,
    "question": "Which one of the following criteria is not normally used when evaluating the appropriateness of a cybersecurity incident containment strategy?",
    "choice_a": "Effectiveness of the strategy",
    "choice_b": "Log records generated by the strategy",
    "choice_c": "Cost of the strategy",
    "choice_d": "Evidence preservation requirements",
    "correct_answer": "B",
    "explanation": "NIST recommends using six criteria to evaluate a containment strategy: the potential damage to resources, the need for evidence preservation, service availability, time and resources required (including cost), effectiveness of the strategy, and duration of the solution.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      161,
      160,
      163,
      182,
      165
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 175,
    "question": "Brian would like to limit the ability of users inside his organization to provision expensive cloud server instances without permission. What type of control would best help him achieve this goal?",
    "choice_a": "Secure web gateway",
    "choice_b": "Security group",
    "choice_c": "Multifactor authentication",
    "choice_d": "Resource policy",
    "correct_answer": "D",
    "explanation": "Cloud providers offer resource policies that customers may use to limit the actions that users of their accounts may take. Implementing resource policies is a good security practice to limit the damage caused by an accidental command, a compromised account, or a malicious insider.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      133,
      131,
      128,
      134,
      79
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 176,
    "question": "Roger is implementing a new set of security controls designed to ensure that his organization’s website does not experience outages during periods of heavy demand. What goal of information security is he trying to achieve?",
    "choice_a": "Integrity",
    "choice_b": "Confidentiality",
    "choice_c": "Availability",
    "choice_d": "Nonrepudiation",
    "correct_answer": "C",
    "explanation": "Roger is designing controls that will protect his website from undesirable interruptions of activity. This is an example of an availability control.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      136,
      124,
      40,
      35,
      80
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 177,
    "question": "Which one of the following attributes of an organization can an information security team best use to determine the appropriate level of resources to apply to mitigating an identified risk?",
    "choice_a": "CVE rating",
    "choice_b": "Risk transference",
    "choice_c": "Risk appetite",
    "choice_d": "Budget",
    "correct_answer": "C",
    "explanation": "The risk appetite helps an organization identify the acceptable level of risk that may exist within an organization. Identified risks should be mitigated until they are within the risk appetite. While budgetary concerns may dictate available resources, the budget does not identify the appropriate level of risk mitigation. Organizations with insufficient funding to mitigate risk to the required level should pursue additional security funding. CVE ratings are used to identify the significance of a vulnerability and are not directly applicable in determining how to mitigate a risk. Risk transference is a risk management strategy used to shift risk to a third party. It is not used in determining the level of resources that should be applied toward mitigating a risk.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      54,
      50,
      45,
      51,
      49
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 178,
    "question": "Roger is preparing an executive briefing for a nontechnical CEO who is interested in learning more about the organization’s cybersecurity program. Which one of the following topics would be most relevant for this meeting?",
    "choice_a": "Proposing the addition of a new encryption algorithm to the organization’s list of approved techniques",
    "choice_b": "Reviewing attempts to lower the false positive rate on the intrusion prevention system",
    "choice_c": "Discussing trends in major security incidents",
    "choice_d": "Reviewing new procedures for incident response",
    "correct_answer": "C",
    "explanation": "Roger should tailor the meeting contents to his audience. In this case, he is speaking to a very senior leader who is not technical, so he should keep the content simple and strategic. Of the topics listed, a review of recent security incidents would be the most relevant to the CEO, while the other topics would be more appropriate for technical leaders.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      56,
      54,
      50,
      44,
      57
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 179,
    "question": "Kevin is configuring a web server to use digital certificates. What technology can he use to allow clients to quickly verify the status of that digital certificate without contacting a remote server.",
    "choice_a": "Certificate stapling",
    "choice_b": "Certificate pinning",
    "choice_c": "OCSP",
    "choice_d": "CRL",
    "correct_answer": "A",
    "explanation": "The Online Certificate Status Protocol (OCSP) provides real-time checking of a digital certificate’s status using a remote server. Certificate stapling attaches a current OCSP response to the certificate to allow the client to validate the certificate without contacting the OCSP server. Certificate revocation lists (CRLs) are a slower, outdated approach to managing certificate status. Certificate pinning is used to provide an expected key, not to manage certificate status.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      142,
      141,
      140,
      143,
      136
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 180,
    "question": "Brian is a risk manager assessing his organization’s compliance with IT system management policies. He identifies a team that is managing their own systems without regard to the policies. The team is unwilling to discuss bringing the systems into compliance. What should Brian’s next step be in this situation?",
    "choice_a": "Report the noncompliance to appropriate management",
    "choice_b": "Disconnect the systems from the network",
    "choice_c": "Reconfigure the systems to meet security standards",
    "choice_d": "Grant an exception to the team",
    "correct_answer": "A",
    "explanation": "As a risk manager, Brian’s responsibility in this case is to inform appropriate management personnel of the noncompliance. He should not unilaterally take action to remedy the situation or grant an exception.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      56,
      50,
      57,
      54,
      45
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 181,
    "question": "Renee recently imaged a drive for use during a criminal investigation. She is working with law enforcement officers to conduct an analysis of the drive. If Renee is called to testify in court, what will be one of the primary things she must prove?",
    "choice_a": "That the drive image is on hardware identical to the original drive",
    "choice_b": "That the image was made using a write-blocker",
    "choice_c": "That she holds a degree in forensic analysis",
    "choice_d": "That the chain of custody of the evidence was preserved",
    "correct_answer": "D",
    "explanation": "The chain of custody requires that Renee be able to clearly document every change in control of the evidence from the time it is collected until it is presented at trial. Evidence may be thrown out if there is any question about the chain of custody. There is no requirement to use identical hardware for drive images, and in many cases, the image is simply a large file stored on a forensic server. There are no formal educational requirements for performing forensic operations, although the opposing attorney may question Renee’s experience. While many forensic investigators do use write-blockers as a safety mechanism while collecting evidence, their use is not a requirement and is not as important as preserving the chain of custody.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      178,
      179,
      177,
      182,
      165
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 182,
    "question": "Lauren is conducting threat research for her organization. Which of the following would be most appropriately classified as a threat actor?",
    "choice_a": "Phishing email",
    "choice_b": "Ransomware",
    "choice_c": "Hacker",
    "choice_d": "Network eavesdropping",
    "correct_answer": "C",
    "explanation": "Threat actors are the individuals or organizations seeking to undermine the security of an organization. A hacker is an example of a threat actor. Threat vectors are the tactics, tools, and techniques used by threat actors to achieve their objectives. Threat vectors would include ransomware, phishing emails, and network eavesdropping.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      66,
      68,
      69,
      70,
      73
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 183,
    "question": "What ISO standard provides guidance for the establishment of a risk management program?",
    "choice_a": "ISO 27001",
    "choice_b": "ISO 31000",
    "choice_c": "ISO 27002",
    "choice_d": "ISO 27701",
    "correct_answer": "B",
    "explanation": "ISO 31000 provides guidelines for risk management programs. This document is not specific to cybersecurity or privacy but covers risk management in a general way so that it may be applied to any type of risk. ISO 27001 provides information security control objectives. ISO 27002 goes beyond control objectives and describes the actual controls that an organization may implement to meet cybersecurity objectives. ISO 27701 contains standard guidance for managing privacy controls. ISO views this document as an extension to their ISO 27001 and ISO 27002 security standards.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      22,
      12,
      10,
      38,
      14
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 184,
    "question": "Evan is reviewing the reporting structure for cybersecurity leaders within a client organization. He notes that the CISO reports to the director of infrastructure and technology, who reports to the CIO. What statement is most accurate about this reporting relationship?",
    "choice_a": "This is an appropriate reporting relationship because the CIO must keep a narrow span of control.",
    "choice_b": "This is an appropriate reporting relationship because most cybersecurity issues involve networking and infrastructure.",
    "choice_c": "This is not an appropriate reporting relationship because most cybersecurity issues do not involve networking and infrastructure.",
    "choice_d": "This is not an appropriate reporting relationship because it creates a potential conflict of interest.",
    "correct_answer": "D",
    "explanation": "This approach creates a potential conflict of interest when the information security team disagrees with an approach endorsed by the director to whom they report. It would be far more appropriate for the CISO to report directly to the CIO, regardless of issues with span of control. It is irrelevant whether most cybersecurity issues in the organization include topics of networking and infrastructure.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      3,
      4,
      27,
      26,
      10
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 504,
    "question": "Sam is responsible for backing up his company’s primary file server. He configured a backup schedule that performs full backups every Monday evening at 9 p.m. and differential backups on other days of the week at that same time. Files change according to the information shown in the following figure. How many files will be copied in Wednesday’s backup?<br><img src=\"/question_assets/CISM/801931_Practice_Exam_2_image1.png\"/>",
    "choice_a": "2",
    "choice_b": "5",
    "choice_c": "3",
    "choice_d": "6",
    "correct_answer": "B",
    "explanation": "In this scenario, all of the files on the server will be backed up on Monday evening during the full backup. The differential backup on Wednesday will then copy all files modified since the last full backup. These include files 1, 2, 3, 5, and 6—a total of five files.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      223,
      185,
      203,
      226,
      210
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 186,
    "question": "Which one of the following controls is <i>most</i> likely to detect the use of a zero-day exploit against an organization?",
    "choice_a": "Security patches",
    "choice_b": "Antivirus software",
    "choice_c": "Anomaly detection",
    "choice_d": "Signature-based IDS",
    "correct_answer": "C",
    "explanation": "Anomaly detection systems search for deviations from normal activity and are likely to detect zero-day attacks. Signature-based detection approaches are not effective against zero-day attacks, because they are unknown to security researchers. Most modern antivirus software uses signature detection techniques, which are not effective against zero-day attacks. Security patches are not available for zero-day vulnerabilities and are not detective controls.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      123,
      115,
      94,
      104,
      107
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 187,
    "question": "Alan is performing a forensic examination of a disk drive and makes a copy for use in his analysis. What is the most important action he must take to provide evidence that the image is an exact copy of the original?",
    "choice_a": "Use identical hardware to read the image that was used with the original disk.",
    "choice_b": "Manually verify the contents of the image.",
    "choice_c": "Copy each file individually.",
    "choice_d": "Perform digital hashing on the original and the copy.",
    "correct_answer": "D",
    "explanation": "Digital hashes are a convenient and secure way to verify that two disks contain identical content. It is not necessary to use identical hardware to read the image. Alan will most likely use a dedicated forensic workstation to view the image. Alan should not copy files individually and should instead use imaging software to duplicate the drive bit by bit. It would not be possible to manually verify every bit on a hard drive.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      179,
      182,
      178,
      180,
      164
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 188,
    "question": "Gordon suspects that a hacker has penetrated a system belonging to his company. The system does not contain any regulated information, and Gordon wishes to conduct an investigation on behalf of his company. He has permission from his supervisor to conduct the investigation. Which of the following statements is true?",
    "choice_a": "Gordon’s investigation may include examining the contents of hard disks, network traffic, and any other systems or information belonging to the company.",
    "choice_b": "Gordon is legally required to contact law enforcement before beginning the investigation.",
    "choice_c": "Gordon may not conduct his own investigation.",
    "choice_d": "Gordon may ethically perform “hack back” activities after identifying the perpetrator.",
    "correct_answer": "A",
    "explanation": "Gordon may conduct his investigation as he wishes and use any information that is legally available to him, including information and systems belonging to his employer. There is no obligation to contact law enforcement. However, Gordon may not perform “hack back” activities because those may constitute violations of the law and/or his ethical obligations.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      175,
      181,
      163,
      168,
      170
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 189,
    "question": "Brian is selecting a CASB for his organization and he would like to use an approach that interacts with the cloud provider directly. Which CASB approach is most appropriate for his needs?",
    "choice_a": "Comprehensive CASB",
    "choice_b": "Inline CASB",
    "choice_c": "Outsider CASB",
    "choice_d": "API-based CASB",
    "correct_answer": "D",
    "explanation": "API-based CASB solutions interact directly with the cloud provider through the provider’s API. Inline CASB solutions intercept requests between the user and the provider. Outsider and comprehensive are not categories of CASB solutions.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      133,
      134,
      130,
      131,
      129
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 190,
    "question": "Which one of the following security tools is not capable of generating an active response to a security event?",
    "choice_a": "Firewall",
    "choice_b": "IDS",
    "choice_c": "IPS",
    "choice_d": "Antivirus software",
    "correct_answer": "B",
    "explanation": "Intrusion detection systems (IDSs) provide only passive responses, such as alerting administrators to a suspected attack. Intrusion prevention systems (IPSs) and firewalls, on the other hand, may take action to block an attack attempt. Antivirus software also may engage in active response by quarantining suspect files.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      123,
      115,
      119,
      118,
      124
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 191,
    "question": "Greg is implementing a data loss prevention system. He would like to ensure that it protects against transmissions of sensitive information by guests on his wireless network. What DLP technology would best meet this goal?",
    "choice_a": "Network-based",
    "choice_b": "Host-based",
    "choice_c": "Pattern recognition",
    "choice_d": "Watermarking",
    "correct_answer": "A",
    "explanation": "In this case, Greg must use a network-based DLP system. Host-based DLP requires the use of agents, which would not be installed on guest systems. Greg may use watermarking and/or pattern recognition to identify the sensitive information. but he must use network-based DLP to meet his goal.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      116,
      62,
      119,
      118,
      125
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 192,
    "question": "Under which of the following scenarios would it be <i>most</i> acceptable for an organization to pursue a risk acceptance strategy?",
    "choice_a": "The likelihood of a risk is extremely low, and the impact is extremely low.",
    "choice_b": "The likelihood of a risk is extremely low, and the impact is extremely high.",
    "choice_c": "The likelihood of a risk is extremely high, and the impact is extremely high.",
    "choice_d": "The likelihood of a risk is extremely high, and the impact is extremely low.",
    "correct_answer": "A",
    "explanation": "Risk acceptance should only occur when both the likelihood and impact of a risk are relatively low. Accepting a risk with high likelihood is dangerous because the risk is very likely to occur. Accepting a risk with high impact is dangerous because the risk could cause considerable damage.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      50,
      45,
      52,
      54,
      51
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 193,
    "question": "Ben is seeking a control objective framework that is widely accepted around the world and focuses specifically on information security controls. Which one of the following frameworks would best meet his needs?",
    "choice_a": "ITIL",
    "choice_b": "ISO 27002",
    "choice_c": "CMM",
    "choice_d": "PMBOK",
    "correct_answer": "B",
    "explanation": "ISO 27002 is an international standard focused on information security and titled “Information technology—Security techniques—Code of practice for information security management.” The Information Technology Infrastructure Library (ITIL) does contain security management practices, but it is not the sole focus of the document, and the ITIL security section is derived from ISO 27002. The Capability Maturity Model (CMM) is focused on software development, and the Project Management Body of Knowledge (PMBOK©) Guide focuses on project management.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      40,
      39,
      32,
      77,
      83
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 194,
    "question": "Carrie received a message from Tina that was digitally signed. What key should she use to verify the digital signature?",
    "choice_a": "Carrie’s public key",
    "choice_b": "Tina’s private key",
    "choice_c": "Tina’s public key",
    "choice_d": "Carrie’s private key",
    "correct_answer": "C",
    "explanation": "When an individual digitally signs a message, they do so using their own private key. When the recipient verifies the digital signature, they do so using the signer’s public key. Therefore, Carrie should use Tina’s public key to verify the signature.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      140,
      138,
      141,
      139,
      143
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 195,
    "question": "Which one of the following statements about cryptographic keys is incorrect?",
    "choice_a": "Asymmetric algorithms generally use longer keys than symmetric algorithms.",
    "choice_b": "Longer keys are better than shorter keys when the same algorithm is used.",
    "choice_c": "All cryptographic keys should be kept secret.",
    "choice_d": "Digital certificates are designed to share public keys.",
    "correct_answer": "C",
    "explanation": "All of these statements are correct except for the statement that all cryptographic keys should be kept secret. The exception to this rule is a public key used in asymmetric cryptography. These keys should be freely shared.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      138,
      143,
      137,
      140,
      141
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 196,
    "question": "You would like to purchase a new intrusion prevention system to safeguard your organization against attack. Which one of the following presentations would most likely sway nontechnical leaders of the organization?",
    "choice_a": "Cost savings projections",
    "choice_b": "Threat assessment",
    "choice_c": "Business case",
    "choice_d": "Technical specifications",
    "correct_answer": "C",
    "explanation": "Business leaders respond well to business case assessment and would likely prefer to see the IPS purchase couched in terms of business impact. Threat assessments generally contain technical details not couched in the language of business leaders. It would be extremely difficult, if not impossible, to produce a credible cost savings projection for a proactive security control, such as an IPS. Business leaders would not likely be interested in the technical specifications of an IPS, preferring to leave those details to technology professionals.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      28,
      2,
      27,
      17,
      8
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 197,
    "question": "Glenda would like to conduct a disaster recovery test and is seeking a test that will allow a review of the plan with no disruption to normal information system activities and as minimal a commitment of time as possible. What type of test should she choose?",
    "choice_a": "Parallel test",
    "choice_b": "Tabletop exercise",
    "choice_c": "Checklist review",
    "choice_d": "Full interruption test",
    "correct_answer": "C",
    "explanation": "The checklist review is the least disruptive type of disaster recovery test. During a checklist review, team members each review the contents of their disaster recovery checklists on their own and suggest any necessary changes. During a tabletop exercise, team members come together and walk through a scenario without making any changes to information systems. During a parallel test, the team actually activates the disaster recovery site for testing but the primary site remains operational. During a full interruption test, the team takes down the primary site and confirms that the disaster recovery site is capable of handling regular operations. The full interruption test is the most thorough test but also the most disruptive.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      226,
      183,
      188,
      225,
      228
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 198,
    "question": "Mary is a security risk analyst for an insurance company. She is currently examining a scenario where a hacker might use a SQL injection attack to deface a web server due to a missing patch in the company’s web application. In this scenario, what is the risk?",
    "choice_a": "Web defacement",
    "choice_b": "Unpatched web application",
    "choice_c": "Hacker",
    "choice_d": "Operating system",
    "correct_answer": "A",
    "explanation": "Risks are the combination of a threat and a vulnerability. Threats are the external forces seeking to undermine security, such as the hacker in this case. Vulnerabilities are the internal weaknesses that might allow a threat to succeed. In this case, web defacement is the risk. In this scenario, if the hacker attempts a SQL injection attack (threat) against the unpatched server (vulnerability), the result is website defacement (risk).",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      43,
      45,
      46,
      51,
      44
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 199,
    "question": "Bob is the manager of an incident response team and is creating a policy that will govern how the organization handles future incidents. Bob knows that his supervisor will not like the current contents of the policy and that the policy will require approval from the CEO. How should Bob proceed?",
    "choice_a": "Stop development of the policy.",
    "choice_b": "Bring the policy to the CEO for approval.",
    "choice_c": "Work with his supervisor to revise the policy.",
    "choice_d": "Explain to the team that his supervisor is a roadblock to getting the policy implemented.",
    "correct_answer": "C",
    "explanation": "Bob should respect the chain of command in his organization and work with his supervisor to revise the policy. He should not go behind his supervisor’s back to the CEO, and there is no need to stop policy development at this point in the process. Bob should not discuss his frustration with team members, as this is an issue between him and his supervisor.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      2,
      27,
      36,
      26,
      4
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 200,
    "question": "Jen’s organization is preparing to launch a new business unit and many employees will be transferring to new roles on both temporary and permanent assignments. What security issue is most likely to arise from this situation?",
    "choice_a": "Security through obscurity",
    "choice_b": "Separation of privileges violation",
    "choice_c": "Privilege creep",
    "choice_d": "Separation of powers violation",
    "correct_answer": "C",
    "explanation": "Failing to properly handle internal employee transfers often leads to a situation known as privilege creep. This occurs when an employee accepts a new position within the company and is then granted the new access permissions necessary to carry out that new work but never has the privileges associated with their old job revoked. The employee then has unnecessary permissions, which violates the security principle of least privilege.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      92,
      93,
      155,
      94,
      84
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 201,
    "question": "Nancy is leading an effort to modernize her organization’s antimalware protection and would like to add endpoint detection and response (EDR) capabilities. Which of the following actions is not normally supported by EDR systems?",
    "choice_a": "Integrating with threat intelligence sources",
    "choice_b": "Analyzing endpoint memory, file system, and network activity for signs of malicious activity",
    "choice_c": "Automatically isolating possible malicious activity to contain the potential damage",
    "choice_d": "Conducting simulated phishing campaigns",
    "correct_answer": "D",
    "explanation": "EDR platforms do not conduct simulated phishing campaigns. The most common features of EDR systems are analyzing endpoint memory, file system, and network activity for signs of malicious activity, isolating possible malicious activity to contain the potential damage, integrating with threat intelligence sources, and integrating with other incident response mechanisms.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      115,
      84,
      113,
      135,
      123
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 202,
    "question": "Sandy is working to deploy a new phishing awareness campaign that will use simulations to help educate users. Users will be sent fake phishing messages and the team will monitor the response of users to those messages. Her ultimate goal is to reduce the impact of phishing attacks on the organization. Which one of the following would be the most effective measure of the program’s success?",
    "choice_a": "Rate of marking spam on simulation messages",
    "choice_b": "Rate of clicking on simulation messages",
    "choice_c": "Rate of opening simulation messages",
    "choice_d": "Number of accounts compromised by real phishing attacks",
    "correct_answer": "D",
    "explanation": "All of these metrics might be used to evaluate the program’s success, but the ultimate measure of success is how well the program meets its objective: reducing the number of successful phishing attacks. Therefore, Sandy should use the number of actual account compromises that occur due to real phishing attacks.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      81,
      84,
      82,
      80,
      77
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 203,
    "question": "Tamara is a cybersecurity analyst for a private business that is suffering a security breach. She believes the attackers have compromised a database containing sensitive information. Which one of the following activities should be Tamara’s first priority?",
    "choice_a": "Containment",
    "choice_b": "Identifying the source of the attack",
    "choice_c": "Eradication",
    "choice_d": "Recovery",
    "correct_answer": "A",
    "explanation": "Tamara’s first priority should be containing the attack. This will prevent it from spreading to other systems and also potentially stop the exfiltration of sensitive information. Only after containing the attack should Tamara move on to eradication and recovery activities. Identifying the source of the attack should be a low priority.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      161,
      157,
      162,
      163,
      167
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 204,
    "question": "Alice is responding to a security incident. She had originally decided to place a system on a quarantine VLAN and allow it to continue communicating with internal systems. However, after conferring with other team members, she decides that even allowing limited access to other systems is an unacceptable risk and decides instead to prevent the quarantine VLAN from accessing any other systems by putting firewall rules in place that limit access to other enterprise systems. The attacker can still control the system to allow Alice to continue monitoring the incident. What strategy is she now pursuing?",
    "choice_a": "Isolation",
    "choice_b": "Eradication",
    "choice_c": "Segmentation",
    "choice_d": "Removal",
    "correct_answer": "A",
    "explanation": "In the isolation strategy, the quarantine network is directly connected to the Internet or restricted severely by firewall rules so that the attacker may continue to control it but not gain access to any other networked resources.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      160,
      161,
      167,
      168,
      162
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 205,
    "question": "What term is used to describe an organization-wide approach to managing risks that might affect the organization’s ability to achieve its goals?",
    "choice_a": "ERM",
    "choice_b": "ERP",
    "choice_c": "CRM",
    "choice_d": "CRP",
    "correct_answer": "A",
    "explanation": "Enterprise risk management (ERM) programs take a formal approach to risk analysis that begins with identifying risks, continues with determining the severity of each risk, and then results in adopting one or more risk management strategies to address each risk. Enterprise resource planning (ERP) systems are used by organizations to manage internal processes. Customer relationship management (CRM) systems are used to track customer and salesperson activity. CRP is not a common risk management or information technology acronym.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      43,
      57,
      50,
      45,
      54
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 206,
    "question": "Ahmed is concerned that users in his organization do not understand what types of information are sensitive and that they do not understand what controls should be used to protect that information. Which one of the following programs would be the best investment of time to address Ahmed’s concern?",
    "choice_a": "Data governance",
    "choice_b": "Data classification",
    "choice_c": "Data loss prevention",
    "choice_d": "Data minimization",
    "correct_answer": "B",
    "explanation": "Data classification programs define the categories of information used by an organization and the security controls appropriate for that information. This would directly address Ahmed’s concern. A data governance program would normally include data classification work but also includes many other components that would slow down Ahmed’s achievement of his primary goal. It might be appropriate to begin with a data classification effort and move into a full data governance program once that effort is complete. Data loss prevention and data minimization programs, while important efforts, do not help users understand categories of data and proper data handling practices.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      63,
      62,
      84,
      77,
      35
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 207,
    "question": "Doug recently became aware of a flaw in one of the applications used by his organization, and he consequently adjusted firewall rules to limit access from external networks. What effect would this have on the risk?",
    "choice_a": "Reduce the likelihood of an exploit",
    "choice_b": "Decrease the threat vector",
    "choice_c": "Increase the risk appetite",
    "choice_d": "Decrease the impact of a successful incident",
    "correct_answer": "A",
    "explanation": "Reducing the exposure of an asset by limiting access through a firewall decreases the likelihood that an external actor will be able to exploit the vulnerability. Threats are external in nature and cannot be eliminated or reduced through the use of controls. Risk appetite is a measure of the organization’s willingness to accept risk and does not change based on the controls Doug implements. Changing firewall exposure reduces the likelihood that an incident will occur but does not reduce the impact of a successful incident.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      51,
      54,
      43,
      50,
      45
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 208,
    "question": "Colleen is a senior director in her organization’s engineering department. The VP of Engineering delegated her the responsibility of making day-to-day access control decisions for product development plans. What term best describes Colleen’s role in relation to this data?",
    "choice_a": "Data owner",
    "choice_b": "Data steward",
    "choice_c": "Data subject",
    "choice_d": "Data custodian",
    "correct_answer": "B",
    "explanation": "In this scenario, the vice president delegated their authority to Colleen, so it is most likely that the vice president is the data owner. The delegation makes Colleen a data steward. In this role, she likely works with the IT teams that manage the data. Those individuals are data custodians. This data is about product development plans and not likely personally identifiable, so there would be no data subjects.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      15,
      4,
      26,
      27,
      2
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 209,
    "question": "Lori recently saw on the news that a country where her organization has a major presence experienced a military coup and is politically unstable. How should this affect the organization’s risk assessment?",
    "choice_a": "The risk assessment should be immediately revised.",
    "choice_b": "The risk assessment should be ignored during the crisis response.",
    "choice_c": "The risk assessment should be revised after the situation stabilizes.",
    "choice_d": "The risk assessment should be revised on the previously determined schedule.",
    "correct_answer": "A",
    "explanation": "Major changes in external risk factors, such as the geopolitical climate, should result in an immediate review and revision of the risk assessment to incorporate the changing state of affairs. This situation clearly qualifies as a major geopolitical change that could impact the organization’s risk profile.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      49,
      43,
      44,
      45,
      54
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 210,
    "question": "Which type of business impact assessment tool is most appropriate when attempting to evaluate the impact of a failure on customer confidence?",
    "choice_a": "Quantitative",
    "choice_b": "Qualitative",
    "choice_c": "Annualized loss expectancy",
    "choice_d": "Reduction",
    "correct_answer": "B",
    "explanation": "Qualitative tools are often used in business impact assessment to capture the impact on intangible factors such as customer confidence, employee morale, and reputation.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      190,
      195,
      192,
      193,
      191
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 211,
    "question": "Russell is concerned about a new hacking group that is targeting his organization. He is performing a risk assessment and wishes to use a technique that identifies the overall risk from that threat. What technique should he use?",
    "choice_a": "Inherent risk",
    "choice_b": "Qualitative assessment",
    "choice_c": "Risk aggregation",
    "choice_d": "Quantitative assessment",
    "correct_answer": "C",
    "explanation": "Risk aggregation looks at all the possible risks related to a single threat vector and assesses them together. While Russell may use quantitative and/or qualitative techniques in his assessment, they do not necessarily identify the overall risk from a single threat unless he uses risk aggregation. Inherent risk is a measure of the risk that exists before an organization applies security controls and is not related to combining risks from a common threat.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      56,
      54,
      43,
      45,
      46
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 212,
    "question": "Which one of the following is the best example of a detective control?",
    "choice_a": "Warning signs",
    "choice_b": "Electrified fences",
    "choice_c": "SIEM",
    "choice_d": "Firewall",
    "correct_answer": "C",
    "explanation": "Security information and event management systems scour log records and other data sources to detect signs of a security incident. Firewalls are preventive controls that are intended block access to a network. Warning signs are deterrent controls that seek to dissuade an attacker from attempting an intrusion. Electrified fences are an example of a preventive control designed to prevent a security incident from occurring in the first place.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      40,
      94,
      113,
      107,
      104
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 213,
    "question": "Which one of the following groups would be <i>least</i> likely to receive updates from an organization’s enterprise risk management program?",
    "choice_a": "Regulators",
    "choice_b": "Senior leaders",
    "choice_c": "Board members",
    "choice_d": "Line managers",
    "correct_answer": "A",
    "explanation": "Risk reporting mechanisms should provide updates to all affected personnel. This would include senior leaders, line managers, and members of the board of directors. An enterprise risk management program would generally not provide routine updates to external parties, such as regulators or law enforcement.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      56,
      57,
      43,
      44,
      50
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 214,
    "question": "Claire is working with other employees in her organization to develop a cybersecurity policy. Which one of the following statements about policy development is <i>not</i> correct?",
    "choice_a": "Meet internal and external requirements.",
    "choice_b": "Obtain input from all relevant stakeholders.",
    "choice_c": "Follow the chain of command.",
    "choice_d": "Try not to deviate from industry standard policy templates.",
    "correct_answer": "D",
    "explanation": "Claire should obtain input from all relevant stakeholders as she develops the policy. She should also craft the policy to meet all requirements, whether they come from internal or external sources and then follow the chain of command to approve her policy. She may use an industry standard template as a starting point, but she can and should customize that template to accommodate her own organization’s culture and requirements.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      77,
      78,
      79,
      32,
      80
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 215,
    "question": "Which one of the following is an example of closed-source threat intelligence?",
    "choice_a": "US-CERT threat advisories",
    "choice_b": "Feed of malicious IP addresses purchased from a vendor",
    "choice_c": "Open Threat Exchange",
    "choice_d": "Vendor threat intelligence blog",
    "correct_answer": "B",
    "explanation": "Closed-source intelligence resources are proprietary and available only to customers of the producer. A feed of malicious IP addresses available for purchase would, therefore, be an example of a closed-source intelligence product. Threat advisories from government agencies (such as US-CERT) or vendors (such as a free vendor blog) are examples of open source intelligence. The Open Threat Exchange is a global community of threat researchers that make their work available as an open source product.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      73,
      76,
      75,
      74,
      69
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 216,
    "question": "Jay is analyzing his organization’s scanning environment and looking for controls that may interfere with scan results. Which one of the following controls is most likely to disrupt vulnerability scans?",
    "choice_a": "Intrusion prevention system",
    "choice_b": "Full disk encryption",
    "choice_c": "Network encryption",
    "choice_d": "SIEM",
    "correct_answer": "A",
    "explanation": "Intrusion prevention systems may disrupt scans by blocking scan probes before they reach the target system. The use of encryption on servers or networks will not interfere with scanning systems, and the use of a SIEM to log and correlate activity also poses no risk to the scan results.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      123,
      97,
      99,
      35,
      107
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 217,
    "question": "What type of disaster recovery test activates the alternate processing facility and uses it to conduct transactions but leaves the primary site up and running?",
    "choice_a": "Checklist review",
    "choice_b": "Full interruption test",
    "choice_c": "Parallel test",
    "choice_d": "Tabletop exercise",
    "correct_answer": "C",
    "explanation": "During a parallel test, the team actually activates the disaster recovery site for testing but the primary site remains operational. During a full interruption test, the team takes down the primary site and confirms that the disaster recovery site is capable of handling regular operations. The full interruption test is the most thorough test but also the most disruptive. The checklist review is the least disruptive type of disaster recovery test. During a checklist review, team members each review the contents of their disaster recovery checklists on their own and suggest any necessary changes. During a tabletop exercise, team members come together and walk through a scenario without making any changes to information systems.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      226,
      217,
      225,
      224,
      219
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 218,
    "question": "Yolanda was asked to provide a brief update on cybersecurity risks to the board of directors in written form. Which one of the following tools would be most appropriate for sharing with this audience?",
    "choice_a": "Business impact assessment",
    "choice_b": "Risk register",
    "choice_c": "Risk matrix",
    "choice_d": "Vulnerability report",
    "correct_answer": "C",
    "explanation": "The board is a very senior audience and should receive an executive summary that does not include too much detail. This approach quickly summarizes risks and allows senior leaders to quickly focus on the most significant risks facing the organization and how those risks might impact organizational goals and objectives. The risk register, business impact assessment, and vulnerability report would all provide far more information than the board needs and is likely to lose their attention.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      56,
      54,
      50,
      59,
      49
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 219,
    "question": "Carl is working to integrate cybersecurity into his organization’s project management process. Which one of the following represents the earliest stage at which cybersecurity should be addressed during a project?",
    "choice_a": "Project execution",
    "choice_b": "Project initiation and planning",
    "choice_c": "Project design",
    "choice_d": "Project maintenance",
    "correct_answer": "B",
    "explanation": "Cybersecurity should be introduced at all stages of the project management process. Therefore, the correct answer to this question is simply the project management stage that occurs first. Project initiation and planning is the first step of the process, and it occurs before design, execution, and maintenance phases.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      10,
      27,
      14,
      2,
      4
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 220,
    "question": "Vivian recently completed a review of her organization’s business continuity and disaster recovery plans. During the review, she encountered the following statement: “In the event that our storage system fails, we must be able to recover all files modified 60 minutes or more prior to the failure. Files modified in the 60 minutes leading up to the failure should be recovered if possible but are an acceptable loss.” What type of statement is this?",
    "choice_a": "MTA",
    "choice_b": "RPO",
    "choice_c": "RTO",
    "choice_d": "SLA",
    "correct_answer": "B",
    "explanation": "The recovery point objective (RPO) is the amount of acceptable data loss in the event of a disaster, expressed as the period of time from which data may be lost. The recovery time objective (RTO) is the amount of time that may elapse between when a system fails and when it is recovered before causing substantial harm to the business. The service level agreement (SLA) is an agreement between a vendor and a customer regarding technology services. Mail transfer agents (MTAs) are a component of email infrastructure and are not related to disaster recovery.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      191,
      185,
      201,
      223,
      226
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 221,
    "question": "Which one of the following statements is true about social media in the wake of a cybersecurity incident?",
    "choice_a": "Social media use should be prohibited for incident response team members.",
    "choice_b": "Management should always issue regular updates on social media.",
    "choice_c": "Social media provides a good means of communication for team members during an incident.",
    "choice_d": "Customers and other stakeholders are likely to discuss incidents on social media.",
    "correct_answer": "D",
    "explanation": "Incident responders must be aware of the impact of social media, regardless of whether they use it directly. Even if your organization does not directly discuss cybersecurity issues on social media, rest assured that your customers and other stakeholders will. Management may, but does not have to, provide updates on social media. Social media is not an effective communications mechanism for internal conversations, as it is not secure, but it is not reasonable for the organization to issue a complete ban on social media use.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      216,
      168,
      169,
      208,
      166
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 222,
    "question": "Rob’s organization uses a fiscal year budgeting system with the fiscal year beginning on July 1. He is planning for an expense that will occur in August 2024. During what fiscal year and calendar year will this expense occur?",
    "choice_a": "CY24 and FY25",
    "choice_b": "CY24 and FY24",
    "choice_c": "CY25 and FY24",
    "choice_d": "CY25 and FY25",
    "correct_answer": "A",
    "explanation": "Rob’s organization uses a fiscal year beginning on July 1. This means that the fiscal year will be one year ahead of the calendar year during the months July through December. August 2024 is a month during calendar year 2024 and, because it is after the fiscal year changes, fiscal year 2025.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      38
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 223,
    "question": "Which one of the following individuals would be the most effective organizational owner for an information security program?",
    "choice_a": "CISM-certified analyst",
    "choice_b": "Chief information officer (CIO)",
    "choice_c": "Director of networking and infrastructure",
    "choice_d": "President and CEO",
    "correct_answer": "B",
    "explanation": "The owner of information security programs may be different from the individuals responsible for implementing the controls. This person should be as senior an individual as possible who is able to focus on the management of the security program. The president and CEO would not be an appropriate choice because an executive at this level is unlikely to have the time necessary to focus on security. Of the remaining choices, the CIO is the most senior position who would be the strongest advocate at the executive level.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      27,
      2,
      4,
      26
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 224,
    "question": "Which cloud computing deployment model requires the use of a unifying technology platform to tie together components from different providers?",
    "choice_a": "Community cloud",
    "choice_b": "Hybrid cloud",
    "choice_c": "Public cloud",
    "choice_d": "Private cloud",
    "correct_answer": "B",
    "explanation": "Hybrid cloud environments blend elements of public, private, and/or community cloud solutions. A hybrid cloud requires the use of technology that unifies the different cloud offerings into a single, coherent platform.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      129,
      128,
      130,
      133,
      135
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 225,
    "question": "What incident response activity focuses on removing any artifacts of the incident that may remain on the organization’s network?",
    "choice_a": "Eradication",
    "choice_b": "Containment",
    "choice_c": "Recovery",
    "choice_d": "Post-incident activities",
    "correct_answer": "A",
    "explanation": "The primary purpose of eradication is to remove any of the artifacts of the incident that may remain on the organization’s network. This may include the removal of any malicious code from the network, the sanitization of compromised media, and the securing of compromised user accounts.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      162,
      157,
      160,
      164,
      165
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 226,
    "question": "After observing an attacker, Alice decides to remove the Internet connection entirely, leaving the systems running but inaccessible from outside the quarantine VLAN. What strategy is she now pursuing?",
    "choice_a": "Containment",
    "choice_b": "Eradication",
    "choice_c": "Removal",
    "choice_d": "Segmentation",
    "correct_answer": "C",
    "explanation": "In the removal approach, Alice keeps the systems running for forensic purposes but completely cuts off their access to or from other networks, including the Internet.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      160,
      167,
      182,
      178,
      166
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 227,
    "question": "Madison is reviewing her organization’s vendor management processes and would like to ensure that a new risk assessment is conducted each time that the organization enters into an agreement with a new vendor or renews an agreement with an existing vendor. What department would likely be the best positioned to assist her with this task?",
    "choice_a": "Procurement",
    "choice_b": "Human Resources",
    "choice_c": "Project Management",
    "choice_d": "Finance",
    "correct_answer": "A",
    "explanation": "Any new or renewing relationship with a vendor should include a formal risk assessment that identifies potential risks associated with the relationship and implements appropriate risk treatments before moving forward. The Procurement department in an organization brings new vendors and systems into the organization and would, therefore, be best positioned to assist Madison.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      90,
      91,
      35,
      80,
      79
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 228,
    "question": "Tyler would like to conduct a disaster recovery test and wants to use the most rigorous testing method possible that does not pose a significant risk of disrupting normal business operations. What type of test should Tyler conduct?",
    "choice_a": "Structured walkthrough",
    "choice_b": "Checklist review",
    "choice_c": "Parallel test",
    "choice_d": "Full interruption test",
    "correct_answer": "C",
    "explanation": "Parallel tests are a very effective test mechanism as they activate the disaster recovery site. They are not as effective as full interruption tests, but they do not have the risk of business disruption associated with a full interruption test. The full interruption test is the most effective way to test an organization’s disaster recovery capabilities as it simulates a real disaster. However, it is also the most dangerous type of test because it could disrupt operations if it fails. Structured walk-throughs provide the organization with important insight into their disaster recovery capabilities, but they are not as effective as full interruption or parallel tests. During a checklist review, individuals review their disaster recovery responsibilities and provide input on the plan, but they do not gain the real-world practical test results that you would gain from a parallel or full interruption test.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      226,
      183,
      225,
      221,
      224
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 229,
    "question": "Andrea is conducting a penetration test and is considering attacking systems belonging to a subsidiary of the target organization in an attempt to gain access. She is unsure whether this is permitted. What document should she consult to determine if this is acceptable activity?",
    "choice_a": "Contract",
    "choice_b": "Statement of work",
    "choice_c": "Lessons learned report",
    "choice_d": "Rules of engagement",
    "correct_answer": "D",
    "explanation": "The rules of engagement provide technical details about the parameters of the test. This level of detail would not normally be found in a contract or statement of work. The lessons learned report is not produced until after the test.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      29,
      30,
      31,
      4,
      27
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 230,
    "question": "Howie is conducting a quantitative risk analysis for the threat posed to his organization by a ransomware attack. As part of his assessment, he identifies that there is a 15 percent chance that a successful attack will take place in a given year. What risk assessment metric has he computed?",
    "choice_a": "EF",
    "choice_b": "ARO",
    "choice_c": "ALE",
    "choice_d": "SLE",
    "correct_answer": "B",
    "explanation": "The likelihood that an event will occur in a given year is the annualized rate of occurrence (ARO). The exposure factor (EF) is the portion of an asset that will likely be damaged by a risk. The single loss expectancy (SLE) is the amount of damage (in financial terms) expected each time a risk occurs, while the annualized loss expectancy (ALE) is the amount of damage expected in a given year from that risk.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      46,
      45,
      54,
      50,
      56
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 231,
    "question": "Loraine is conducting a post-incident review after a breach of her organization’s information security controls. Which one of the following actions is not normally part of a post-incident review?",
    "choice_a": "Determine the root cause of the incident.",
    "choice_b": "Reassess risks.",
    "choice_c": "Take appropriate remedial actions.",
    "choice_d": "Punish those responsible for the incident.",
    "correct_answer": "D",
    "explanation": "Organizations should conduct post-incident reviews that determine the root cause of information security incidents, develop corrective actions, reassess risk, evaluate response effectiveness, and take appropriate remedial actions. Punishment should not generally be used as a response because it may intimidate employees and cause them to be less helpful in future post-incident reviews.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      165,
      227,
      162,
      181,
      183
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 51,
    "question": "What security control can be used to clearly communicate to users the level of protection required for different data types?",
    "choice_a": "Classification policies",
    "choice_b": "Retention standards",
    "choice_c": "Lifecycle practices",
    "choice_d": "Compensating controls",
    "correct_answer": "A",
    "explanation": "Classification policies create different categories of data used within an organization and then specify the level of security control required for each classification level. Using classifications helps users understand the type of protection necessary for each data type they encounter.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      63,
      32,
      79,
      77,
      35
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 233,
    "question": "Brooke is measuring the time that the organization takes to remediate security vulnerabilities. She provides management with a weekly report showing the most recent data as well as the long-term trend. Management has set a goal of addressing all serious vulnerabilities within 7 days and Brooke is measuring whether this goal is satisfied. What term best describes this type of metric?",
    "choice_a": "KGI",
    "choice_b": "KRI",
    "choice_c": "KPI",
    "choice_d": "KMI",
    "correct_answer": "A",
    "explanation": "Key goal indicators (KGIs) are similar to KPIs but measure progress toward defined goals. Because Brooke is measuring performance against a goal set by management, this is an example of a KGI. Key performance indicators (KPIs) are metrics that demonstrate the success of the security program in achieving its objectives. KPIs are mutually agreed-upon measures that evaluate whether a security program is meeting its defined goals. Generally speaking, KPIs are a look backward at historical performance, providing a measuring stick to evaluate the past success of the program. Key risk indicators (KRIs) are measures that seek to quantify the security risk facing an organization. KRIs, unlike KPIs and KGIs, are a look forward. They attempt to show how much risk exists that may jeopardize the future security of the organization. KMIs are not a standard metric for cybersecurity programs.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      81,
      83,
      80,
      79,
      39
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 234,
    "question": "What would be a valid argument for not immediately removing power from a machine when an incident is discovered?",
    "choice_a": "There is no other system that can replace this one if it is turned off.",
    "choice_b": "The damage has been done. Turning the machine off would not stop additional damage.",
    "choice_c": "Valuable evidence in memory will be lost.",
    "choice_d": "Too many users are logged in and using the system.",
    "correct_answer": "C",
    "explanation": "The most compelling reason for not removing power from a machine is that you will lose the contents of memory. Carefully consider the pros and cons of removing power. After all is considered, it may be the best choice.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      161,
      160,
      163,
      162,
      178
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 235,
    "question": "Candace is designing a backup strategy for her organization’s file server. She would like to perform a backup every weekday that has the smallest possible storage footprint. What type of backup should she perform?",
    "choice_a": "Full backup",
    "choice_b": "Incremental backup",
    "choice_c": "Differential backup",
    "choice_d": "Transaction log backup",
    "correct_answer": "B",
    "explanation": "Incremental backups provide the option that includes the smallest amount of data. In this case, that would be only the data modified since the most recent incremental backup. A differential backup would back up all data modified since the last full backup, which would be a substantial amount. The full backup would include all information on the server. Transaction log backups are specifically designed to support database servers and would not be effective on a file server.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      223,
      184,
      185,
      201,
      225
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 236,
    "question": "Jackie is concerned that her organization’s vulnerability scanning program might interfere with the operation of production systems. She would like to conduct the scans without installing any software on the systems that will be scanned. What type of scan should she <i>avoid</i>?",
    "choice_a": "Server-based scans",
    "choice_b": "Agent-based scans",
    "choice_c": "Credentialed scans",
    "choice_d": "Noncredentialed scans",
    "correct_answer": "B",
    "explanation": "Agent-based scans require installing scanning agents on the systems to be scanned, whereas server-based scans run using software on the scanning server. Alice wants to avoid installing any software, so she should stick with a server-based scan. These scans may be run in either credentialed or noncredentialed mode.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      100,
      101,
      99,
      103,
      97
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 237,
    "question": "Roger recently accepted a new position as a security professional at a company that runs its entire IT infrastructure within an IaaS environment. Which one of the following would most likely be the responsibility of Roger’s firm?",
    "choice_a": "Patching operating systems",
    "choice_b": "Configuring the network firewall",
    "choice_c": "Wiping drives prior to disposal",
    "choice_d": "Applying hypervisor updates",
    "correct_answer": "A",
    "explanation": "In an infrastructure as a service environment, the vendor is responsible for hardware- and network-related responsibilities. These include configuring network firewalls, maintaining the hypervisor, and managing physical equipment. The customer retains responsibility for patching operating systems on its virtual machine instances.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      131,
      128,
      132,
      126,
      90
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 238,
    "question": "Renee is designing the long-term security plan for her organization and has a three- to five-year planning horizon. Her primary goal is to align the security function with the broader plans and objectives of the business. What type of plan is she developing?",
    "choice_a": "Strategic",
    "choice_b": "Operational",
    "choice_c": "Tactical",
    "choice_d": "Summary",
    "correct_answer": "A",
    "explanation": "Strategic plans have a long-term planning horizon of up to five years in most cases. They are designed to strategically align the security function with the business’ objectives. Operational and tactical plans have shorter horizons of a year or less.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      10,
      27,
      13,
      14,
      12
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 239,
    "question": "Seamus is conducting a business impact assessment for his organization to determine the risk associated with a denial-of-service attack against his organization’s data center. He consulted with subject matter experts and determined that the attack would not cause any permanent damage to equipment, applications, or data. The primary damage would come in the form of lost revenue. Seamus believes that the organization could lose $75,000 in revenue during a successful attack. Seamus also consulted with his threat management vendor, who considered the probability of a successful attack against his organization and determined that there is a 10 percent chance of a successful attack in the next 12 months. What is the SLE in this scenario?",
    "choice_a": "$625",
    "choice_b": "$7,500",
    "choice_c": "$75,000",
    "choice_d": "$6,250",
    "correct_answer": "C",
    "explanation": "The single loss expectancy (SLE) is the amount of damage expected to occur as the result of a single successful attack. In this case, the scenario provides this information as $75,000.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      46,
      45,
      59,
      50,
      54
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 505,
    "question": "Vincent is the CISO of the organization shown in the diagram below. The numbers in parentheses indicate the number of members on each team. Which of the following individuals have an optimal span of control?<br><img src=\"/question_assets/CISM/801931_Practice_Exam_2_image2.png\"/>",
    "choice_a": "Director of Policy and Compliance",
    "choice_b": "Director of Security Operations",
    "choice_c": "Director of Incident Response",
    "choice_d": "Director of Security Engineering",
    "correct_answer": "D",
    "explanation": "The optimal span of control for a manager is to have between five and ten direct reports. The Director of Security Engineering has 7, which is in the optimal range. The Director of Security Operations has 16, which is likely too large, indicating that this position might benefit from being split in two. The Directors of Incident Response and Policy/Compliance have small spans of control, indicating that these positions might benefit from aggregation.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      2,
      3,
      27,
      4,
      26
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 241,
    "question": "What type of risk has an acceptable level determined by management discretion?",
    "choice_a": "Controlled risk",
    "choice_b": "Inherent risk",
    "choice_c": "Residual risk",
    "choice_d": "Appropriated risk",
    "correct_answer": "C",
    "explanation": "Residual risk is the amount of risk that remains after the organization implements security controls. The acceptable level of management risk is determined by management discretion. Inherent risk is a measure of the risk that exists before an organization applies security controls and is outside the control of management. Controlled risk and appropriated risk are not terms commonly used in risk assessment.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      54,
      50,
      52,
      51,
      55
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 242,
    "question": "Which one of the following categories best describes information protected by HIPAA?",
    "choice_a": "SPI",
    "choice_b": "PCI",
    "choice_c": "PII",
    "choice_d": "PHI",
    "correct_answer": "D",
    "explanation": "The Health Insurance Portability and Accountability Act (HIPAA) mandates the safeguarding of protected health information (PHI). Sensitive personal information (SPI) and personally identifiable information (PII) may fall under HIPAA but do not necessarily do so. Payment card information (PCI) is covered by PCI DSS.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      37,
      9,
      22,
      25,
      8
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 243,
    "question": "Staff from Susan’s company often travel internationally. Susan believes that they may be targeted for corporate espionage activities because of the technologies that her company is developing and wishes to include advice in the security training provided to international travelers. What practice should Susan recommend that they adopt for connecting to networks while they travel?",
    "choice_a": "Do not connect to networks while traveling",
    "choice_b": "Only connect to public Wi-Fi",
    "choice_c": "Only use websites that support TLS",
    "choice_d": "Use a VPN for all connections",
    "correct_answer": "D",
    "explanation": "While it may be tempting to tell her staff to simply not connect to any network, Susan knows that they will need connectivity to do their work. Using a VPN to connect their laptops and mobile devices to a trusted network and ensuring that all traffic is tunneled through the VPN is her best bet to secure their Internet usage. Susan may also want to ensure that they take “clean” laptops and devices that do not contain sensitive information or documents and that those systems are fully wiped and reviewed when they return.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      122,
      35,
      64,
      32,
      85
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 244,
    "question": "Florian is building a disaster recovery plan for his organization and would like to determine the amount of time that a particular IT service may be down without causing serious damage to business operations. What variable is Florian calculating?",
    "choice_a": "RTO",
    "choice_b": "MTD",
    "choice_c": "RPO",
    "choice_d": "SLA",
    "correct_answer": "B",
    "explanation": "The maximum tolerable downtime (MTD) is the longest amount of time that an IT service or component may be unavailable without causing serious damage to the organization. The recovery time objective (RTO) is the amount of time expected to return an IT service or component to operation after a failure. The recovery point objective (RPO) identifies the maximum amount of data, measured in time, that may be lost during a recovery effort. Service level agreements (SLAs) are written contracts that document service expectations.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      191,
      197,
      203,
      221,
      228
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 245,
    "question": "What process ensures that every aspect of an organization’s work aligns with the organization’s strategy and goals?",
    "choice_a": "Assurance and testing",
    "choice_b": "Internal audit",
    "choice_c": "External audit",
    "choice_d": "Corporate governance",
    "correct_answer": "D",
    "explanation": "Governance efforts function at all layers of an organization to coordinate the development and execution of strategic plans. This ensures that every aspect of an organization’s work aligns with the organization’s strategy and goals.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      27,
      26,
      36,
      2,
      17
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 246,
    "question": "Which one of the following is commonly used to evaluate the success of an information security program most directly?",
    "choice_a": "Strategies",
    "choice_b": "Policies",
    "choice_c": "Metrics",
    "choice_d": "Vulnerability count",
    "correct_answer": "C",
    "explanation": "Metrics provide quantitative measures of the success of an information security program. Compliance with policies may be a component of a security program evaluation but the evaluation should be guided by concrete metrics. Security strategies may be a component of a security program evaluation, but the evaluation should be guided by concrete metrics. A vulnerability assessment may be a component of a security program evaluation, but the evaluation should be guided by concrete metrics.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      81,
      83,
      82,
      77,
      40
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 247,
    "question": "Andrew is working with his financial team to purchase a cybersecurity insurance policy to cover the financial impact of a data breach. What type of risk management strategy is he using?",
    "choice_a": "Risk transference",
    "choice_b": "Risk avoidance",
    "choice_c": "Risk acceptance",
    "choice_d": "Risk mitigation",
    "correct_answer": "A",
    "explanation": "Purchasing insurance is the most common example of risk transference—shifting liability to a third party.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      53,
      50,
      52,
      51,
      54
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 506,
    "question": "The Domer Industries risk assessment team recently conducted a qualitative risk assessment and developed a matrix similar to the one shown here. Which quadrant contains the risks that require the most immediate attention?<br><img src=\"/question_assets/CISM/801931_Practice_Exam_2_image3.png\"/>",
    "choice_a": "III",
    "choice_b": "II",
    "choice_c": "I",
    "choice_d": "IV",
    "correct_answer": "C",
    "explanation": "The risk assessment team should pay the most immediate attention to those risks that appear in quadrant I. These are the risks with a high probability of occurring and a high impact on the organization if they do occur.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      45,
      47,
      56,
      50,
      54
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 249,
    "question": "Harold recently completed leading the postmortem review of a security incident. What documentation should he prepare next?",
    "choice_a": "Lessons-learned document",
    "choice_b": "Risk assessment",
    "choice_c": "Remediation list",
    "choice_d": "Mitigation checklist",
    "correct_answer": "A",
    "explanation": "A lessons-learned document is often created and distributed to involved parties after a postmortem review to ensure that those who were involved in the incident and others who may benefit from the knowledge are aware of what they can do to prevent future issues and to improve response in the event that one occurs.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      165,
      166,
      227,
      157,
      168
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 250,
    "question": "Kayla is preparing to testify in court about an attack waged against her organization. She understands that the material she is presenting is complex and is preparing a diagram of the attack to bring into court to help explain the concept. What term best describes the chart she is preparing?",
    "choice_a": "Testimonial evidence",
    "choice_b": "Real evidence",
    "choice_c": "Demonstrative evidence",
    "choice_d": "Documentary evidence",
    "correct_answer": "C",
    "explanation": "Kayla will be providing testimonial evidence when she is in court. The diagram that she will use to support this testimony is best classified as demonstrative evidence. It is not real or documentary evidence because it is not being used as proof itself, but rather to illustrate a concept.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      30,
      36,
      31,
      4,
      26
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 251,
    "question": "Which one of the following organizations is most likely to sponsor an APT attack?",
    "choice_a": "Nation-state",
    "choice_b": "Script kiddie",
    "choice_c": "Multinational corporation",
    "choice_d": "Small business",
    "correct_answer": "A",
    "explanation": "Advanced persistent threat (APT) attackers are well funded and well resourced. These threats almost always come from nation-states with government/military backing and funding.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      69,
      66,
      68,
      73,
      74
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 252,
    "question": "What international standard provides a consistent set of security objectives for information technology and is published by ISACA?",
    "choice_a": "COBIT",
    "choice_b": "ITIL",
    "choice_c": "ISO 27001",
    "choice_d": "SP 800-53",
    "correct_answer": "A",
    "explanation": "The Control Objectives for Information Technology (COBIT) provide security-related objectives and is published by ISACA. ISO 27001 does provide security objectives, but it is published by the International Organization for Standardization. SP 800-53 does provide information security guidance, but it is published by the National Institute for Standards and Technology (NIST). The IT Infrastructure Library (ITIL) is focused on IT service management. It does contain some security information, but it is published by AXELOS.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      38,
      22,
      12,
      27,
      36
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 253,
    "question": "Which data processing role in an organization is most likely to grant users access to information on a day-to-day basis?",
    "choice_a": "Business owners",
    "choice_b": "Data stewards",
    "choice_c": "Data owners",
    "choice_d": "Data processors",
    "correct_answer": "B",
    "explanation": "Data stewards carry out most of the operational responsibilities related to data management and would be the most likely to approve access requests. They have authority delegated to them by business and data owners. Data processors are required to perform specific actions under regulations like the EU GDPR.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      15,
      4,
      19,
      27,
      36
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 254,
    "question": "Who selects the members of the board of directors of a publicly traded corporation?",
    "choice_a": "President",
    "choice_b": "General public",
    "choice_c": "Shareholders",
    "choice_d": "Board chairperson",
    "correct_answer": "C",
    "explanation": "The shareholders of a company have the power to elect the members of its board of directors. The president is selected by the board of directors and does not choose the directors. The board chair leads the board of directors but does not elect the board’s members. The general public has no input into the composition of the board of directors of a publicly traded company.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      26,
      27,
      3,
      4,
      15
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 255,
    "question": "Brian recently verified that the cash registers in his retail stores are printing only the last four digits of credit card numbers on receipts, replacing all the other digits with asterisks. The receipt does contain the customer’s name and signature. What type of control has he implemented?",
    "choice_a": "Deidentification",
    "choice_b": "Purging",
    "choice_c": "Tokenization",
    "choice_d": "Masking",
    "correct_answer": "D",
    "explanation": "This is an example of data masking, removing enough digits from sensitive information to render it nonsensitive. Tokenization would replace the existing number with an unrelated number. Purging would remove the data completely. The data is not deidentified because the customer’s name appears on the receipt.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      64,
      62,
      63,
      40,
      118
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 256,
    "question": "Evan is the budget manager for a cybersecurity team at a large publicly traded company. During their strategic planning session, the team determines that a new position they were scheduled to hire is no longer needed to meet the team’s strategic goals. Without any other information, what should Evan do with this excess funding?",
    "choice_a": "Reallocate it to other security needs",
    "choice_b": "Return it to the business",
    "choice_c": "Reallocate it within the technology organization",
    "choice_d": "Provide it to the CISO for use as a discretionary fund",
    "correct_answer": "B",
    "explanation": "If Evan’s team does not need these funds for their budgeted purpose, they should return them to the business for reallocation. Leaders may then determine whether they are reinvested in another area of cybersecurity or another area of the business, or are distributed to shareholders as profit.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      2,
      27,
      10,
      26,
      28
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 257,
    "question": "As the CIO of a large organization, Clara would like to adopt standard processes for managing IT activities. Which one of the following frameworks focuses on IT service management and includes topics such as change management, configuration management, and service level agreements?",
    "choice_a": "PMBOK",
    "choice_b": "ITIL",
    "choice_c": "PCI DSS",
    "choice_d": "TOGAF",
    "correct_answer": "B",
    "explanation": "The IT Infrastructure Library (ITIL) framework focuses on IT service management. The Project Management Body of Knowledge (PMBOK©) provides a common core of project management expertise. The Payment Card Industry Data Security Standard (PCI DSS) contains regulations for credit card security. The Open Group Architecture Framework (TOGAF) focuses on IT architecture issues.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      29,
      38,
      27,
      36,
      30
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 258,
    "question": "Tammy is considering using a new service provider and would like to review the results of an audit conducted under SSAE 18. She would like to ensure that the auditors tested the effectiveness of the controls used by the provider over an extended period of time. She is willing to sign an NDA to access the report. What type of report would provide her with the most detailed and relevant information?",
    "choice_a": "SOC 1 Type II",
    "choice_b": "SOC 3 Type I",
    "choice_c": "SOC 3 Type II",
    "choice_d": "SOC 2 Type II",
    "correct_answer": "D",
    "explanation": "SOC 2 and SOC 3 reports both cover security controls. SOC 1 reports cover controls over financial reporting, which would not likely be relevant for Tammy. SOC 2 reports contain more detail and are generally released only under NDA. Type I reports cover only a snapshot in time, whereas Type II reports cover an extended period of time. Therefore, an SOC 2 Type II report would provide Tammy with the best possible information.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      42,
      91,
      90,
      135,
      96
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 259,
    "question": "Which one of the following classification levels is <i>least</i> likely to be used in a business setting?",
    "choice_a": "Sensitive",
    "choice_b": "Top Secret",
    "choice_c": "Internal",
    "choice_d": "Public",
    "correct_answer": "B",
    "explanation": "The Top Secret classification level comes from the U.S. government classification scheme and this terminology would not likely be used in a typical business setting. Businesses generally use schemes that contain levels including Highly Sensitive, Sensitive, Internal, and Public.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      63,
      62,
      32,
      79,
      35
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 260,
    "question": "Norm is using full-disk encryption technology to protect the contents of laptops against theft. What goal of cryptography is he attempting to achieve?",
    "choice_a": "Nonrepudiation",
    "choice_b": "Integrity",
    "choice_c": "Availability",
    "choice_d": "Confidentiality",
    "correct_answer": "D",
    "explanation": "Norm’s actions are designed to protect against the unauthorized disclosure of sensitive information. This is a clear example of protecting confidentiality.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      136,
      143,
      138,
      137,
      144
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 261,
    "question": "Which one of the following actions should be the primary goal of an organization’s information security program?",
    "choice_a": "Implement the organization’s security strategy.",
    "choice_b": "Block unwanted network connections",
    "choice_c": "Minimize disruptions to business activity.",
    "choice_d": "Identify intrusion attempts.",
    "correct_answer": "A",
    "explanation": "The primary goal of an information security program is to implement the organization’s security strategy. While an organization’s security program may include controls that identify intrusion attempts, minimize disruptions to business activity, and block undesirable network connections, the primary objective of the program is to implement the organization’s security strategy.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      10,
      27,
      17,
      13,
      22
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 262,
    "question": "Which one of the following data elements would not normally be included in an evidence log?",
    "choice_a": "Serial number",
    "choice_b": "Malware signatures",
    "choice_c": "Record of handling",
    "choice_d": "Storage location",
    "correct_answer": "B",
    "explanation": "Malware signatures would not normally be included in an evidence log. The log would typically contain identifying information (such as the location, serial number, model number, hostname, MAC addresses, and IP addresses of a computer); the name, title, and phone number of each individual who collected or handled the evidence during the investigation; the time and date (including time zone) of each occurrence of evidence handling; and the locations where the evidence was stored.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      163,
      178,
      179,
      182,
      166
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 263,
    "question": "Which one of the following security documents can best be described as a plan to meet security objectives in the future?",
    "choice_a": "Security strategy",
    "choice_b": "Threat assessment",
    "choice_c": "Vulnerability assessment",
    "choice_d": "Security policy",
    "correct_answer": "A",
    "explanation": "The security strategy outlines a plan designed to meet defined security objectives. A threat assessment describes the threat environment facing an organization and does not include plans for meeting security objectives. A vulnerability assessment describes the vulnerabilities that exist in an organization’s technology environment. An organization’s security policy outlines management expectations for security.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      10,
      13,
      17,
      14,
      11
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 264,
    "question": "Brianne is assessing her organization’s cybersecurity program under the CMMI maturity model. She determines that the organization has consistent, repeatable processes that it adapts to the needs of each project. What stage of the CMMI best describes her program?",
    "choice_a": "Defined",
    "choice_b": "Managed",
    "choice_c": "Quantitatively Managed",
    "choice_d": "Optimizing",
    "correct_answer": "A",
    "explanation": "Organizations at Level 3: Defined have standard processes that are used organization-wide and are adapted for use within each project. When an organization is at Level 2: Managed, it has begun to implement organized processes on a per-project basis but is still operating in reactive mode. Level 4: Quantitatively Managed organizations build measurement and controls on top of their processes to allow them to quickly identify and remediate deficiencies and address control gaps before issues arise. At the top tier of the CMMI, Level 5: Optimizing organizations use a continuous process improvement approach to adjust and fine-tune the way that they work to achieve peak efficiency and effectiveness.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      40,
      39,
      81,
      79,
      83
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 265,
    "question": "Kevin would like to ensure that his software runs on a platform that is able to expand and contract as needs change. Which one of the following terms best describes his goal?",
    "choice_a": "Elasticity",
    "choice_b": "Scalability",
    "choice_c": "Cost effectiveness",
    "choice_d": "Agility",
    "correct_answer": "A",
    "explanation": "This approach will let Kevin take advantage of all these features. However, the situation described in the scenario, expanding capacity when demand spikes and then reducing that capacity when demand falls again, is the definition of elasticity.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      126,
      127,
      128,
      147,
      148
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 266,
    "question": "Sonia would like to upgrade her organization’s intrusion prevention system but is having difficulty obtaining the necessary funding. The organization is investing in other opportunities but does not see the need to invest in cybersecurity. What would be Sonia’s best next step?",
    "choice_a": "Escalate the situation to senior leaders",
    "choice_b": "Write a project plan",
    "choice_c": "Obtain several quotes for the required equipment",
    "choice_d": "Develop a business case",
    "correct_answer": "D",
    "explanation": "Sonia should develop a formal business case that outlines the need for the upgrade and the expected benefits. Using a formal business case helps the organization put the investment in the context of the rest of the organization’s needs. Sonia may need to develop a project plain and obtain quotes as part of this, but those should not be her end goal. The business case may eventually make its way to senior leaders, but Sonia should pursue her case through normal channels first.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      2,
      10,
      17,
      26
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 267,
    "question": "Which one of the following is an example of an information security awareness tool?",
    "choice_a": "Poster",
    "choice_b": "Certification course",
    "choice_c": "Initial security training",
    "choice_d": "Refresher security training",
    "correct_answer": "A",
    "explanation": "Posters are commonly used to raise awareness of security issues. Security certification courses and training programs are in-depth training efforts and are categorized as security education, rather than awareness.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      84,
      82,
      83,
      77,
      78
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 268,
    "question": "Barry is the CIO of an organization that recently suffered a serious operational issue that required activation of the disaster recovery plan. He would like to conduct a lessons-learned session to review the incident. Who would be the best facilitator for this session?",
    "choice_a": "Disaster recovery team leader",
    "choice_b": "Barry, as chief information officer",
    "choice_c": "Chief information security officer",
    "choice_d": "None of these",
    "correct_answer": "D",
    "explanation": "Barry should recruit an independent moderator to facilitate the session. Having a moderator who was not directly involved in the effort encourages honest and open feedback.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      227,
      165,
      187,
      168,
      181
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 269,
    "question": "Vincent would like to digitally sign a message that he is sending to Andrea. What key should he use to create the digital signature?",
    "choice_a": "Vincent’s private key",
    "choice_b": "Vincent’s public key",
    "choice_c": "Andrea’s public key",
    "choice_d": "Andrea’s private key",
    "correct_answer": "A",
    "explanation": "When an individual digitally signs a message, they do so using their own private key. When the recipient verifies the digital signature, they do so using the signer’s public key. Therefore, Vincent should use his own private key to create the signature.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      140,
      138,
      139,
      143,
      141
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 270,
    "question": "Gina recently discovered that a hacking group has been targeting the type of web server used by her organization. How should she handle this information with respect to her organization’s risk assessment?",
    "choice_a": "Only mitigate the risk if it is identified in the risk assessment",
    "choice_b": "Reassess the risk based upon this new threat",
    "choice_c": "Note the presence of the threat for inclusion in the next scheduled risk assessment",
    "choice_d": "Immediately take action to disable the web server to avoid the new threat",
    "correct_answer": "B",
    "explanation": "Gina should incorporate this information into her organization’s risk assessment by performing an update of that assessment now, rather than waiting until the next planned assessment. It would be premature to respond to the risk by disabling the web server without conducting this assessment. It is a crucial responsibility of information security managers to monitor for factors such as this that may require reassessment of risk to ensure that changes are identified and managed appropriately.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      49,
      43,
      44,
      73,
      74
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 271,
    "question": "Phil is conducting a penetration test and has gained access to a target system. The account he has on that system is a standard user account, and Phil is installing a tool that will allow him to gain root access. What term best describes this activity?",
    "choice_a": "Pivoting",
    "choice_b": "Lateral movement",
    "choice_c": "Privilege escalation",
    "choice_d": "Persistence",
    "correct_answer": "C",
    "explanation": "Privilege escalation is the act of increasing the level of access that an attacker has to a system. It is a common exploit to launch after gaining initial access to a system in an attempt to gain administrative access (otherwise known as root or superuser access).",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      67,
      43,
      51,
      66,
      69
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 272,
    "question": "What evidence standard do most civil investigations follow?",
    "choice_a": "Beyond a reasonable doubt",
    "choice_b": "Preponderance of the evidence",
    "choice_c": "Beyond the shadow of a doubt",
    "choice_d": "Clear and convincing evidence",
    "correct_answer": "B",
    "explanation": "Civil investigations typically follow the “preponderance of the evidence” standard.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      37,
      7,
      27,
      14
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 273,
    "question": "Joe would like to determine the appropriate disposition of a flash drive used to gather highly sensitive evidence during an incident response effort. He does not need to reuse the drive but wants to return it to its owner, an outside contractor. What is the appropriate disposition?",
    "choice_a": "Destroy",
    "choice_b": "Clear",
    "choice_c": "Erase",
    "choice_d": "Purge",
    "correct_answer": "A",
    "explanation": "The data disposition flowchart (shown below) directs that any media containing highly sensitive information that will leave the control of the organization must be destroyed. Joe should purchase a new replacement device to provide to the contractor.<br><img src=\"/question_assets/CISM/801931_Practice_Exam_2_image4.png\"/> Source: NIST SP 800-88: Guidelines for Media Sanitization.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      164,
      165,
      182,
      179,
      163
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 274,
    "question": "Yolanda is the chief privacy officer for a financial institution and is researching privacy requirements related to customer checking accounts. Which one of the following laws is most likely to apply to this situation?",
    "choice_a": "HIPAA",
    "choice_b": "SOX",
    "choice_c": "GLBA",
    "choice_d": "FERPA",
    "correct_answer": "C",
    "explanation": "The Gramm–Leach–Bliley Act (GLBA) contains provisions regulating the privacy of customer financial information. It applies specifically to financial institutions. The Sarbanes–Oxley Act (SOX) applies to publicly traded corporations. The Health Insurance Portability and Accountability Act (HIPAA) applies to healthcare providers. The Family Educational Rights and Privacy Act (FERPA) applies to educational institutions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      37,
      14,
      27,
      22,
      9
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 275,
    "question": "What technology uses mathematical algorithms to render information unreadable to those lacking the required key?",
    "choice_a": "Data encryption",
    "choice_b": "Data obfuscation",
    "choice_c": "Data loss prevention",
    "choice_d": "Data minimization",
    "correct_answer": "A",
    "explanation": "Encryption technology uses mathematical algorithms to protect information from prying eyes, both while it is in transit over a network and while it resides on systems. Encrypted data is unintelligible to anyone who does not have access to the appropriate decryption key, making it safe to store and transmit encrypted data over otherwise insecure means.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      136,
      137,
      143,
      138,
      64
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 276,
    "question": "Gwen is conducting a risk assessment of her organization’s privacy practices and would like to use an industry standard set of privacy controls. What standard would best assist her in this assessment?",
    "choice_a": "NIST RMF",
    "choice_b": "ISO 31000",
    "choice_c": "NIST CSF",
    "choice_d": "ISO 27701",
    "correct_answer": "D",
    "explanation": "ISO 27701 contains standard guidance for managing privacy controls and would, therefore, be a helpful resource for Gwen. ISO 31000 provides guidelines for risk management programs. This document is not specific to cybersecurity or privacy but covers risk management in a general way so that it may be applied to any risk. NIST publishes both a Cybersecurity Framework (CSF) and a Risk Management Framework (RMF). The RMF is a formal process for implementing security controls and authorizing system use, whereas the CSF provides a broad structure for cybersecurity controls. Neither addresses privacy specifically.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      40,
      39,
      62,
      63,
      83
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 277,
    "question": "Gary is preparing for an upcoming audit of his organization against a new security standard. In preparation for the audit, he reviews each of the requirements under the standard and compares it to his organization’s current state. He developed a list of items that he would like to remediate before the audit. What type of analysis is Gary performing?",
    "choice_a": "Gap analysis",
    "choice_b": "Threat analysis",
    "choice_c": "SWOT analysis",
    "choice_d": "Conjoint analysis",
    "correct_answer": "A",
    "explanation": "The comparison of an organization’s existing state to an external standard or regulation is a gap analysis. This analysis identifies deficiencies (or “gaps”) between the desired and current states. Threat analysis is used to assess the presence and capabilities of threat actors. SWOT analysis is used to assess an organization’s strengths, weaknesses, opportunities, and threats. Conjoint analysis is a market research technique.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      44,
      50,
      54,
      43,
      48
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 278,
    "question": "Brent is reviewing the controls that will protect his organization in the event of a sustained period of power loss. Which one of the following solutions would best meet his needs?",
    "choice_a": "Uninterruptible power supply (UPS)",
    "choice_b": "Redundant servers",
    "choice_c": "Generator",
    "choice_d": "RAID",
    "correct_answer": "C",
    "explanation": "Generators can provide backup power for a sustained period of time in the event of a power loss, but they take time to activate. An uninterruptible power supply (UPS) provides immediate, battery-driven power for a short period of time to cover momentary losses of power, which would not cover a sustained period of power loss. RAID and redundant servers are high-availability controls, but they do not cover power loss scenarios.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      127,
      126,
      40,
      80,
      95
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 279,
    "question": "The severity of a risk is best identified by assessing both its _______ and its _______.",
    "choice_a": "likelihood; frequency",
    "choice_b": "likelihood; impact",
    "choice_c": "magnitude; impact",
    "choice_d": "classification; likelihood",
    "correct_answer": "B",
    "explanation": "When we evaluate any risk, we do so by using two different factors: likelihood and impact. The first is the likelihood of occurrence, or probability, that the risk will occur. We might express this as the percent chance that a threat will exploit a vulnerability over a specified period of time, such as within the next year. Second is the magnitude of the impact that the risk will have on the organization if it does occur. We might express this as the financial cost that we will incur as the result of a risk, although there are other possible measures.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      45,
      46,
      47,
      56,
      49
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 280,
    "question": "Lynda is disposing of a drive containing sensitive information that was collected during the response to a cybersecurity incident. The information is categorized as a high-security risk, and she wishes to reuse the media during a future incident. What is the appropriate disposition for this information?",
    "choice_a": "Erase",
    "choice_b": "Clear",
    "choice_c": "Purge",
    "choice_d": "Destroy",
    "correct_answer": "C",
    "explanation": "Lynda should consult the flowchart that appears below. Following that chart, the appropriate disposition for media that contains high security risk information and will be reused within the organization is to purge it.<br><img src=\"/question_assets/CISM/801931_Practice_Exam_2_image5.png\"/><br>Source: NIST SP 800-88: Guidelines for Media Sanitization.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      64,
      63,
      145,
      39,
      32
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 281,
    "question": "Carla is preparing to purchase a significant amount of cybersecurity equipment as part of a new network security initiative. What term best describes this type of expense?",
    "choice_a": "Unbudgeted",
    "choice_b": "Operational",
    "choice_c": "Capital",
    "choice_d": "Recurring",
    "correct_answer": "C",
    "explanation": "This is a large purchase of equipment that should be treated as a capital expense. It is not part of routine operations, so it would not be considered an operational expense. The scenario does not indicate whether it is budgeted or unbudgeted, nor does it indicate whether the expense is one-time or recurring.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      28,
      10,
      27,
      2,
      36
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 282,
    "question": "Which one of the following statements about an information security program’s scope statement is not correct?",
    "choice_a": "The scope statement should always apply to the entire organization.",
    "choice_b": "The scope statement should include the security objectives covered by the program.",
    "choice_c": "The scope statement should be written in plain language.",
    "choice_d": "The scope statement should be included in the program charter.",
    "correct_answer": "A",
    "explanation": "The scope statement for a security program should specify the type of security objectives included in the program and the portion of the organization covered by the program. It should be written in plain language and included as a core component of the program charter. Scope statements may cover an entire organization, or they may be narrowly tailored to cover specific business units or functions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      31,
      28,
      36,
      10,
      27
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 283,
    "question": "Which one of the following penetration testing techniques does not involve expanding the scope of a compromise to additional systems?",
    "choice_a": "Privilege escalation",
    "choice_b": "Pivoting",
    "choice_c": "Maneuver",
    "choice_d": "Lateral movement",
    "correct_answer": "A",
    "explanation": "Pivoting, maneuver, and lateral movement are all similar terms that involve moving from one compromised system to compromise other systems on the same network. Privilege escalation is a technique used to expand the access an attacker has to an already compromised system.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      71,
      66,
      69,
      68,
      70
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 284,
    "question": "Renee is conducting an analysis of the potential threat posed to her organization by a data breach. She is concerned that a breach might cause employees, customers, and other stakeholders to lose confidence in the organization. What type of risk best describes Renee’s concern?",
    "choice_a": "Strategic risk",
    "choice_b": "Reputational risk",
    "choice_c": "Financial risk",
    "choice_d": "Operational risk",
    "correct_answer": "B",
    "explanation": "Reputational risk occurs when the negative publicity surrounding a security breach causes the loss of goodwill among customers, employees, suppliers, and other stakeholders. Financial risk is the risk of monetary damage to the organization as the result of a data breach. Strategic risk is the risk that an organization will become less effective in meeting its major goals and objectives as a result of the breach. Operational risk is risk to the organization’s ability to carry out its day-to-day functions. While the breach may affect all of these things, Renee is most concerned about the loss of confidence, which is most accurately described as a reputational risk.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      44,
      45,
      50,
      54,
      56
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 285,
    "question": "James is conducting a risk assessment for his organization and is attempting to assign an asset value to the servers in his data center. The organization’s primary concern is ensuring that it has sufficient funds available to rebuild the data center in the event it is damaged or destroyed. Which one of the following asset valuation methods would be most appropriate in this situation?",
    "choice_a": "Opportunity cost",
    "choice_b": "Purchase cost",
    "choice_c": "Depreciated cost",
    "choice_d": "Replacement cost",
    "correct_answer": "D",
    "explanation": "If the organization’s primary concern is the cost of rebuilding the data center, James should use the replacement cost method to determine the current market price for equivalent servers.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      46,
      45,
      54,
      59,
      57
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 286,
    "question": "Tom recently hired a new team member for his organization’s incident response team. The new team member comes from another organization and has information security experience but has never had incident response duties in the past. What type of training is most appropriate for this situation?",
    "choice_a": "Undergraduate degree",
    "choice_b": "Hands-on experience",
    "choice_c": "Formal incident response training",
    "choice_d": "Awareness",
    "correct_answer": "C",
    "explanation": "A new team member with no prior incident response experience should almost always receive formal training before beginning incident response duties. While hands-on experience is a very effective learning tool, it should generally only be used to supplement formal training programs. Awareness programs are designed to increase employee awareness of information security issues and should not be relied upon for the professional education of security team members. While an undergraduate degree in information security or a related field does provide very effective education, it is not practical to put a new employee through a degree program prior to beginning work.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      183,
      158,
      169,
      168,
      165
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 287,
    "question": "Rolando is a risk manager with a large-scale enterprise. The firm recently evaluated the risk of California mudslides on its operations in the region and determined that the cost of responding outweighed the benefits of any controls it could implement. The company chose to take no action at this time. What risk management strategy did Rolando’s organization pursue?",
    "choice_a": "Risk mitigation",
    "choice_b": "Risk avoidance",
    "choice_c": "Risk acceptance",
    "choice_d": "Risk transference",
    "correct_answer": "C",
    "explanation": "In a risk acceptance strategy, the organization decides that taking no action is the most beneficial route to managing a risk.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      50,
      52,
      45,
      56,
      49
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 288,
    "question": "Jan is a new CISO and is seeking a framework that will help her select a comprehensive set of objectives for her organization’s security program. Which one of the following documents would best assist her in this work?",
    "choice_a": "ISO 27001",
    "choice_b": "CCPA",
    "choice_c": "HIPAA",
    "choice_d": "GAPP",
    "correct_answer": "A",
    "explanation": "Jan should use a framework to help guide the objectives for her program. Common frameworks for cybersecurity programs include the Control Objectives for Information Technology (COBIT) and ISO 27001. The Health Insurance Portability and Accountability Act (HIPAA) and the California Consumer Privacy Act (CCPA) are regulations affecting cybersecurity and should be addressed by the objectives but do not provide a comprehensive set of objectives. The Generally Accepted Privacy Principles (GAPP) are a framework for designing a privacy program, rather than a security program.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      38,
      12,
      22,
      10,
      27
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 289,
    "question": "Darcy’s Doodles is a publicly traded corporation that is overseen by a board of directors consisting of 12 members. The CEO holds one of the seats on the board. Under industry best practices, what is the minimum acceptable number of independent directors?",
    "choice_a": "7",
    "choice_b": "6",
    "choice_c": "5",
    "choice_d": "2",
    "correct_answer": "A",
    "explanation": "Industry best practices dictate that the board consist of a majority of independent directors. The board currently has 12 seats, meaning that at least 7 of those individuals should be independent directors. The fact that the CEO is on the board is only relevant insofar as it means that the CEO’s seat does not qualify as an independent directorship and that at least 7 of the remaining 11 seats should be independent.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      26,
      27,
      38,
      12,
      2
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 290,
    "question": "Which one of the following statements about corporate governance systems is incorrect?",
    "choice_a": "A governance system should be static.",
    "choice_b": "A governance system should cover the enterprise end-to-end, focusing not only on the IT function but on all technology and information processing the enterprise puts in place to achieve its goals.",
    "choice_c": "Each enterprise needs a governance system to satisfy stakeholder needs and to generate value from the use of information and technology.",
    "choice_d": "A governance system for enterprise information and technology is built from a number of components that can be of different types and work together in a holistic way.",
    "correct_answer": "A",
    "explanation": "A governance system should be dynamic, not static. This allows the system to adapt to the changing needs of the organization. The other statements listed here are all principles of governance systems defined by ISACA.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      38,
      26,
      27,
      10,
      14
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 291,
    "question": "Matt is developing a business continuity plan for his organization’s website. The organization requires 247 availability for the site and any outage of more than a few minutes will have a critical reputational impact on the business. What would be the best control for use in this situation?",
    "choice_a": "RAID",
    "choice_b": "Geographically diverse failover site",
    "choice_c": "Offsite backups",
    "choice_d": "Insurance",
    "correct_answer": "B",
    "explanation": "A geographically distant failover site is the best control against a lengthy outage, as the backup site can assume operations in a matter of minutes. Insurance can only shift financial risk. It is not possible to use insurance to manage reputational risk. Offsite backups are an effective control, but they would not be able to meet the requirement of restoring website operations in a few minutes. RAID will protect against the failure of a single hard drive in a server but will not mitigate many of the risks inherent in operating a web server, such as a flood in the data center.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      210,
      220,
      184,
      190,
      224
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 292,
    "question": "Gavin is drafting a document that provides a detailed step-by-step process that users may follow to connect to the VPN from remote locations. Alternatively, users may ask IT to help them configure the connection. What term best describes this document?",
    "choice_a": "Procedure",
    "choice_b": "Policy",
    "choice_c": "Standard",
    "choice_d": "Guideline",
    "correct_answer": "A",
    "explanation": "A procedure offers a step-by-step process for completing a cybersecurity activity. The VPN instructions that Gavin is creating are best described using this term.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      33,
      79,
      77,
      84,
      32
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 293,
    "question": "Janet recently accepted a position as the CIO at a major university. The feedback she heard from many stakeholders is that the security program is not well-aligned with the needs of the organization. She would like to convene a group of faculty, administrators, and students to help guide the program. What type of group is she convening?",
    "choice_a": "Change advisory board",
    "choice_b": "Leadership team",
    "choice_c": "Executive committee",
    "choice_d": "Steering committee",
    "correct_answer": "D",
    "explanation": "Steering committees help to facilitate alignment between security and business objectives. Janet can convene a group that represents business units and get their input in the development of security plans. The change advisory board (CAB) is designed to manage change requests, not to provide input on security activities. Leadership teams and the executive committee operate at an executive level and would not likely have the time or expertise to participate in this effort.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      27,
      10,
      36,
      4,
      17
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 294,
    "question": "Brandon is reviewing his organization’s change management program and is confirming that all relevant information is included in requests for change (RFC). Which one of the following elements is not commonly found in an RFC?",
    "choice_a": "Results of auditing the change",
    "choice_b": "Description of the change",
    "choice_c": "Expected impact of the change",
    "choice_d": "Proposed schedule for the change",
    "correct_answer": "A",
    "explanation": "Auditing normally occurs after a change has taken place and would not change the contents of an RFC. The RFC would normally include a description of the change, an explanation of the expected impact, a risk assessment, a rollback plan, the names of team members involved in the change, a proposed schedule, and the systems and services affected by the change.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      95,
      117,
      145,
      146,
      39
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 295,
    "question": "Jill is reviewing the security controls that her organization uses to protect a sensitive network segment. She determines that the network is lacking adequate IDS capability. What type of control deficiency has Jill identified?",
    "choice_a": "Detective",
    "choice_b": "Corrective",
    "choice_c": "Preventive",
    "choice_d": "Deterrent",
    "correct_answer": "A",
    "explanation": "An intrusion detection system (IDS) identifies potential intrusions that may be taking place on a network and is, therefore, an example of a detective control. An intrusion prevention system (IPS), on the other hand, might actually block the attack and would be an example of a preventive control.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      51,
      50,
      54,
      55,
      43
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 296,
    "question": "What type of data is most susceptible to eavesdropping attacks?",
    "choice_a": "Data in processing",
    "choice_b": "Data at rest",
    "choice_c": "Encrypted data",
    "choice_d": "Data in motion",
    "correct_answer": "D",
    "explanation": "Data in motion is data that is in transit over a network. When data travels on an untrusted network, it is open to eavesdropping attacks by anyone with access to those networks. Data at rest is stored data that resides on hard drives, tapes, in the cloud, or on other storage media. This data is prone to pilfering by insiders or external attackers who gain access to systems and are able to browse through their contents. Data in processing is data that is actively in use by a computer system. This includes the data stored in memory while processing takes place. An attacker with control of the system may be able to read the contents of memory and steal sensitive information. Encrypted data is not susceptible to eavesdropping attacks because it has been rendered unreadable by anyone without access to the decryption key.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      136,
      137,
      62,
      116,
      64
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 297,
    "question": "Valerie is reviewing the logs of her organization’s data loss prevention (DLP) system and believes that she found a record indicating that an employee is stealing confidential information. What should she do next?",
    "choice_a": "Inform the employee’s manager",
    "choice_b": "Cut off the employee’s network access",
    "choice_c": "Perform further investigation",
    "choice_d": "Question the employee",
    "correct_answer": "C",
    "explanation": "Valerie should conduct a further investigation of the incident before involving management or taking steps that would alert the employee to her suspicion. Valerie should not approach the employee before validating the information and consulting with management. Valerie should inform the employee’s manager at some point during the investigation but should first perform further investigation to validate the report. Cutting off access is a drastic step and should only be taken after consultation with management.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      159,
      157,
      169,
      161,
      163
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 298,
    "question": "David would like to send Mike a message using an asymmetric encryption algorithm. What key should he use to encrypt the message?",
    "choice_a": "David’s public key",
    "choice_b": "Mike’s private key",
    "choice_c": "Mike’s public key",
    "choice_d": "David’s private key",
    "correct_answer": "C",
    "explanation": "When encrypting a message using an asymmetric encryption algorithm, the person performing the encryption does so using the recipient’s public key.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      138,
      143,
      141,
      139,
      140
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 299,
    "question": "Carolyn is concerned that users on her network may be storing sensitive information, such as Social Security numbers, on their hard drives without proper authorization or security controls. What third-party security service can she implement to best detect this activity?",
    "choice_a": "IPS",
    "choice_b": "TLS",
    "choice_c": "DLP",
    "choice_d": "IDS",
    "correct_answer": "C",
    "explanation": "Data loss prevention (DLP) systems may identify sensitive information stored on endpoint systems or in transit over a network. This is their primary purpose. DLP systems are commonly available as a third-party managed service offering. Intrusion detection and prevention systems (IDSs/IPSs) may be used to identify some sensitive information using signatures built for that purpose, but this is not the primary role of those tools, and they would not be as effective as DLP systems at this task. TLS is a network encryption protocol that may be used to protect sensitive information, but it does not have any ability to identify sensitive information.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      116,
      62,
      123,
      135,
      94
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 300,
    "question": "Gary recently conducted a comprehensive security review of his organization. He identified the 25 top risks to the organization and is pursuing different risk management strategies for each of these risks. In some cases, he is using multiple strategies to address a single risk. His goal is to reduce the overall level of risk so that it lies within his organization’s risk tolerance. Gary decides that the organization should integrate a threat intelligence feed with the firewall. What type of risk management strategy is this?",
    "choice_a": "Risk transference",
    "choice_b": "Risk acceptance",
    "choice_c": "Risk avoidance",
    "choice_d": "Risk mitigation",
    "correct_answer": "D",
    "explanation": "The use of a threat intelligence feed to block connections at the firewall reduces the likelihood of a successful attack and is, therefore, a risk mitigation activity.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      50,
      51,
      73,
      74,
      49
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 301,
    "question": "At the end of a cybersecurity exercise, who gathers to share lessons learned during both the offensive and defensive portions of the exercise?",
    "choice_a": "Purple team",
    "choice_b": "Blue team",
    "choice_c": "Red team",
    "choice_d": "White team",
    "correct_answer": "A",
    "explanation": "Purple teaming is conducted after an exercise to bring together the red and blue teams for knowledge sharing.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      157,
      168,
      169,
      166,
      202
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 507,
    "question": "Mary is reviewing the availability controls for the system architecture shown here. What technology is shown that provides fault tolerance for the database servers?<br><img src=\"/question_assets/CISM/801931_Practice_Exam_2_image6.png\"/>",
    "choice_a": "Failover cluster",
    "choice_b": "UPS",
    "choice_c": "Tape backup",
    "choice_d": "Cold site",
    "correct_answer": "A",
    "explanation": "The illustration shows an example of a failover cluster, where DB1 and DB2 are both configured as database servers. At any given time, only one will function as the active database server, while the other remains ready to assume responsibility if the first one fails. While the environment may use UPS, tape backup, and cold sites as disaster recovery and business continuity controls, they are not shown in the diagram.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      58,
      127,
      126,
      128,
      39
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 303,
    "question": "Gavin is the disaster recovery team leader for his organization. They are currently in the response phase of an incident that has severe customer impact. Gavin just received a phone call from a reporter asking for details on the root cause and an estimated recovery time. Gavin has this information at his fingertips. What should he do?",
    "choice_a": "Refer the matter to the public relations department",
    "choice_b": "Provide the information to the reporter",
    "choice_c": "Request a few minutes to gather the information and return the call",
    "choice_d": "Refuse to provide any information",
    "correct_answer": "A",
    "explanation": "Disaster recovery teams should always refer media inquiries to the public relations team to ensure a coordinated, consistent response. They should not attempt to answer questions themselves.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      216,
      169,
      168,
      158,
      166
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 304,
    "question": "At what stage of the software development process should risk management activities normally begin?",
    "choice_a": "Design",
    "choice_b": "Coding",
    "choice_c": "Testing",
    "choice_d": "Deployment",
    "correct_answer": "A",
    "explanation": "Software and systems development efforts create and modify software and systems on a regular basis. New and modified systems are a potential source of risk to the organization, and integrating risk assessment and response practices into these development efforts helps ensure that the organization integrates security from the start and does not need to “bolt on” security controls after the fact in a costly and error-prone approach. This should be done at the beginning of the software development process, the design phase.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      57,
      43,
      50,
      49,
      59
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 305,
    "question": "Paul is designing a compensating control for an issue that is preventing his organization from achieving PCI DSS compliance. Which one of the following statements about compensating controls is incorrect?",
    "choice_a": "The control must provide a similar level of defense as the original requirement, such that the compensating control sufficiently offsets the risk that the original PCI DSS requirement was designed to defend against.",
    "choice_b": "The control must meet the intent and rigor of the original requirement.",
    "choice_c": "The organizations CISO (or other senior-most security executive) must personally approve the control.",
    "choice_d": "The control must be “above and beyond” other PCI DSS requirements.",
    "correct_answer": "C",
    "explanation": "There are three requirements for PCI DSS compensating controls. First, the control must meet the intent and rigor of the original requirement. Second, the control must provide a similar level of defense as the original requirement, such that the compensating control sufficiently offsets the risk that the original PCI DSS requirement was designed to defend against. Third, the control must be “above and beyond” other PCI DSS requirements. There is no requirement that the CISO personally approve the use of any compensating control.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      35,
      79,
      77,
      39,
      42
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 306,
    "question": "Greg is the CISO at a mid-sized corporation, and he recently asked a group of volunteer security researchers to conduct a penetration test against his organization. These volunteers are unpaid and doing this test to advance their own skills. What term best describes this test?",
    "choice_a": "White hat",
    "choice_b": "Gray hat",
    "choice_c": "Black hat",
    "choice_d": "Blue hat",
    "correct_answer": "A",
    "explanation": "It is irrelevant whether the testers are paid or unpaid. The key factor here is that Greg, a leader in the organization, authorized the test. This makes the exercise a white-hat test. Gray-hat tests are executed without permission but with benevolent intent. Black-hat tests are executed with malicious intent. Blue-hat exercises do not exist.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      109,
      110,
      108,
      107,
      114
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 307,
    "question": "Paul is considering the risk facing his organization from a data breach. He is having difficulty coming up with financial data to describe the risk associated with reputational damage and other intangible concerns. What type of risk assessment would be most appropriate in this scenario?",
    "choice_a": "Hybrid",
    "choice_b": "Quantitative",
    "choice_c": "Qualitative",
    "choice_d": "ALE",
    "correct_answer": "C",
    "explanation": "Quantitative risk assessments use numeric data in the analysis, resulting in assessments that allow the very straightforward prioritization of risks. Qualitative risk assessments substitute subjective judgments and categories for strict numerical analysis, allowing the assessment of risks that are difficult to quantify. Given Paul’s inability to derive quantitative measures, a qualitative assessment would be more appropriate. A business impact assessment (BIA) and an annualized loss expectancy (ALE) are elements of a quantitative assessment.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      47,
      46,
      45,
      59,
      50
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 308,
    "question": "What NIST publication contains guidance on cybersecurity incident handling?",
    "choice_a": "SP 800-88",
    "choice_b": "SP 800-53",
    "choice_c": "SP 800-61",
    "choice_d": "SP 800-18",
    "correct_answer": "C",
    "explanation": "NIST SP 800-61 is the Computer Security Incident Handling Guide. NIST SP 800-53 is Security and Privacy Controls for Federal Information Systems and Organizations. NIST SP 800-88 is Guidelines for Media Sanitization. NIST SP 800-18 is the Guide for Developing Security Plans for Federal Information Systems.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      157,
      168,
      158,
      159,
      165
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 309,
    "question": "You are working to evaluate the risk of flood to an area as part of a business continuity planning (BCP) effort. You consult the flood maps from the Federal Emergency Management Agency (FEMA). According to those maps, the area lies within a 200-year flood plain. What is the annualized rate of occurrence (ARO) of a flood in that region?",
    "choice_a": "0.02",
    "choice_b": "0.005",
    "choice_c": "0.01",
    "choice_d": "200",
    "correct_answer": "B",
    "explanation": "The annualized rate of occurrence (ARO) is the expected number of times an incident will occur each year. In the case of a 200-year flood plain, planners should expect a flood once every 200 years. This is equivalent to a 1/200 chance of a flood in any given year, or 0.005 floods per year.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      46,
      47,
      44,
      59,
      49
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 310,
    "question": "Thomas is developing an information security governance roadmap for his organization. Which one of the following should have the greatest influence on this roadmap?",
    "choice_a": "Compliance requirements",
    "choice_b": "Threat assessment",
    "choice_c": "Vulnerability assessment",
    "choice_d": "Strategy",
    "correct_answer": "D",
    "explanation": "Strategy should be the primary influence when developing an information security governance roadmap. Threat assessments, vulnerability assessments, and compliance requirements may play a role in the development of the strategy and roadmap, but they should not be the primary driver.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      27,
      10,
      14,
      17,
      2
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 311,
    "question": "Danielle is creating a professional development program for her cybersecurity team. She would like to include opportunities that allow employees to independently validate their skills. Which one of the following efforts would best meet her needs?",
    "choice_a": "Training",
    "choice_b": "Certification",
    "choice_c": "Awareness",
    "choice_d": "Accreditation",
    "correct_answer": "B",
    "explanation": "Certifications help employees validate their skills and are an important recruiting and retention tool. Training programs help employees keep their skills current and develop skills in new areas of cybersecurity. Awareness efforts are meant to reinforce security knowledge. Accreditation processes are used to formally certify systems in government and military applications.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      85,
      84,
      86,
      82,
      83
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 312,
    "question": "HAL Systems recently decided to stop offering public NTP services because of a fear that its NTP servers would be used in amplification DDoS attacks. What type of risk management strategy did HAL pursue with respect to its NTP services?",
    "choice_a": "Risk mitigation",
    "choice_b": "Risk acceptance",
    "choice_c": "Risk transference",
    "choice_d": "Risk avoidance",
    "correct_answer": "D",
    "explanation": "HAL Systems decided to stop offering the service because of the risk. This is an example of a risk avoidance strategy. The company altered its operations in a manner that eliminates the risk of NTP misuse.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      50,
      52,
      51,
      54,
      49
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 313,
    "question": "Brenda is crafting a goal for her information security program to address a critical security objective and has come up with the following statement: “We will improve our ability to detect denial-of-service incidents by the end of this year.” What element of the SMART framework is missing from this goal?",
    "choice_a": "Measurable",
    "choice_b": "Specific",
    "choice_c": "Relevant",
    "choice_d": "Time-bound",
    "correct_answer": "A",
    "explanation": "This goal does not contain any measurable objective that may be used to determine when the organization successfully achieves it. The goal is specific in that it includes the objective of increasing detection capabilities. It is relevant because it addresses a critical security objective, and it is time-bound because it includes a deadline at the end of the year.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      81,
      79,
      80,
      83,
      84
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 314,
    "question": "Matt wants to ensure that critical network traffic from systems throughout his company is prioritized over web browsing and social media use at this company. What technology can he use to do this?",
    "choice_a": "VPN",
    "choice_b": "VLANs",
    "choice_c": "QoS",
    "choice_d": "ISDN",
    "correct_answer": "C",
    "explanation": "Quality of service is a feature found on routers and other network devices that can prioritize specific network traffic. QoS policies define which traffic is prioritized, and traffic is then handled based on the policy.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      121,
      119,
      120,
      122,
      118
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 315,
    "question": "Kareem is reviewing the results of some network vulnerability tests that he conducted and believes that the false positive rate is too high. He would like to adjust the scans to reduce this rate. What adjustment would be most likely to have the desired effect?",
    "choice_a": "Increase the scan sensitivity",
    "choice_b": "Decrease the scan sensitivity",
    "choice_c": "Change the scan perspective",
    "choice_d": "Update the scanner plugins",
    "correct_answer": "B",
    "explanation": "The most direct way that Kareem can reduce the number of false positives is to decrease the scan sensitivity. This does run the risk of increasing the false negative rate, but it would achieve his desired result. Increasing the scan sensitivity would increase the false positive rate. Changing the scan perspective or updating plug-ins may have the side effect of altering the false positive rate, but it is not as likely to work as decreasing the sensitivity.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      99,
      100,
      97,
      81,
      108
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 316,
    "question": "Jen’s firm is planning to open a new retail store that will accept credit cards. What regulation must the firm comply with as a result of this processing?",
    "choice_a": "FERPA",
    "choice_b": "PCI DSS",
    "choice_c": "HIPAA",
    "choice_d": "GLBA",
    "correct_answer": "B",
    "explanation": "The Payment Card Industry Data Security Standard (PCI DSS) is an industry regulatory framework that specifies the cybersecurity requirements for organizations involved in credit card transactions.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      37,
      21,
      14,
      22,
      29
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 317,
    "question": "Robert is responsible for securing systems used to process credit card information. What security control framework should guide his actions?",
    "choice_a": "PCI DSS",
    "choice_b": "HIPAA",
    "choice_c": "RMF",
    "choice_d": "CSF",
    "correct_answer": "A",
    "explanation": "The Payment Card Industry Data Security Standard (PCI DSS) governs the storage, processing, and transmission of credit card information. The NIST Cybersecurity Framework (CSF) and Risk Management Framework (RMF) are general advice for cybersecurity organizations but do not contain specific advice for payment card processing. The Health Insurance Portability and Accountability Act (HIPAA) governs protected health information.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      37,
      21,
      22,
      25,
      23
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 318,
    "question": "Alex’s company recently experienced a security breach where the intruder managed to steal personally identifiable information (PII) from a company database. What goal of information security did this attack violate?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Availability",
    "choice_d": "Authorization",
    "correct_answer": "A",
    "explanation": "This attack removed sensitive information from the organization without permission and therefore is a breach in confidentiality. The attack did not make unauthorized modifications to information and therefore is not an integrity attack. The attack did not disrupt the legitimate access to information and therefore is not an availability attack. Authorization is not one of the three key goals of information security.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      136,
      62,
      116,
      40,
      151
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 319,
    "question": "Which one of the following risks would be best described as an external risk to an organization?",
    "choice_a": "Rogue employee",
    "choice_b": "Ransomware",
    "choice_c": "Staff error",
    "choice_d": "Server failure",
    "correct_answer": "B",
    "explanation": "Server failure, employee errors, and malicious insiders are all examples of internal threats because they originate from within the organization. Ransomware originates from outside the organization and is, therefore, an example of an external risk.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      44,
      43,
      66,
      71,
      48
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 320,
    "question": "Ryan recently installed a set of infrared motion detectors in his data center. What type of security control did he configure?",
    "choice_a": "Compensating",
    "choice_b": "Corrective",
    "choice_c": "Preventive",
    "choice_d": "Detective",
    "correct_answer": "D",
    "explanation": "Motion detectors are designed to detect intruders in a facility and are, therefore, a detective control. Preventive controls are designed to prevent a security incident from occurring in the first place. Corrective controls are designed to recover normal operations after an incident. Compensating controls are designed to fill a control gap left after another control was not implemented.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      35,
      40,
      77,
      79,
      83
    ],
    "source": "801931 Practice Exam 2"
  },
  {
    "id": 321,
    "question": "Matt is updating the organization’s threat assessment process. What category of control is Matt implementing?",
    "choice_a": "Operational",
    "choice_b": "Technical",
    "choice_c": "Corrective",
    "choice_d": "Managerial",
    "correct_answer": "D",
    "explanation": "Managerial controls are procedural mechanisms that focus on the mechanics of the risk management process. Threat assessment is an example of one of these activities.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      19,
      22,
      12,
      27,
      10
    ],
    "source": "801931 c01"
  },
  {
    "id": 322,
    "question": "Jade’s organization recently suffered a security breach that affected stored credit card data. Jade’s primary concern is the fact that the organization is subject to sanctions for violating the provisions of the Payment Card Industry Data Security Standard. What category of risk is concerning Jade?",
    "choice_a": "Strategic",
    "choice_b": "Compliance",
    "choice_c": "Operational",
    "choice_d": "Financial",
    "correct_answer": "B",
    "explanation": "The breach of credit card information may cause many different impacts on the organization, including compliance, operational, and financial risks. However, in this scenario, Jade’s primary concern is violating PCI DSS, making the concern a compliance risk.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      8,
      37,
      22,
      14,
      21
    ],
    "source": "801931 c01"
  },
  {
    "id": 323,
    "question": "Chris is responding to a security incident that compromised one of his organization’s web servers. He believes that the attackers defaced one or more pages on the website. What cybersecurity objective did this attack violate?",
    "choice_a": "Confidentiality",
    "choice_b": "Nonrepudiation",
    "choice_c": "Integrity",
    "choice_d": "Availability",
    "correct_answer": "C",
    "explanation": "The defacement of a website alters content without authorization and is, therefore, a violation of the integrity objective. The attackers may also have breached the confidentiality or availability of the website, but the scenario does not provide us with enough information to draw those conclusions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      1,
      6,
      7,
      22,
      8
    ],
    "source": "801931 c01"
  },
  {
    "id": 324,
    "question": "Which one of the following elements is <i>most</i> important to gaining the support of senior leaders for cybersecurity initiatives?",
    "choice_a": "Using plain, understandable language",
    "choice_b": "Communicating often and in the format desired by the leaders",
    "choice_c": "Demonstrating the alignment between business objectives and security needs",
    "choice_d": "Adopting emerging technologies",
    "correct_answer": "C",
    "explanation": "The most important consideration when gaining stakeholder support for security initiatives is demonstrating the alignment between a request and the objectives of the business. While managers should certainly use plain language and communicate in the format desired by leaders, these are secondary considerations. Adopting emerging technologies is not necessary to underscore the importance of security initiatives.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      28,
      2,
      27,
      17,
      10
    ],
    "source": "801931 c01"
  },
  {
    "id": 325,
    "question": "Tonya is concerned about the risk that an attacker will attempt to gain access to her organization’s database server. She is searching for a control that would discourage the attacker from attempting to gain access. What type of security control is she seeking to implement?",
    "choice_a": "Preventive",
    "choice_b": "Detective",
    "choice_c": "Corrective",
    "choice_d": "Deterrent",
    "correct_answer": "D",
    "explanation": "Deterrent controls are designed to prevent an attacker from attempting to violate security policies in the first place. Preventive controls would attempt to block an attack that was about to take place. Corrective controls would remediate the issues that arose during an attack.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      20,
      22,
      16,
      14,
      12
    ],
    "source": "801931 c01"
  },
  {
    "id": 326,
    "question": "Which one of the following individuals bears ultimate responsibility for protecting an organization’s data?",
    "choice_a": "Data steward",
    "choice_b": "End users",
    "choice_c": "Data custodian",
    "choice_d": "Data owner",
    "correct_answer": "D",
    "explanation": "All individuals within an organization have some responsibility for protecting data. However, the data owner is the senior-most leader who bears ultimate responsibility for this protection. The data owner may delegate some authority and/or responsibility to data stewards, data custodians, and end users, but they still bear ultimate responsibility.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      15,
      4,
      26,
      27,
      10
    ],
    "source": "801931 c01"
  },
  {
    "id": 327,
    "question": "Brooke is conducting a SWOT analysis for her organization’s cybersecurity program. She recently learned about a cybersecurity insurance offering that may allow the organization to transfer some financial risk and is considering purchasing a policy. Where would this offering fit in the SWOT analysis?",
    "choice_a": "Strength",
    "choice_b": "Weakness",
    "choice_c": "Opportunity",
    "choice_d": "Threat",
    "correct_answer": "C",
    "explanation": "The availability of this cybersecurity insurance offering is an external factor that the organization might exploit to better achieve its objectives and, therefore, should be classified as an opportunity. Strengths and weaknesses are internal characteristics of the organization. Threats are external factors that pose a risk to the organization.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      11,
      14,
      10,
      8,
      28
    ],
    "source": "801931 c01"
  },
  {
    "id": 328,
    "question": "Tina is tuning her organization’s intrusion prevention system to prevent false positive alerts. What type of control is Tina implementing?",
    "choice_a": "Technical control",
    "choice_b": "Physical control",
    "choice_c": "Managerial control",
    "choice_d": "Operational control",
    "correct_answer": "A",
    "explanation": "Technical controls enforce confidentiality, integrity, and availability in the digital space. Examples of technical security controls include firewall rules, access control lists, intrusion prevention systems, and encryption.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      19,
      20,
      22,
      1,
      38
    ],
    "source": "801931 c01"
  },
  {
    "id": 329,
    "question": "Dan is the CISO of an organization and he is spearheading the development of a new security operations center (SOC). He bears responsibility for the success of this initiative. In the RACI matrix entry for this initiative, how would Dan <i>best</i> be labeled?",
    "choice_a": "R",
    "choice_b": "A",
    "choice_c": "C",
    "choice_d": "I",
    "correct_answer": "B",
    "explanation": "As the ultimate stakeholder for the initiative, Dan is the accountable individual and should be labeled with an “A” in the RACI matrix. Others who are directly contributing to the effort would be labeled as responsible (“R”). Stakeholders who are not directly working on the SOC implementation would be labeled as either consulted (“C”) or informed (“I”), as appropriate.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      4,
      27,
      2,
      28,
      31
    ],
    "source": "801931 c01"
  },
  {
    "id": 330,
    "question": "Tony is reviewing the status of his organization’s defenses against a breach of their file server. He believes that a compromise of the file server could reveal information that would prevent the company from continuing to do business. What term <i>best</i> describes the risk that Tony is considering?",
    "choice_a": "Strategic",
    "choice_b": "Reputational",
    "choice_c": "Financial",
    "choice_d": "Operational",
    "correct_answer": "A",
    "explanation": "The risk that Tony is contemplating could fit any one of these categories. However, his primary concern is that the company may no longer be able to do business if the risk materializes. This is a strategic risk.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      8,
      10,
      2,
      27,
      22
    ],
    "source": "801931 c01"
  },
  {
    "id": 331,
    "question": "Which one of the following data elements is not commonly associated with identity theft?",
    "choice_a": "Social Security number",
    "choice_b": "Driver’s license number",
    "choice_c": "Frequent flyer number",
    "choice_d": "Passport number",
    "correct_answer": "C",
    "explanation": "Although it is possible that a frequent flyer account number, or any other account number for that matter, could be used in identity theft, it is far more likely that identity thieves would use core identity documents. These include driver’s licenses, passports, and Social Security numbers.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      9,
      25,
      24,
      6,
      22
    ],
    "source": "801931 c01"
  },
  {
    "id": 332,
    "question": "What term best describes an organization’s desired security state?",
    "choice_a": "Control objectives",
    "choice_b": "Security priorities",
    "choice_c": "Strategic goals",
    "choice_d": "Best practices",
    "correct_answer": "A",
    "explanation": "As an organization analyzes its risk environment, technical and business leaders determine the level of protection required to preserve the confidentiality, integrity, and availability of their information and systems. They express these requirements by writing the control objectives that the organization wishes to achieve. These control objectives are statements of a desired security state.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      22,
      10,
      1,
      12,
      13
    ],
    "source": "801931 c01"
  },
  {
    "id": 333,
    "question": "Jerry is developing a cybersecurity awareness program for members of his team who have administrative access to sensitive systems. What category <i>best</i> describes the users he is targeting?",
    "choice_a": "Privileged users",
    "choice_b": "High-risk users",
    "choice_c": "End users",
    "choice_d": "Data owners",
    "correct_answer": "A",
    "explanation": "It may be true that these individuals fit into more than one, or even all, of these categories. However, the key element in the question is that the users have administrative access to systems. Therefore, they are best described as privileged users.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      2,
      4,
      19,
      27
    ],
    "source": "801931 c01"
  },
  {
    "id": 334,
    "question": "Which one of the following individuals is the <i>least</i> appropriate direct manager of a chief information security officer?",
    "choice_a": "Chief information officer",
    "choice_b": "Chief risk officer",
    "choice_c": "Chief executive officer",
    "choice_d": "Senior director for identity and access management",
    "correct_answer": "D",
    "explanation": "The CISO should report to a senior-level decision-maker in the organization and not to the leader of another technology function. Therefore, the senior D director for identity and access management is an inappropriate reporting structure. The CIO, CRO, and CEO would all be appropriate supervisors for a CISO.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      27,
      26,
      4,
      10
    ],
    "source": "801931 c01"
  },
  {
    "id": 335,
    "question": "Greg recently conducted an assessment of his organization’s security controls and discovered a potential gap: the organization does not use full-disk encryption on laptops. What type of control gap exists in this case?",
    "choice_a": "Detective",
    "choice_b": "Corrective",
    "choice_c": "Deterrent",
    "choice_d": "Preventive",
    "correct_answer": "D",
    "explanation": "The use of full-disk encryption is intended to prevent a security incident from occurring if a device is lost or stolen. Therefore, this is a preventive control gap.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      20,
      12,
      22,
      8,
      13
    ],
    "source": "801931 c01"
  },
  {
    "id": 336,
    "question": "Toni is developing a new goal for her information security program. She has currently written it as “We will acquire and implement a new intrusion prevention system that will reduce successful network intrusions by 50%.” What element of the SMART framework is lacking from this goal?",
    "choice_a": "Specific",
    "choice_b": "Measurable",
    "choice_c": "Achievable",
    "choice_d": "Relevant",
    "correct_answer": "E",
    "explanation": "This goal is specific in that it describes the implementation of an IPS. It is also measurable since it states a clear objective of reducing intrusions by 50 percent. We do not have enough information about the organization to determine whether it is achievable or relevant. It is definitely not, time-bound because it contains no deadline. Toni could remedy this situation by adding a deliverable date to the goal.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      13,
      17,
      10,
      2,
      28
    ],
    "source": "801931 c01",
    "choice_e": "Time-bound"
  },
  {
    "id": 337,
    "question": "Nolan is writing an after-action report on a security breach that took place in his organization. The attackers stole thousands of customer records from the organization’s database. What cybersecurity principle was most impacted in this breach?",
    "choice_a": "Availability",
    "choice_b": "Nonrepudiation",
    "choice_c": "Confidentiality",
    "choice_d": "Integrity",
    "correct_answer": "C",
    "explanation": "The disclosure of sensitive information to unauthorized individuals is a violation of the principle of confidentiality.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      1,
      6,
      9,
      22,
      25
    ],
    "source": "801931 c01"
  },
  {
    "id": 338,
    "question": "Which one of the following objectives is not one of the three main objectives that information security professionals must achieve to protect their organizations against cybersecurity threats?",
    "choice_a": "Integrity",
    "choice_b": "Nonrepudiation",
    "choice_c": "Availability",
    "choice_d": "Confidentiality",
    "correct_answer": "B",
    "explanation": "The three primary objectives of cybersecurity professionals are confidentiality, integrity, and availability.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      1,
      6,
      7,
      22,
      5
    ],
    "source": "801931 c01"
  },
  {
    "id": 339,
    "question": "What is the <i>most</i> appropriate span of control for a cybersecurity leader?",
    "choice_a": "2",
    "choice_b": "4",
    "choice_c": "7",
    "choice_d": "12",
    "correct_answer": "C",
    "explanation": "The span of control is the number of employees who directly report to a manager. Most organizations consider 5–10 employees to be an appropriate span of control.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      2,
      3,
      4,
      26,
      27
    ],
    "source": "801931 c01"
  },
  {
    "id": 340,
    "question": "Brian is conducting a maturity assessment of his organization’s cybersecurity team using Capability Maturity Model Integration (CMMI). He notes that the team does use defined processes but that they develop them in a reactive manner for each project they undertake. What level of maturity would <i>best</i> describe this team?",
    "choice_a": "Defined",
    "choice_b": "Repeatable",
    "choice_c": "Initial",
    "choice_d": "Quantitatively managed",
    "correct_answer": "E",
    "explanation": "This is an example of a Managed organization: one that begins to implement organized processes on a per-project basis but is still operating in reactive mode. At the Initial level, the organization has unpredictable processes that are poorly controlled. When an organization achieves Level 3: Defined, it has standard processes that are used organization-wide and are adapted for use within each project. Level 4: Quantitatively Managed organizations build measurement and controls on top of their processes to allow them to quickly identify and remediate deficiencies and address control gaps before issues arise. At the top tier of the CMMI, Level 5: Optimizing organizations use a continuous process improvement approach to adjust and fine-tune the way that they work to achieve peak efficiency and effectiveness.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      12,
      10,
      17,
      38,
      22
    ],
    "source": "801931 c01",
    "choice_e": "Managed"
  },
  {
    "id": 341,
    "question": "Joe is authoring a document that explains to system administrators one way in which they might comply with the organization’s requirement to encrypt all laptops. What type of document is Joe writing?",
    "choice_a": "Policy",
    "choice_b": "Guideline",
    "choice_c": "Procedure",
    "choice_d": "Standard",
    "correct_answer": "B",
    "explanation": "The key term in this scenario is “one way.” This indicates that compliance with the document is not mandatory, so Joe must be authoring a guideline. Policies, standards, and procedures are all mandatory.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      77,
      33,
      80,
      95,
      62
    ],
    "source": "801931 c02"
  },
  {
    "id": 342,
    "question": "Victor is designing an information security governance program for his organization. Which one of the following statements about governance programs is not correct?",
    "choice_a": "Governance programs should clearly distinguish between governance and management activities",
    "choice_b": "Governance programs should be created once and developed in a manner that does not require future changes.",
    "choice_c": "Security governance programs should be aligned with corporate governance programs",
    "choice_d": "Governance programs should cover the enterprise end-to-end.",
    "correct_answer": "B",
    "explanation": "Governance programs should be flexible and dynamic, rather than static. They should adapt to changes in the environment, as needed. They should be tailored to the enterprise’s needs and cover the enterprise end-to-end. They should clearly distinguish between governance and management activities.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      27,
      38,
      31,
      4,
      12
    ],
    "source": "801931 c02"
  },
  {
    "id": 343,
    "question": "What law creates privacy obligations for those who handle the personal information of European Union residents?",
    "choice_a": "HIPAA",
    "choice_b": "FERPA",
    "choice_c": "GDPR",
    "choice_d": "PCI DSS",
    "correct_answer": "C",
    "explanation": "The General Data Protection Regulation (GDPR) implements privacy requirements for handling the personal information of EU residents. The Health Insurance Portability and Accountability Act (HIPAA) includes security and privacy rules that affect health-care providers, health insurers, and health information clearinghouses. The Family Educational Rights and Privacy Act (FERPA) applies to educational institutions. The Payment Card Industry Data Security Standard (PCI DSS) applies to credit and debit card information.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      37,
      9,
      15,
      22,
      27
    ],
    "source": "801931 c02"
  },
  {
    "id": 344,
    "question": "Which one of the following is <i>not</i> one of the five core security functions defined by the NIST Cybersecurity Framework?",
    "choice_a": "Identify",
    "choice_b": "Contain",
    "choice_c": "Respond",
    "choice_d": "Recover",
    "correct_answer": "B",
    "explanation": "The five security functions described in the NIST Cybersecurity Framework are identify, protect, detect, respond, and recover.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      39,
      40,
      77,
      78,
      79
    ],
    "source": "801931 c02"
  },
  {
    "id": 345,
    "question": "What ISO standard provides guidance on privacy controls?",
    "choice_a": "27002",
    "choice_b": "27001",
    "choice_c": "27701",
    "choice_d": "31000",
    "correct_answer": "C",
    "explanation": "The International Organization for Standardization (ISO) publishes ISO 27701, covering privacy controls. ISO 27001 and 27002 cover cybersecurity, and ISO 31000 covers risk management.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      38,
      22,
      19,
      12,
      30
    ],
    "source": "801931 c02"
  },
  {
    "id": 346,
    "question": "Which one of the following documents must normally be approved by the CEO or similarly high-level executive?",
    "choice_a": "Standard",
    "choice_b": "Procedure",
    "choice_c": "Guideline",
    "choice_d": "Policy",
    "correct_answer": "D",
    "explanation": "Policies require approval from the highest level of management, usually the CEO. Other documents may often be approved by other managers, such as the CISO.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      77,
      79,
      78,
      80,
      39
    ],
    "source": "801931 c02"
  },
  {
    "id": 347,
    "question": "Greg would like to create an umbrella agreement that provides the security terms and conditions for all future work that his organizations does with a vendor. What type of agreement should Greg use?",
    "choice_a": "BPA",
    "choice_b": "MOU",
    "choice_c": "MSA",
    "choice_d": "SLA",
    "correct_answer": "C",
    "explanation": "Master service agreements (MSAs) provide an umbrella contract for the work that a vendor does with an organization over an extended period of time. The MSA typically includes detailed security and privacy requirements. Each time the organization enters into a new project with the vendor, they may then create a statement of work (SOW) that contains project-specific details and references the MSA.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      29,
      30,
      27,
      36,
      2
    ],
    "source": "801931 c02"
  },
  {
    "id": 348,
    "question": "What organization is known for creating independent security benchmarks covering hardware and software platforms from many different vendors?",
    "choice_a": "Microsoft",
    "choice_b": "Center for Internet Security",
    "choice_c": "Cloud Security Alliance",
    "choice_d": "Cisco",
    "correct_answer": "B",
    "explanation": "All of these organizations produce security standards and benchmarks. However, only the Center for Internet Security (CIS) is known for producing independent benchmarks covering a wide variety of software and hardware.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      41,
      40,
      32,
      103,
      104
    ],
    "source": "801931 c02"
  },
  {
    "id": 349,
    "question": "In a publicly traded corporation, who is directly responsible for hiring and firing the chief executive officer?",
    "choice_a": "Senior executive team",
    "choice_b": "Shareholders",
    "choice_c": "Board of directors",
    "choice_d": "Chief financial officer",
    "correct_answer": "C",
    "explanation": "In the corporate governance model for publicly traded organizations, the shareholders who own the corporation delegate control of the corporation to the elected members of the board of directors. The board is then responsible for selecting the CEO, reviewing the CEO’s performance, and terminating the CEO when necessary.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      26,
      27,
      3,
      2,
      38
    ],
    "source": "801931 c02"
  },
  {
    "id": 350,
    "question": "Which one of the following would <i>not</i> normally be found in an organization’s information security policy?",
    "choice_a": "Statement of the importance of cybersecurity",
    "choice_b": "Requirement to use AES-256 encryption",
    "choice_c": "Delegation of authority",
    "choice_d": "Designation of responsible executive",
    "correct_answer": "B",
    "explanation": "Security policies do not normally contain prescriptive technical guidance, such as a requirement to use a specific encryption algorithm. This type of detail would normally be found in a security standard.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      77,
      32,
      79,
      40,
      35
    ],
    "source": "801931 c02"
  },
  {
    "id": 351,
    "question": "Darren is working with an independent auditor to produce an audit report that he will share with his customers under NDA to demonstrate that he has appropriate security controls in place. The auditor will not be assessing the effectiveness of those controls. What type of audit report should Darren expect?",
    "choice_a": "SOC 2 Type 1",
    "choice_b": "SOC 2 Type 2",
    "choice_c": "SOC 3 Type 1",
    "choice_d": "SOC 3 Type 2",
    "correct_answer": "A",
    "explanation": "The fact that the auditor will not be assessing the effectiveness of the controls means that this is a Type 1 report, not a Type 2 report. The fact that it will be shared only under NDA means that it is an SOC 2 assessment.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      42,
      96,
      90,
      91,
      35
    ],
    "source": "801931 c02"
  },
  {
    "id": 352,
    "question": "Danielle is developing a business case to support a proposed investment in her organization’s vulnerability management program. Which of the following components would she <i>not</i> normally include in the business case?",
    "choice_a": "Cost analysis",
    "choice_b": "Implementation plan",
    "choice_c": "Rollback plan",
    "choice_d": "Strategic context",
    "correct_answer": "C",
    "explanation": "The common elements of a business case include a scope statement, a strategic context, a cost analysis, an evaluation of alternatives, a project plan, and a management plan. Organizations may develop rollback plans for high-risk changes, but those rollback plans are not a standard component of the business case.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      10,
      27,
      2,
      17
    ],
    "source": "801931 c02"
  },
  {
    "id": 353,
    "question": "What compliance obligation applies to merchants and service providers who work with credit card information?",
    "choice_a": "FERPA",
    "choice_b": "SOX",
    "choice_c": "HIPAA",
    "choice_d": "PCI DSS",
    "correct_answer": "D",
    "explanation": "The Payment Card Industry Data Security Standard (PCI DSS) provides detailed rules about the storage, processing, and transmission of credit and debit card information. PCI DSS is not a law but rather a contractual obligation that applies to credit card merchants and service providers.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      37,
      21,
      29,
      22,
      25
    ],
    "source": "801931 c02"
  },
  {
    "id": 354,
    "question": "Gwen is developing a new security policy for her organization. Which one of the following statements does not reflect best practices for policy development?",
    "choice_a": "All stakeholders should agree with the proposed policy.",
    "choice_b": "The policy should follow normal corporate policy approval processes.",
    "choice_c": "Policies should match the “tone at the top” from senior business leaders.",
    "choice_d": "Cybersecurity managers are typically responsible for communicating and implementing approved security policies.",
    "correct_answer": "A",
    "explanation": "Policies should be developed in a manner that obtains input from all relevant stakeholders, but it is not necessary to obtain agreement or approval from all stakeholders. Policies should follow normal corporate policy approval processes and should be written in a manner that fits within the organizational culture and “tone at the top.” Once an information security policy is approved, it commonly falls to the information security manager to communicate and implement the policy.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      77,
      78,
      79,
      80,
      82
    ],
    "source": "801931 c02"
  },
  {
    "id": 355,
    "question": "Kevin is developing the business case for a new information security incident response program. Which one of the following statements is true about the costs associated with this initiative?",
    "choice_a": "The business case does not need to address costs, since this is done within the budgeting process.",
    "choice_b": "The business case should only include the one-time costs that are associated with implementing the new initiative.",
    "choice_c": "The business case should only include the new recurring costs that are created by the initiative.",
    "choice_d": "The business case should include both one-time and recurring costs associated with the initiative.",
    "correct_answer": "D",
    "explanation": "A complete business case should include all relevant financial and human resources costs for an initiative, including both one-time and recurring costs.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      28,
      2,
      10,
      8,
      26
    ],
    "source": "801931 c02"
  },
  {
    "id": 356,
    "question": "Which individual in an organization bears ultimate accountability to the board of directors for achieving the organization’s strategic plan?",
    "choice_a": "CISO",
    "choice_b": "CIO",
    "choice_c": "CFO",
    "choice_d": "CEO",
    "correct_answer": "D",
    "explanation": "The chief executive officer (CEO) bears ultimate responsibility for the efficiency and effectiveness of the organization in all respects. The chief information officer (CIO), chief information security officer (CISO), and chief financial officer (CFO) are all accountable to the CEO or other senior leader for the areas under their span of control.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      26,
      27,
      2,
      4,
      10
    ],
    "source": "801931 c02"
  },
  {
    "id": 357,
    "question": "The board of directors of Kate’s company recently hired an independent firm to review the state of the organization’s security controls and certify those results to the board. What term best describes this engagement?",
    "choice_a": "Assessment",
    "choice_b": "Control review",
    "choice_c": "Gap analysis",
    "choice_d": "Audit",
    "correct_answer": "D",
    "explanation": "Any of these terms could reasonably be used to describe this engagement. However, the term <i>audit</i> best describes this effort because of the formal nature of the review and the fact that it was requested by the board.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      96,
      80,
      79,
      81,
      40
    ],
    "source": "801931 c02"
  },
  {
    "id": 358,
    "question": "Which one of the following is not an objective domain in the COBIT framework?",
    "choice_a": "Secure, Protect, and Defend (SPD)",
    "choice_b": "Evaluate, Direct, and Monitor (EDM)",
    "choice_c": "Align, Plan, and Organize (APO)",
    "choice_d": "Deliver, Service, and Support (DSS)",
    "correct_answer": "A",
    "explanation": "The five COBIT domains are:<br>Evaluate, Direct, and Monitor (EDM)<br>Align, Plan, and Organize (APO)<br>Build, Acquire, and Implement (BAI)<br>Deliver, Service, and Support (DSS)<br>Monitor, Evaluate, and Assess (MEA).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      38,
      12,
      22,
      19,
      30
    ],
    "source": "801931 c02"
  },
  {
    "id": 359,
    "question": "Which one of the following is not a common use of the NIST Cybersecurity Framework?",
    "choice_a": "Describe the current cybersecurity posture of an organization.",
    "choice_b": "Describe the target future cybersecurity posture of an organization.",
    "choice_c": "Communicate with stakeholders about cybersecurity risk.",
    "choice_d": "Create specific technology requirements for an organization.",
    "correct_answer": "D",
    "explanation": "The NIST Cybersecurity Framework is designed to help organizations describe their current cybersecurity posture, describe their target state for cybersecurity, identify and prioritize opportunities for improvement, assess progress, and communicate with stakeholders about risk. It does not create specific technology requirements.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      10,
      17,
      12,
      14,
      27
    ],
    "source": "801931 c02"
  },
  {
    "id": 360,
    "question": "Which one of the following items is <i>not</i> normally included in a request for an exception to security policy?",
    "choice_a": "Description of a compensating control",
    "choice_b": "Description of the risks associated with the exception",
    "choice_c": "Proposed revision to the security policy",
    "choice_d": "Business justification for the exception",
    "correct_answer": "C",
    "explanation": "Requests for an exception to a security policy would not normally include a proposed revision to the policy. Exceptions are documented variances from the policy because of specific technical and/or business requirements. They do not alter the original policy, which remains in force for systems not covered by the exception.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      35,
      32,
      33,
      40,
      80
    ],
    "source": "801931 c02"
  },
  {
    "id": 361,
    "question": "Jen identified a missing patch on a Windows server that might allow an attacker to gain remote control of the system. After consulting with her manager, she applied the patch. From a risk management perspective, what has she done?",
    "choice_a": "Removed the threat",
    "choice_b": "Reduced the threat",
    "choice_c": "Removed the vulnerability",
    "choice_d": "Reduced the vulnerability",
    "correct_answer": "C",
    "explanation": "By applying the patch, Jen has removed the vulnerability from her server. This also has the effect of eliminating this particular risk. Jen cannot control the external threat of an attacker attempting to gain access to her server.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      50,
      43,
      51,
      54,
      45
    ],
    "source": "801931 c03"
  },
  {
    "id": 362,
    "question": "You notice a high number of SQL injection attacks against a web application run by your organization, so you install a web application firewall to block many of these attacks before they reach the server. How have you altered the severity of this risk?",
    "choice_a": "Reduced the magnitude",
    "choice_b": "Eliminated the vulnerability",
    "choice_c": "Reduced the probability",
    "choice_d": "Eliminated the threat",
    "correct_answer": "C",
    "explanation": "Installing a web application firewall reduces the probability that an attack will reach the web server. Vulnerabilities may still exist in the web application, and the threat of an external attack is unchanged. The impact of a successful SQL injection attack is also unchanged by a web application firewall.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      45,
      51,
      43,
      54,
      50
    ],
    "source": "801931 c03"
  },
  {
    "id": 508,
    "question": "Aziz is responsible for the administration of an e-commerce website that generates $100,000 per day in revenue for his firm. The website uses a database that contains sensitive information about the firm’s customers.<br>Aziz is assessing the risk of a denial-of-service attack against the database where the attacker would destroy the data contained within the database. He expects that it would cost approximately $500,000 to reconstruct the database from existing records. After consulting threat intelligence, he believes that there is a 5 percent chance of a successful attack in any given year.<br>What is the asset value (AV)?",
    "choice_a": "$5,000",
    "choice_b": "$100,000",
    "choice_c": "$500,000",
    "choice_d": "$600,000",
    "correct_answer": "C",
    "explanation": "The asset at risk in this case is the customer database. Losing control of the database would result in a $500,000 fine, so the asset value (AV) is $500,000.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      46,
      45,
      59,
      54,
      50
    ],
    "source": "801931 c03"
  },
  {
    "id": 509,
    "question": "Aziz is responsible for the administration of an e-commerce website that generates $100,000 per day in revenue for his firm. The website uses a database that contains sensitive information about the firm’s customers.<br>Aziz is assessing the risk of a denial-of-service attack against the database where the attacker would destroy the data contained within the database. He expects that it would cost approximately $500,000 to reconstruct the database from existing records. After consulting threat intelligence, he believes that there is a 5 percent chance of a successful attack in any given year.<br>What is the exposure factor (EF)?",
    "choice_a": "5%",
    "choice_b": "20%",
    "choice_c": "50%",
    "choice_d": "100%",
    "correct_answer": "D",
    "explanation": "The attack would result in the total loss of customer data stored in the database, making the exposure factor (EF) 100 percent.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      46,
      45,
      59,
      54,
      43
    ],
    "source": "801931 c03"
  },
  {
    "id": 510,
    "question": "Aziz is responsible for the administration of an e-commerce website that generates $100,000 per day in revenue for his firm. The website uses a database that contains sensitive information about the firm’s customers.<br>Aziz is assessing the risk of a denial-of-service attack against the database where the attacker would destroy the data contained within the database. He expects that it would cost approximately $500,000 to reconstruct the database from existing records. After consulting threat intelligence, he believes that there is a 5 percent chance of a successful attack in any given year.<br>What is the single loss expectancy (SLE)?",
    "choice_a": "$5,000",
    "choice_b": "$100,000",
    "choice_c": "$500,000",
    "choice_d": "$600,000",
    "correct_answer": "C",
    "explanation": "We compute the single loss expectancy (SLE) by multiplying the asset value (AV) ($500,000) and the exposure factor (EF) (100%) to get an SLE of $500,000.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      46,
      45,
      59,
      54,
      50
    ],
    "source": "801931 c03"
  },
  {
    "id": 511,
    "question": "Aziz is responsible for the administration of an e-commerce website that generates $100,000 per day in revenue for his firm. The website uses a database that contains sensitive information about the firm’s customers.<br>Aziz is assessing the risk of a denial-of-service attack against the database where the attacker would destroy the data contained within the database. He expects that it would cost approximately $500,000 to reconstruct the database from existing records. After consulting threat intelligence, he believes that there is a 5 percent chance of a successful attack in any given year.<br>What is the annualized rate of occurrence (ARO)?",
    "choice_a": "0.05",
    "choice_b": "0.20",
    "choice_c": "2.00",
    "choice_d": "5.00",
    "correct_answer": "A",
    "explanation": "Aziz’s threat intelligence research determined that the threat has a 5 percent likelihood of occurrence each year. This is an ARO of 0.05.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      46,
      45,
      43,
      49,
      74
    ],
    "source": "801931 c03"
  },
  {
    "id": 512,
    "question": "Aziz is responsible for the administration of an e-commerce website that generates $100,000 per day in revenue for his firm. The website uses a database that contains sensitive information about the firm’s customers.<br>Aziz is assessing the risk of a denial-of-service attack against the database where the attacker would destroy the data contained within the database. He expects that it would cost approximately $500,000 to reconstruct the database from existing records. After consulting threat intelligence, he believes that there is a 5 percent chance of a successful attack in any given year.<br>What is the annualized loss expectancy (ALE)?",
    "choice_a": "$5,000",
    "choice_b": "$25,000",
    "choice_c": "$100,000",
    "choice_d": "$500,000",
    "correct_answer": "B",
    "explanation": "We compute the annualized loss expectancy (ALE) by multiplying the SLE ($500,000) and the ARO (0.05) to get an ALE of $25,000.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      46,
      45,
      59,
      50,
      54
    ],
    "source": "801931 c03"
  },
  {
    "id": 513,
    "question": "Grace recently completed a risk assessment of her organization’s exposure to data breaches and determined that there is a high level of risk related to the loss of sensitive personal information. She is considering a variety of approaches to managing this risk.<br>Grace’s first idea is to add a web application firewall to protect her organization against SQL injection attacks. What risk management strategy does this approach adopt?",
    "choice_a": "Risk acceptance",
    "choice_b": "Risk avoidance",
    "choice_c": "Risk mitigation",
    "choice_d": "Risk transference",
    "correct_answer": "C",
    "explanation": "Installing new controls or upgrading existing controls is an effort to reduce the probability or magnitude of a risk. This is an example of a risk mitigation activity.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      50,
      51,
      52,
      54,
      56
    ],
    "source": "801931 c03"
  },
  {
    "id": 514,
    "question": "Grace recently completed a risk assessment of her organization’s exposure to data breaches and determined that there is a high level of risk related to the loss of sensitive personal information. She is considering a variety of approaches to managing this risk.<br>Grace is considering dropping the customer activities that collect and store sensitive personal information. What risk management strategy would Grace’s approach use?",
    "choice_a": "Risk acceptance",
    "choice_b": "Risk avoidance",
    "choice_c": "Risk mitigation",
    "choice_d": "Risk transference",
    "correct_answer": "B",
    "explanation": "Changing business processes or activities to eliminate a risk is an example of risk avoidance.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      50,
      52,
      51,
      53,
      54
    ],
    "source": "801931 c03"
  },
  {
    "id": 515,
    "question": "Grace recently completed a risk assessment of her organization’s exposure to data breaches and determined that there is a high level of risk related to the loss of sensitive personal information. She is considering a variety of approaches to managing this risk.<br>Grace’s company decided to install the web application firewall and continue doing business. They are still worried about other risks to the information that were not addressed by the firewall and are considering purchasing an insurance policy to cover those risks. What strategy does this use?",
    "choice_a": "Risk acceptance",
    "choice_b": "Risk avoidance",
    "choice_c": "Risk mitigation",
    "choice_d": "Risk transference",
    "correct_answer": "D",
    "explanation": "Insurance policies use a risk transference strategy by shifting some or all of the financial risk from the organization to an insurance company.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      50,
      53,
      51,
      52,
      54
    ],
    "source": "801931 c03"
  },
  {
    "id": 516,
    "question": "Grace recently completed a risk assessment of her organization’s exposure to data breaches and determined that there is a high level of risk related to the loss of sensitive personal information. She is considering a variety of approaches to managing this risk.<br>In the end, Grace found that the insurance policy was too expensive and opted not to purchase it. She is taking no additional action. What risk management strategy is Grace using in this situation?",
    "choice_a": "Risk acceptance",
    "choice_b": "Risk avoidance",
    "choice_c": "Risk mitigation",
    "choice_d": "Risk transference",
    "correct_answer": "A",
    "explanation": "When an organization decides to take no further action to address the remaining risk, they are choosing a strategy of risk acceptance.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      50,
      52,
      54,
      51,
      53
    ],
    "source": "801931 c03"
  },
  {
    "id": 372,
    "question": "Under the European Union’s GDPR, what term is assigned to the individual who leads an organization’s privacy efforts?",
    "choice_a": "Data protection officer",
    "choice_b": "Data controller",
    "choice_c": "Data steward",
    "choice_d": "Data processor",
    "correct_answer": "A",
    "explanation": "Under the General Data Protection Regulation (GDPR), the data protection officer (DPO) is an individual who is assigned the direct responsibility for carrying out an organization’s privacy program.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      64,
      63,
      79,
      77,
      40
    ],
    "source": "801931 c03"
  },
  {
    "id": 373,
    "question": "Helen’s organization maintains medical records on behalf of its customers, who are individual physicians. What term best describes the role of Helen’s organization?",
    "choice_a": "Data processor",
    "choice_b": "Data controller",
    "choice_c": "Data owner",
    "choice_d": "Data steward",
    "correct_answer": "A",
    "explanation": "In this case, the physicians maintain the data ownership role. They have chosen to outsource data processing to Helen’s organization, making that organization a data processor.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      63,
      62,
      91,
      90,
      131
    ],
    "source": "801931 c03"
  },
  {
    "id": 374,
    "question": "Gene recently conducted an assessment and determined that his organization can be without its main transaction database for a maximum of two hours before unacceptable damage occurs to the business. What metric has Gene identified?",
    "choice_a": "MTBF",
    "choice_b": "MTTR",
    "choice_c": "RTO",
    "choice_d": "RPO",
    "correct_answer": "C",
    "explanation": "The recovery time objective (RTO) is the amount of time that the organization can tolerate a system being down before it is repaired. That is the metric that Gene has identified in this scenario.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      58,
      81,
      83,
      79,
      78
    ],
    "source": "801931 c03"
  },
  {
    "id": 375,
    "question": "Tina works for a hospital system and manages the system’s patient records. What category of personal information best describes the information that is likely to be found in those records?",
    "choice_a": "PCI",
    "choice_b": "PHI",
    "choice_c": "PFI",
    "choice_d": "PII",
    "correct_answer": "B",
    "explanation": "This is a tricky question, as it is possible to find all of these categories of information in patient records. However, they are most likely to contain protected health information (PHI). PHI could also be described as a subcategory of personally identifiable information (PII), but PHI is a better description. It is also possible that the records might contain payment card information (PCI) or personal financial information (PFI), but that is less likely than PHI.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      62,
      64,
      63,
      40,
      32
    ],
    "source": "801931 c03"
  },
  {
    "id": 376,
    "question": "Asa believes that her organization is taking data collected from customers for technical support and using it for marketing without their permission. What principle is most likely being violated?",
    "choice_a": "Data minimization",
    "choice_b": "Data retention",
    "choice_c": "Purpose limitation",
    "choice_d": "Data sovereignty",
    "correct_answer": "C",
    "explanation": "Organizations should only use data for the purposes disclosed during the collection of that data. In this case, the organization collected data for technical support purposes and is now using it for marketing purposes. That violates the principle of purpose limitation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      64,
      62,
      63,
      40,
      90
    ],
    "source": "801931 c03"
  },
  {
    "id": 157,
    "question": "Which one of the following U.S. government classification levels requires the highest degree of security control?",
    "choice_a": "Secret",
    "choice_b": "Confidential",
    "choice_c": "Top Secret",
    "choice_d": "Unclassified",
    "correct_answer": "C",
    "explanation": "Top Secret is the highest level of classification under the U.S. system and, therefore, requires the highest level of security control.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      63,
      79,
      77,
      40,
      64
    ],
    "source": "801931 c03"
  },
  {
    "id": 378,
    "question": "Which of the following data protection techniques is reversible when conducted properly?",
    "choice_a": "Tokenization",
    "choice_b": "Masking",
    "choice_c": "Hashing",
    "choice_d": "Shredding",
    "correct_answer": "A",
    "explanation": "Tokenization techniques use a lookup table and are designed to be reversible. Masking and hashing techniques replace the data with values that can’t be reversed back to the original data if performed properly. Shredding, when conducted properly, physically destroys data so that it may not be recovered.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      64,
      62,
      137,
      138,
      116
    ],
    "source": "801931 c03"
  },
  {
    "id": 379,
    "question": "What term is given to an individual or organization who determines the reasons for processing personal information?",
    "choice_a": "Data steward",
    "choice_b": "Data controller",
    "choice_c": "Data processor",
    "choice_d": "Data custodian",
    "correct_answer": "B",
    "explanation": "Data controllers are the entities who determine the reasons for processing personal information and direct the methods of processing that data. This term is used primarily in European law, and it serves as a substitute for the term <i>data owner</i> to avoid a presumption that anyone who collects data has an ownership interest in that data.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      43,
      59,
      66,
      76,
      98
    ],
    "source": "801931 c03"
  },
  {
    "id": 380,
    "question": "Brian recently conducted a risk mitigation exercise and has determined the level of risk that remains after implementing a series of controls. What term best describes this risk?",
    "choice_a": "Inherent risk",
    "choice_b": "Control risk",
    "choice_c": "Risk appetite",
    "choice_d": "Residual risk",
    "correct_answer": "D",
    "explanation": "The residual risk is the risk that remains after an organization implements controls designed to mitigate, avoid, and/or transfer the inherent risk.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      54,
      50,
      51,
      49,
      45
    ],
    "source": "801931 c03"
  },
  {
    "id": 381,
    "question": "Which of the following measures is not commonly used to assess threat intelligence?",
    "choice_a": "Timeliness",
    "choice_b": "Detail",
    "choice_c": "Accuracy",
    "choice_d": "Relevance",
    "correct_answer": "B",
    "explanation": "Although higher levels of detail can be useful, they aren’t a common measure used to assess threat intelligence. Instead, the timeliness, accuracy, and relevance of the information are considered critical to determining whether you should use the threat information.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      74,
      75,
      76,
      73,
      49
    ],
    "source": "801931 c04"
  },
  {
    "id": 382,
    "question": "What language is STIX based on?",
    "choice_a": "PHP",
    "choice_b": "HTML",
    "choice_c": "XML",
    "choice_d": "Python",
    "correct_answer": "C",
    "explanation": "STIX is an XML-based language, allowing it to be easily extended and modified while also using standard XML-based editors, readers, and other tools.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      75,
      73,
      74,
      76,
      72
    ],
    "source": "801931 c04"
  },
  {
    "id": 383,
    "question": "Kolin is a penetration tester who works for a cybersecurity company. His firm was hired to conduct a penetration test against a health-care system, and Kolin is working to gain access to the systems belonging to a hospital in that system. What term best describes Kolin’s work?",
    "choice_a": "White hat",
    "choice_b": "Gray hat",
    "choice_c": "Green hat",
    "choice_d": "Black hat",
    "correct_answer": "A",
    "explanation": "Attacks that are conducted as part of an authorized penetration test are white-hat hacking attacks, regardless of whether they are conducted by internal employees or an external firm. Kolin is, therefore, engaged in white-hat hacking. If he were acting on his own, without authorization, his status would depend on his intent. If he had malicious intent, his activity would be considered black-hat hacking. If he simply intended to report vulnerabilities to the hospital, his attack would be considered gray hat. Green hat is not a commonly used category of attacker.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      67,
      66,
      71,
      70,
      68
    ],
    "source": "801931 c04"
  },
  {
    "id": 384,
    "question": "Which one of the following attackers is most likely to be associated with an APT?",
    "choice_a": "Nation-state actor",
    "choice_b": "Hacktivist",
    "choice_c": "Script kiddie",
    "choice_d": "Insider",
    "correct_answer": "A",
    "explanation": "Advanced persistent threats (APTs) are most commonly associated with nation-state actors. It is unlikely that an APT group would leverage the unsophisticated services of a script kiddie. It is also unlikely that a hacktivist would have access to APT resources. Although APTs may take advantage of insider access, they are most commonly associated with nation-state actors.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      69,
      68,
      66,
      70,
      72
    ],
    "source": "801931 c04"
  },
  {
    "id": 385,
    "question": "What organizations did the U.S. government help create to share knowledge between organizations in specific verticals?",
    "choice_a": "DHS",
    "choice_b": "SANS",
    "choice_c": "CERTS",
    "choice_d": "ISACs",
    "correct_answer": "D",
    "explanation": "The U.S. government created the Information Sharing and Analysis Centers (ISACs). ISACs help infrastructure owners and operators share threat information, and they provide tools and assistance to their members.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      73,
      75,
      76,
      74,
      43
    ],
    "source": "801931 c04"
  },
  {
    "id": 386,
    "question": "Which of the following threat actors typically has the greatest access to resources?",
    "choice_a": "Nation-state actors",
    "choice_b": "Organized crime",
    "choice_c": "Hacktivists",
    "choice_d": "Insider threats",
    "correct_answer": "A",
    "explanation": "Nation-state actors are government-sponsored, and they typically have the greatest access to resources, including tools, money, and talent.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      66,
      69,
      68,
      70,
      67
    ],
    "source": "801931 c04"
  },
  {
    "id": 387,
    "question": "Of the threat vectors shown here, which one is most commonly exploited by attackers who are at a distant location?",
    "choice_a": "Email",
    "choice_b": "Direct access",
    "choice_c": "Wireless",
    "choice_d": "Removable media",
    "correct_answer": "A",
    "explanation": "Email is the most common threat vector exploited by attackers who use phishing and other social engineering tactics to gain access to an organization. The other vectors listed here—direct access, wireless, and removable media—all require physical proximity to an organization and are not easily executed from a remote location.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      71,
      66,
      68,
      69,
      73
    ],
    "source": "801931 c04"
  },
  {
    "id": 388,
    "question": "Which one of the following is the best example of a hacktivist group?",
    "choice_a": "Chinese military",
    "choice_b": "U.S. government",
    "choice_c": "Russian mafia",
    "choice_d": "Anonymous",
    "correct_answer": "D",
    "explanation": "The Chinese military and U.S. government are examples of nation-state actors and advanced persistent threats (APTs). The Russian mafia is an example of a criminal syndicate. Anonymous is the world’s most prominent hacktivist group.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      68,
      66,
      71,
      70,
      69
    ],
    "source": "801931 c04"
  },
  {
    "id": 389,
    "question": "What type of assessment is particularly useful for identifying insider threats?",
    "choice_a": "Behavioral",
    "choice_b": "Instinctual",
    "choice_c": "Habitual",
    "choice_d": "IOCs",
    "correct_answer": "A",
    "explanation": "Behavioral assessments are very useful when you are attempting to identify insider threats. Since insider threats are often hard to distinguish from normal behavior, the context of the actions performed—such as after-hours logins, misuse of credentials, logins from abnormal locations, or abnormal patterns—and other behavioral indicators are often used.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      70,
      66,
      49,
      43,
      44
    ],
    "source": "801931 c04"
  },
  {
    "id": 390,
    "question": "Cindy wants to send threat information via a standardized protocol specifically designed to exchange cyberthreat information. What should she choose?",
    "choice_a": "STIX 1.0",
    "choice_b": "OpenIOC",
    "choice_c": "STIX 2.0",
    "choice_d": "TAXII",
    "correct_answer": "D",
    "explanation": "TAXII, the Trusted Automated Exchange of Intelligence Information protocol, is specifically designed to communicate cyberthreat information at the application layer. OpenIOC is a compromise indicator framework, and STIX is a threat description language.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      75,
      73,
      74,
      71,
      66
    ],
    "source": "801931 c04"
  },
  {
    "id": 391,
    "question": "Greg believes that an attacker may have installed malicious firmware in a network device before it was provided to his organization by the supplier. What type of threat vector best describes this attack?",
    "choice_a": "Supply chain",
    "choice_b": "Removable media",
    "choice_c": "Cloud",
    "choice_d": "Direct access",
    "correct_answer": "A",
    "explanation": "Tampering with equipment before it reaches the intended user is an example of a supply chain threat. It is also possible to describe this attack as a direct access attack because it involved physical access to the device, but supply chain is a more relevant answer. You should be prepared to select the best possible choice from several possible correct answers when you take the exam. Exam questions often use this type of misdirection.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      48,
      71,
      43,
      66,
      57
    ],
    "source": "801931 c04"
  },
  {
    "id": 392,
    "question": "Ken is conducting threat research on Transport Layer Security (TLS) and would like to consult the authoritative reference for the protocol’s technical specification. What resource would best meet his needs?",
    "choice_a": "Academic journal",
    "choice_b": "Internet RFCs",
    "choice_c": "Subject matter experts",
    "choice_d": "Textbooks",
    "correct_answer": "B",
    "explanation": "All of these resources might contain information about the technical details of TLS, but Internet Request for Comments (RFC) documents are the definitive technical standards for Internet protocols. Consulting the RFCs would be Ken’s best option.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      106,
      106
    ],
    "source": "801931 c04"
  },
  {
    "id": 393,
    "question": "Wendy is scanning cloud-based repositories for sensitive information. Which one of the following should concern her most if discovered in a public repository?",
    "choice_a": "Product manuals",
    "choice_b": "Source code",
    "choice_c": "API keys",
    "choice_d": "Open source data",
    "correct_answer": "C",
    "explanation": "All of these items could be concerning, depending on the circumstances. However, API keys should <i>never</i> be found in public repositories because they may grant unauthorized individuals access to information and resources.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      71,
      44,
      48,
      73,
      65
    ],
    "source": "801931 c04"
  },
  {
    "id": 394,
    "question": "Which one of the following threat research tools is used to visually display information about the location of threat actors?",
    "choice_a": "Threat map",
    "choice_b": "Predictive analysis",
    "choice_c": "Vulnerability feed",
    "choice_d": "STIX",
    "correct_answer": "A",
    "explanation": "Threat maps are graphical tools that display information about the geographic locations of attackers and their targets. These tools are most often used as interesting marketing gimmicks, but they can also help identify possible threat sources.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      76,
      73,
      75,
      69,
      68
    ],
    "source": "801931 c04"
  },
  {
    "id": 395,
    "question": "Vince recently received the hash values of malicious software that several other firms in his industry found installed on their systems after a compromise. What term best describes this information?",
    "choice_a": "Vulnerability feed",
    "choice_b": "IoC",
    "choice_c": "TTP",
    "choice_d": "RFC",
    "correct_answer": "B",
    "explanation": "Specific details of attacks that may be used to identify compromises are known as indicators of compromise (IoCs). This data may also be described as an adversary tactic, technique, or procedure (TTP), but the fact that it is a set of file signatures makes it more closely match the definition of an IoC.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      75,
      73,
      74,
      69,
      71
    ],
    "source": "801931 c04"
  },
  {
    "id": 396,
    "question": "Ursula recently discovered that a group of developers are sharing information over a messaging tool provided by a cloud vendor but not sanctioned by her organization. What term best describes this use of technology?",
    "choice_a": "Shadow IT",
    "choice_b": "System integration",
    "choice_c": "Vendor management",
    "choice_d": "Data exfiltration",
    "correct_answer": "A",
    "explanation": "The developers in question are using unapproved technology for business purposes. This is the classic definition of shadow IT. It is possible to describe this as data exfiltration, but there is no indication that the data security has been compromised, so shadow IT is a better description here. Remember, you will often be asked to choose the best answer from multiple correct answers on the exam.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      70,
      44,
      43,
      50,
      51
    ],
    "source": "801931 c04"
  },
  {
    "id": 397,
    "question": "Tom’s organization recently learned that his vendor is discontinuing support for their customer relationship management (CRM) system. What should concern Tom the most from a security perspective?",
    "choice_a": "Unavailability of future patches",
    "choice_b": "Lack of technical support",
    "choice_c": "Theft of customer information",
    "choice_d": "Increased costs",
    "correct_answer": "A",
    "explanation": "Tom’s greatest concern should be that running unsupported software exposes his organization to the risk of new, unpatchable vulnerabilities. It is certainly true that Tom will no longer receive technical support, but this is a less important issue from a security perspective. There is no indication in this scenario that discontinuing the product will result in the theft of customer information or increased costs.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      43,
      44,
      48,
      51,
      50
    ],
    "source": "801931 c04"
  },
  {
    "id": 398,
    "question": "Which one of the following information sources would not be considered an OSINT source?",
    "choice_a": "DNS lookup",
    "choice_b": "Search engine research",
    "choice_c": "Port scans",
    "choice_d": "WHOIS queries",
    "correct_answer": "C",
    "explanation": "Port scans are an active reconnaissance technique that probe target systems and would not be considered open source intelligence (OSINT). Search engine research, DNS lookups, and WHOIS queries are all open source resources.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      73,
      74,
      75,
      71,
      67
    ],
    "source": "801931 c04"
  },
  {
    "id": 399,
    "question": "Edward Snowden was a government contractor who disclosed sensitive government documents to journalists to uncover what he believed were unethical activities. Which two of the following terms best describe Snowden’s activities? (Choose two.)",
    "choice_a": "Insider",
    "choice_b": "State actor",
    "choice_c": "Hacktivist",
    "choice_d": "APT",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "As a government contractor, Snowden had authorized access to classified information and exploited this access to make an unauthorized disclosure of that information. This clearly makes him fit into the category of an insider. He did so with political motivations, making him fit the category of hacktivist as well.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      68,
      66,
      70,
      67,
      44
    ],
    "source": "801931 c04",
    "choice_e": "Organized crime"
  },
  {
    "id": 517,
    "question": "Renee is a cybersecurity hobbyist. She receives an email about a new web-based grading system being used by her son’s school and she visits the site. She notices that the URL for the site looks like this:<br><code>https://www.myschool.edu/grades.php&studentID=1023425</code><br>She realizes that 1023425 is her son’s student ID number and then attempts to access the following similar URLs:<br><code>https://www.myschool.edu/grades.php&studentID=1023423</code><br><code>https://www.myschool.edu/grades.php&studentID=1023424</code><br><code>https://www.myschool.edu/grades.php&studentID=1023426</code><br><code>https://www.myschool.edu/grades.php&studentID=1023427</code><br>When she does so, she accesses the records of other students. She closes the records and immediately informs the school principal of the vulnerability. What term best describes Renee’s work?",
    "choice_a": "White-hat hacking",
    "choice_b": "Green-hat hacking",
    "choice_c": "Gray-hat hacking",
    "choice_d": "Black-hat hacking",
    "correct_answer": "C",
    "explanation": "Renee was not authorized to perform this security testing, so her work does not fit into the category of white-hat hacking. However, she also does not have malicious intent, so her work cannot be categorized as a black-hat attack. Instead, it fits somewhere in between the two extremes and would best be described as gray-hat hacking.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      67,
      66,
      68,
      70,
      65
    ],
    "source": "801931 c04"
  },
  {
    "id": 401,
    "question": "Which one of the following elements is <i>least</i> likely to be found in an information security program charter?",
    "choice_a": "Scope statement",
    "choice_b": "Project schedule",
    "choice_c": "Roles and responsibilities",
    "choice_d": "Governance structure",
    "correct_answer": "B",
    "explanation": "Information security program charters commonly contain high-level organizational items, such as a scope statement, statement of roles and responsibilities, and description of the governance structure. A project schedule is a more tactical document that would not normally be included in a program-level charter due to its changing nature.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      79,
      78,
      77,
      80,
      82
    ],
    "source": "801931 c05"
  },
  {
    "id": 402,
    "question": "Victoria’s organization has a disconnect between the human resources function and the information security function. As a result, employee transfers are not being properly handled. What is the greatest security risk resulting from this situation?",
    "choice_a": "Privilege escalation",
    "choice_b": "Separation of duties",
    "choice_c": "Privilege creep",
    "choice_d": "Two-person control",
    "correct_answer": "C",
    "explanation": "Privilege creep occurs when an employee transfers within the organization and does not have their old privileges revoked. Privilege creep may occur when transfers are not properly processed and, if left unchecked, violates the principle of least privilege.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      92,
      155,
      93,
      96,
      83
    ],
    "source": "801931 c05"
  },
  {
    "id": 403,
    "question": "Leo is responsible for managing his organization’s information security budget. Which one of the following circumstances is the most preferred situation?",
    "choice_a": "Expenses greatly exceed budget.",
    "choice_b": "Expenses slightly exceed budget.",
    "choice_c": "Expenses are slightly under budget.",
    "choice_d": "Expenses are greatly under budget.",
    "correct_answer": "C",
    "explanation": "The best-case scenario is that expenses are close to the budgeted amount but do not exceed the actual budget. Budget overages are difficult because funds may not be available to cover all expenses. When expenses are significantly under budget, the organization suffers an opportunity cost because those funds could have been used for other purposes or returned to shareholders as profit.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      89,
      96,
      83,
      80,
      79
    ],
    "source": "801931 c05"
  },
  {
    "id": 404,
    "question": "Andrew is concerned that his security program is not well aligned with business goals and would like to convene a group to help guide his work. What type of group would best meet his needs?",
    "choice_a": "Change advisory board (CAB)",
    "choice_b": "Senior leadership",
    "choice_c": "Board",
    "choice_d": "Steering committee",
    "correct_answer": "D",
    "explanation": "Steering committees help facilitate alignment between security and business objectives. The security manager can convene a group that represents business units and get their input in the development of security plans. The change advisory board (CAB) is designed to manage change requests, not to provide input on security activities. Senior leadership teams and the board operate at an executive level and would not likely have the time or expertise to participate in this effort.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      80,
      79,
      82,
      83,
      96
    ],
    "source": "801931 c05"
  },
  {
    "id": 405,
    "question": "Norma is developing a new information security standard for her organization and would like to ensure that the policy has appropriate authority and goes through an appropriate approval process. Where should she look to verify this is the case?",
    "choice_a": "Scope statement",
    "choice_b": "RFC",
    "choice_c": "NDA",
    "choice_d": "Charter",
    "correct_answer": "D",
    "explanation": "The information security program charter should contain program documentation procedures that formalize how the organization will establish, communicate, and maintain information security standards and other documents. This would not be found in a short scope statement, a request for change (RFC), or a nondisclosure agreement (NDA).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      79,
      78,
      32,
      35,
      80
    ],
    "source": "801931 c05"
  },
  {
    "id": 406,
    "question": "Dan would like to add a new element to his organization’s information security awareness program. Which one of the following tools would be most appropriate?",
    "choice_a": "End user training",
    "choice_b": "Certification",
    "choice_c": "Capture the flag",
    "choice_d": "Posters",
    "correct_answer": "D",
    "explanation": "Awareness efforts are not designed to impart new knowledge but simply to remind employees of security information they have already learned. Of the techniques listed here, only posters are an awareness mechanism. All of the other techniques are training tools designed to impart new knowledge.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      84,
      83,
      82,
      77,
      81
    ],
    "source": "801931 c05"
  },
  {
    "id": 407,
    "question": "Alexis is working to develop standard language for use with vendors that will ensure that her organization retains ownership of data handled by the vendor. Where would be the best location to include this language?",
    "choice_a": "Contract",
    "choice_b": "NDA",
    "choice_c": "MOU",
    "choice_d": "SOW",
    "correct_answer": "A",
    "explanation": "Data ownership language should be legally binding and part of the master agreement with the vendor. As it is such an important topic, it should be included in the formal contract with the vendor. It is not appropriate subject matter for a nondisclosure agreement (NDA) that focuses on confidentiality or a less formal vehicle, such as a memorandum of understanding (MOU) or statement of work (SOW).",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      90,
      91,
      92,
      79,
      35
    ],
    "source": "801931 c05"
  },
  {
    "id": 408,
    "question": "Bob is developing a set of measures designed to evaluate how well the information security program in his organization is functioning. He will provide monthly reporting on these metrics, looking back at the program’s functioning over the past month. What term best describes these metrics?",
    "choice_a": "KMIs",
    "choice_b": "KGIs",
    "choice_c": "KRIs",
    "choice_d": "KPIs",
    "correct_answer": "D",
    "explanation": "Key performance indicators (KPIs) are metrics that demonstrate the success of the security program in achieving its objectives. KPIs are mutually agreed-upon measures that evaluate whether a security program is meeting its defined goals. Generally speaking, KPIs are a look back at historical performance, providing a measuring stick to evaluate the past success of the program. Key goal indicators (KGIs) are similar to KPIs but measure progress toward defined goals. For example, if an organization has a goal to eliminate all stored Social Security numbers (SSNs), a KGI might track the percentage of SSNs removed. Key risk indicators (KRIs) are measures that seek to quantify the security risk facing an organization. KRIs, unlike KPIs and KGIs, are a look forward. They attempt to show how much risk exists that may jeopardize the future security of the organization. KMIs are not a standard metric for cybersecurity programs.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      81,
      82,
      83,
      80,
      40
    ],
    "source": "801931 c05"
  },
  {
    "id": 409,
    "question": "Tanya is hiring a new incident analyst to help supplement the capabilities of her team. She is identifying the line item in her budget that will cover the salary and benefits for this new employee. What term best describes this expense?",
    "choice_a": "One-time",
    "choice_b": "Capital",
    "choice_c": "Unbudgeted",
    "choice_d": "Operational",
    "correct_answer": "D",
    "explanation": "This is an operational expense, since it is a payroll expenditure, rather than a large purchase of capital equipment. The cost of hiring an employee is a recurring cost, rather than a one-time cost. The scenario does not identify whether the expense was budgeted or unbudgeted.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      88,
      89,
      85,
      81,
      79
    ],
    "source": "801931 c05"
  },
  {
    "id": 410,
    "question": "Gary’s organization uses a fiscal year budgeting system, with the fiscal year beginning on January 1. He is planning for an expense that will occur in June 2024. During what fiscal and calendar year will this expense occur?",
    "choice_a": "CY24 and FY24",
    "choice_b": "CY24 and FY25",
    "choice_c": "CY24 and FY23",
    "choice_d": "CY25 and FY24",
    "correct_answer": "A",
    "explanation": "Gary’s organization uses a fiscal year beginning on January 1. This means that the fiscal year and calendar year are aligned and they will always be the same. June 2024 is a month during the calendar year 2024 and, because the fiscal year is aligned with the calendar year, it is also the fiscal year 2024.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      87,
      86,
      89,
      80,
      81
    ],
    "source": "801931 c05"
  },
  {
    "id": 411,
    "question": "The Acme Widgets Company is putting new controls in place for its accounting department. Management is concerned that a rogue accountant may be able to create a new false vendor and then issue checks to that vendor as payment for services that were never rendered. What security control can best help prevent this situation?",
    "choice_a": "Mandatory vacation",
    "choice_b": "Separation of duties",
    "choice_c": "Defense in depth",
    "choice_d": "Job rotation",
    "correct_answer": "B",
    "explanation": "When following the separation of duties principle, organizations divide critical tasks into discrete components and ensure that no one individual has the ability to perform both actions. This prevents a single rogue individual from performing that task in an unauthorized manner.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      93,
      35,
      96,
      90,
      79
    ],
    "source": "801931 c05"
  },
  {
    "id": 412,
    "question": "An accounting employee at Doolittle Industries was recently arrested for participation in an embezzlement scheme. The employee transferred money to a personal account and then shifted funds around between other accounts every day to disguise the fraud for months. Which one of the following controls might have best allowed the earlier detection of this fraud?",
    "choice_a": "Separation of duties",
    "choice_b": "Least privilege",
    "choice_c": "Defense in depth",
    "choice_d": "Mandatory vacation",
    "correct_answer": "D",
    "explanation": "Mandatory vacation programs require that employees take continuous periods of time off each year and revoke their system privileges during that time. The purpose of these required vacation periods is to disrupt any attempt to engage in the cover-up actions necessary to hide fraud and result in exposing the threat. Separation of duties, least privilege, and defense-in-depth controls all may help prevent the fraud in the first place but are unlikely to speed the detection of fraud that has already occurred.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      93,
      92,
      155,
      94,
      95
    ],
    "source": "801931 c05"
  },
  {
    "id": 413,
    "question": "After completing the first year of his security awareness program, Charles reviews the data about how many personnel completed training compared to how many were assigned the training to determine whether he hit the 95 percent completion rate he was aiming for. What is this type of measure called?",
    "choice_a": "A KPI",
    "choice_b": "A metric",
    "choice_c": "An awareness control",
    "choice_d": "A return on investment rate",
    "correct_answer": "A",
    "explanation": "Charles is tracking a key performance indicator (KPI). A KPI is used to measure performance (and success). Without a definition of success, this would simply be a metric, but Charles is working toward a known goal and can measure against it. There is not a return investment calculation in this problem, and the measure is not a control.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      81,
      84,
      80,
      79,
      89
    ],
    "source": "801931 c05"
  },
  {
    "id": 414,
    "question": "Which one of the following efforts allows security professionals to validate their knowledge to current and potential employers?",
    "choice_a": "Training",
    "choice_b": "Certification",
    "choice_c": "Awareness",
    "choice_d": "Accreditation",
    "correct_answer": "B",
    "explanation": "Certifications help employees validate their skills and are an important recruiting and retention tool. Training programs help employees keep their skills current and develop skills in new areas of cybersecurity. Awareness efforts are meant to reinforce security knowledge. Accreditation processes are used to formally certify systems in government and military applications.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      85,
      84,
      86,
      81,
      80
    ],
    "source": "801931 c05"
  },
  {
    "id": 415,
    "question": "Which one of the following statements about change management programs is correct?",
    "choice_a": "All changes must be approved by the change advisory board (CAB).",
    "choice_b": "Minor changes do not require an RFC.",
    "choice_c": "Some RFCs may be immediately approved on an automated basis.",
    "choice_d": "The primary purpose of change management is to create a paper trail to support audits.",
    "correct_answer": "C",
    "explanation": "In a formal change management program, all changes require an RFC, no matter how minor. However, some routine changes have preapproved status and may be made as soon as the RFC is submitted. RFCs for these changes are automatically approved. Once someone submits an RFC for review, it must be approved by a relevant authority. For minor changes, this may simply be the person’s manager. In the case of major changes, the organization’s CAB may review and approve the change. The primary purpose of change management is to minimize the probability and impact of disruptions to IT services due to changes. Change management does support audits, but this is not the primary purpose of the function.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      95,
      146,
      97,
      35,
      80
    ],
    "source": "801931 c05"
  },
  {
    "id": 416,
    "question": "Wendy is designing a pre-employment screening program for her organization. Which one of the following screening techniques is commonly omitted due to legal and privacy concerns?",
    "choice_a": "Credit checks",
    "choice_b": "Criminal background checks",
    "choice_c": "Reference checks",
    "choice_d": "Education verification",
    "correct_answer": "A",
    "explanation": "Background screening often includes criminal background checks, sex offender registry lookups, reference checks, and employment/education verification. In some cases, organizations may perform credit checks to further investigate an employee’s background, although obtaining and using this information requires written consent and is heavily regulated, so many organizations skip this part of checks.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      92,
      62,
      63,
      90,
      84
    ],
    "source": "801931 c05"
  },
  {
    "id": 417,
    "question": "Elliott is evaluating a new content management system that an outside service provider will host for his organization. What is the most appropriate minimum security standard for him to require of possible vendors?",
    "choice_a": "Handling information in the same manner the organization would",
    "choice_b": "Compliance with the vendor’s own policies",
    "choice_c": "Compliance with all laws and regulations",
    "choice_d": "Elimination of all identified security risks",
    "correct_answer": "A",
    "explanation": "The most appropriate standard to use as a baseline when evaluating vendors is to determine whether the vendor’s security controls meet the organization’s own standards. Compliance with laws and regulations should be included in that requirement and are a necessary, but not sufficient, condition for working with the vendor. Vendor compliance with their own policies also fits into the category of necessary, but not sufficient, controls, since the vendor’s policy may be weaker than the organization’s own requirements. The elimination of all identified security risks is an impossible requirement for a potential vendor to meet.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      90,
      91,
      77,
      79,
      35
    ],
    "source": "801931 c05"
  },
  {
    "id": 418,
    "question": "Abe works for an organization that has several subsidiaries that operate independently. Those subsidiaries report to different leaders and have their own independent security programs. If the governance model does not change, what would be the appropriate way for Abe’s security program to address this situation?",
    "choice_a": "Limit the objectives of his program.",
    "choice_b": "Limit the scope of his program.",
    "choice_c": "Include the subsidiaries in his program.",
    "choice_d": "Replace the subsidiary programs with his own.",
    "correct_answer": "B",
    "explanation": "The current governance structure allows these subsidiaries to remain independent. Therefore, it is not appropriate to include them in the parent organization’s program or replace their programs. Instead, Abe should limit the portion of the organization included in his program, which is a limitation of scope.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      78,
      79,
      80,
      83,
      95
    ],
    "source": "801931 c05"
  },
  {
    "id": 419,
    "question": "Sally is developing a set of metrics that will help her organization assess changes in the threat environment and adjust their security program accordingly. What type of metrics is she developing?",
    "choice_a": "KMIs",
    "choice_b": "KGIs",
    "choice_c": "KRIs",
    "choice_d": "KPIs",
    "correct_answer": "C",
    "explanation": "Key risk indicators (KRIs) are measures that seek to quantify the security risk facing an organization. KRIs, unlike KPIs and KGIs, are a look forward. They attempt to show how much risk exists that may jeopardize the future security of the organization. Key performance indicators (KPIs) are metrics that demonstrate the success of the security program in achieving its objectives. KPIs are mutually agreed-upon measures that evaluate whether a security program is meeting its defined goals. Generally speaking, KPIs are a look back at historical performance, providing a measuring stick to evaluate the past success of the program. Key goal indicators (KGIs) are similar to KPIs but measure progress toward defined goals. For example, if an organization has a goal to eliminate all stored Social Security numbers (SSNs), a KGI might track the percentage of SSNs removed. KMIs are not a standard metric for cybersecurity programs.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      81,
      83,
      82,
      80,
      40
    ],
    "source": "801931 c05"
  },
  {
    "id": 420,
    "question": "Tia recently created a set of high-level security metrics for senior leaders who need to understand the effectiveness of the security program. What would be the best way for her to communicate these metrics?",
    "choice_a": "Continue to post them on a dashboard that is available to stakeholders to peruse at their convenience.",
    "choice_b": "Provide stakeholders with access to a web page that contains detailed security metrics.",
    "choice_c": "Email a copy of the dashboard to stakeholders periodically.",
    "choice_d": "Provide reporting to stakeholders that contextualizes these metrics.",
    "correct_answer": "D",
    "explanation": "One common mistake made by information security managers is to develop a dashboard or web page with updated metrics and then simply inform stakeholders that they may view those metrics whenever they like. This approach has two major drawbacks. First, stakeholders who are not involved in security on a day-to-day basis are unlikely to revisit the site unless prompted to do so periodically. Second, providing metrics is only one piece of the picture. Security managers should also provide context for those metrics to explain changes and update stakeholders on the progress of the program.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      82,
      80,
      81,
      84,
      85
    ],
    "source": "801931 c05"
  },
  {
    "id": 421,
    "question": "Which one of the following security assessment techniques assumes that an organization has already been compromised and searches for evidence of that compromise?",
    "choice_a": "Vulnerability scanning",
    "choice_b": "Penetration testing",
    "choice_c": "Threat hunting",
    "choice_d": "War driving",
    "correct_answer": "C",
    "explanation": "Threat hunting is an assessment technique that makes an assumption of compromise and then searches the organization for indicators of compromise that confirm the assumption. Vulnerability scanning, penetration testing, and war driving are all assessment techniques that probe for vulnerabilities but do not assume that a compromise has already taken place.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      73,
      74,
      75,
      76,
      102
    ],
    "source": "801931 c06"
  },
  {
    "id": 518,
    "question": "Renee is configuring her vulnerability management solution to perform credentialed scans of servers on her network.<br>What type of account should she provide to the scanner?",
    "choice_a": "Domain administrator",
    "choice_b": "Local administrator",
    "choice_c": "Root",
    "choice_d": "Read-only",
    "correct_answer": "D",
    "explanation": "Credentialed scans require only read-only access to target servers. Renee should follow the principle of least privilege and limit the access available to the scanner.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      100,
      93,
      99,
      97,
      155
    ],
    "source": "801931 c06"
  },
  {
    "id": 423,
    "question": "Ryan is planning to conduct a vulnerability scan of a business-critical system using dangerous plug-ins. What would be the best approach for the initial scan?",
    "choice_a": "Run the scan against production systems to achieve the most realistic results possible.",
    "choice_b": "Run the scan during business hours.",
    "choice_c": "Run the scan in a test environment.",
    "choice_d": "Do not run the scan to avoid disrupting the business.",
    "correct_answer": "C",
    "explanation": "Ryan should first run his scan against a test environment to identify likely vulnerabilities and assess whether the scan itself might disrupt business activities.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      99,
      97,
      146,
      95,
      108
    ],
    "source": "801931 c06"
  },
  {
    "id": 424,
    "question": "Tina is searching for potential gaps in her organization’s incident response plan and gathers the team together for an exercise. They do not use any actual IT systems (production or test) in their work but simply discuss how they would respond to a scenario. What term best describes this test?",
    "choice_a": "Red team exercise",
    "choice_b": "Blue team exercise",
    "choice_c": "Tabletop exercise",
    "choice_d": "Purple team exercise",
    "correct_answer": "C",
    "explanation": "The scenario does not provide us with enough information to determine whether this exercise involved red team, blue team, or purple team tactics, and in fact, those exercises typically involve live access to systems. Tabletop exercises, on the other hand, are designed to walk teams through a scenario, and that is what Tina is doing in this instance.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      33,
      83,
      80,
      78,
      95
    ],
    "source": "801931 c06"
  },
  {
    "id": 425,
    "question": "Tara recently analyzed the results of a vulnerability scan report and found that a vulnerability reported by the scanner did not exist because the system was actually patched as specified. What type of error occurred?",
    "choice_a": "False positive",
    "choice_b": "False negative",
    "choice_c": "True positive",
    "choice_d": "True negative",
    "correct_answer": "A",
    "explanation": "A false positive error occurs when the vulnerability scanner reports a vulnerability that does not actually exist.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      102,
      43,
      46,
      56,
      49
    ],
    "source": "801931 c06"
  },
  {
    "id": 426,
    "question": "Brian ran a penetration test against a school’s grading system and discovered a flaw that would allow students to alter their grades by exploiting a SQL injection vulnerability. What type of control should he recommend to the school’s cybersecurity team to prevent students from engaging in this type of activity?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Alteration",
    "choice_d": "Availability",
    "correct_answer": "B",
    "explanation": "By allowing students to change their own grades, this vulnerability provides a pathway to unauthorized alteration of information. Brian should recommend that the school deploy integrity controls that prevent unauthorized modifications.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      136,
      151,
      40,
      107,
      110
    ],
    "source": "801931 c06"
  },
  {
    "id": 427,
    "question": "Which one of the following is least likely to affect the type and frequency of vulnerability scans run by an organization?",
    "choice_a": "Technical constraints",
    "choice_b": "License limitations",
    "choice_c": "Regulatory Requirements",
    "choice_d": "Holidays",
    "correct_answer": "D",
    "explanation": "There is no reason that an organization can’t run vulnerability scans on weekends or holidays. On the other hand, vulnerability scan possibilities may be limited by technical constraints, regulatory requirements, and license limitations.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      98,
      54,
      50,
      45,
      56
    ],
    "source": "801931 c06"
  },
  {
    "id": 519,
    "question": "During a vulnerability scan, Brian discovered that a system on his network contained the below vulnerability. What security control, if deployed, would likely have addressed this issue?<br><img src=\"/question_assets/CISM/801931_c06_image1.png\"/>",
    "choice_a": "Patch management",
    "choice_b": "File integrity monitoring",
    "choice_c": "Intrusion detection",
    "choice_d": "Threat hunting",
    "correct_answer": "A",
    "explanation": "This vulnerability is corrected by a patch that was released by Microsoft in 2017. A strong patch management program would have identified and remediated the missing patch.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      104,
      117,
      97,
      103,
      95
    ],
    "source": "801931 c06"
  },
  {
    "id": 429,
    "question": "Which one of the following tools is most likely to detect an XSS vulnerability?",
    "choice_a": "Static application test",
    "choice_b": "Web application vulnerability scanner",
    "choice_c": "Intrusion detection system",
    "choice_d": "Network vulnerability scanner",
    "correct_answer": "B",
    "explanation": "Intrusion detection systems do not detect vulnerabilities; they detect attacks. The remaining three tools could all possibly discover a cross-site scripting (XSS) vulnerability, but a web application vulnerability scanner is the most likely to detect it because it is specifically designed to test web applications.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      101,
      123,
      100,
      103,
      107
    ],
    "source": "801931 c06"
  },
  {
    "id": 430,
    "question": "During a penetration test, Patrick deploys a toolkit on a compromised system and uses it to gain access to other systems on the same network. What term best describes this activity?",
    "choice_a": "Lateral movement",
    "choice_b": "Privilege escalation",
    "choice_c": "Footprinting",
    "choice_d": "OSINT",
    "correct_answer": "A",
    "explanation": "Moving from one compromised system to other systems on the same network is known as lateral movement. Privilege escalation attacks increase the level of access that an attacker has to an already compromised system. Footprinting and OSINT are reconnaissance techniques.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      67,
      66,
      68,
      71,
      69
    ],
    "source": "801931 c06"
  },
  {
    "id": 431,
    "question": "Kevin is participating in a security exercise for his organization. His role in the exercise is to use hacking techniques to attempt to gain access to the organization’s systems. What role is Kevin playing in this exercise?",
    "choice_a": "Red team",
    "choice_b": "Blue team",
    "choice_c": "Purple team",
    "choice_d": "White team",
    "correct_answer": "A",
    "explanation": "Offensive hacking is used by red teams as they attempt to gain access to systems on the target network. Blue teams are responsible for managing the organization’s defenses. White teams serve as the neutral moderators of the exercise. Purple teaming is conducted after an exercise to bring together the red and blue teams for knowledge sharing.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      112,
      107,
      113,
      114,
      79
    ],
    "source": "801931 c06"
  },
  {
    "id": 432,
    "question": "Which one of the following assessment techniques is designed to solicit participation from external security experts and reward them for discovering vulnerabilities?",
    "choice_a": "Threat hunting",
    "choice_b": "Penetration testing",
    "choice_c": "Bug bounty",
    "choice_d": "Vulnerability scanning",
    "correct_answer": "C",
    "explanation": "Bug bounty programs are designed to allow external security experts to test systems and uncover previously unknown vulnerabilities. Bug bounty programs offer successful testers financial rewards to incentivize their participation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      114,
      107,
      109,
      112,
      99
    ],
    "source": "801931 c06"
  },
  {
    "id": 433,
    "question": "Kyle is conducting a penetration test. After gaining access to an organization’s database server, he installs a backdoor on the server to grant himself access in the future. What term best describes this action?",
    "choice_a": "Privilege escalation",
    "choice_b": "Lateral movement",
    "choice_c": "Maneuver",
    "choice_d": "Persistence",
    "correct_answer": "D",
    "explanation": "Backdoors are a persistence tool, designed to make sure that the attacker’s access persists after the original vulnerability is remediated. Kyle can use this backdoor to gain access to the system in the future, even if the original exploit that he used to gain access is no longer effective.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      67,
      69,
      68,
      71,
      51
    ],
    "source": "801931 c06"
  },
  {
    "id": 434,
    "question": "Which one of the following techniques would be considered passive reconnaissance?",
    "choice_a": "Port scans",
    "choice_b": "Vulnerability scans",
    "choice_c": "WHOIS lookups",
    "choice_d": "Footprinting",
    "correct_answer": "C",
    "explanation": "WHOIS lookups use external registries and are an example of open source intelligence (OSINT), which is a passive reconnaissance technique. Port scans, vulnerability scans, and footprinting all require active engagement with the target and are, therefore, active reconnaissance.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      73,
      74,
      75,
      71,
      67
    ],
    "source": "801931 c06"
  },
  {
    "id": 435,
    "question": "Brandon is conducting a penetration test to detect gaps in his organization’s security controls. While conducting the test, Brandon should adopt which of the following mindsets?",
    "choice_a": "Defender’s mindset",
    "choice_b": "Manager’s mindset",
    "choice_c": "Executive’s mindset",
    "choice_d": "Attacker’s mindset",
    "correct_answer": "D",
    "explanation": "Penetration testers must take a very different approach in their thinking. Instead of trying to defend against all possible threats, they only need to find a single vulnerability that they might exploit to achieve their goals. To find these flaws, they must think like the adversary who might attack the system in the real world. This approach is commonly known as adopting the <i>hacker mindset</i>.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      107,
      108,
      109,
      110,
      112
    ],
    "source": "801931 c06"
  },
  {
    "id": 436,
    "question": "Bruce is conducting a penetration test for a client. The client provided him with details of their systems in advance. What type of test is Bruce conducting?",
    "choice_a": "Gray-box test",
    "choice_b": "Blue-box test",
    "choice_c": "White-box test",
    "choice_d": "Black-box test",
    "correct_answer": "C",
    "explanation": "White-box tests are performed with full knowledge of the underlying technology, configurations, and settings that make up the target. Black-box tests are intended to replicate what an attacker would encounter. Testers are not provided with access to or information about an environment, but instead, they must gather information, discover vulnerabilities, and make their way through an infrastructure or systems as an attacker would. Gray-box tests are a blend of black-box and white-box testing. Blue-box tests are not a type of penetration test.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      109,
      110,
      108,
      107,
      112
    ],
    "source": "801931 c06"
  },
  {
    "id": 437,
    "question": "Lila is working on a penetration testing team and she is unsure whether she is allowed to conduct social engineering as part of the test. What document should she consult to find this information?",
    "choice_a": "Contract",
    "choice_b": "Statement of work",
    "choice_c": "Rules of engagement",
    "choice_d": "Lessons learned report",
    "correct_answer": "C",
    "explanation": "The rules of engagement provide technical details on the parameters of the test. This level of detail would not normally be found in a contract or statement of work. The lessons learned report is not produced until after the test.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      110,
      114,
      108,
      112,
      95
    ],
    "source": "801931 c06"
  },
  {
    "id": 438,
    "question": "Grace would like to determine the operating system running on a system that she is targeting in a penetration test. Which one of the following techniques will most directly provide her with this information?",
    "choice_a": "Port scanning",
    "choice_b": "Footprinting",
    "choice_c": "Vulnerability scanning",
    "choice_d": "Packet capture",
    "correct_answer": "B",
    "explanation": "All of these techniques might provide Grace with information about the operating system running on a device. However, footprinting is a technique specifically designed to elicit this information.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      73,
      67,
      71,
      66,
      74
    ],
    "source": "801931 c06"
  },
  {
    "id": 271,
    "question": "Phil is conducting a penetration test and has gained access to a target system. The account he has on that system is a standard user account, and Phil is installing a tool that will allow him to gain root access. What term best describes this activity?",
    "choice_a": "Privilege escalation",
    "choice_b": "Lateral movement",
    "choice_c": "Pivoting",
    "choice_d": "Persistence",
    "correct_answer": "A",
    "explanation": "Privilege escalation is the act of increasing the level of access that an attacker has to a system. It is a common exploit to launch after gaining initial access to a system in an attempt to gain administrative access (otherwise known as root or superuser access).",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      67,
      43,
      51,
      66,
      69
    ],
    "source": "801931 c06"
  },
  {
    "id": 128,
    "question": "Jen is conducting a penetration test for a client. The client did not provide her with any details about their systems in advance of the test and Jen is determining this information using reconnaissance techniques. What type of test is Jen performing?",
    "choice_a": "Black box",
    "choice_b": "White box",
    "choice_c": "Gray box",
    "choice_d": "Blue box",
    "correct_answer": "A",
    "explanation": "Black-box tests are intended to replicate what an attacker would encounter. Testers are not provided with access to or information about an environment, and instead, they must gather information, discover vulnerabilities, and make their way through an infrastructure or systems like an attacker would. White-box tests are performed with full knowledge of the underlying technology, configurations, and settings that make up the target. Gray-box tests are a blend of black-box and white-box testing. Blue-box tests are not a type of penetration test.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      109,
      111,
      107,
      110,
      108
    ],
    "source": "801931 c06"
  },
  {
    "id": 441,
    "question": "In cloud security model does the cloud service provider bear the most responsibility for implementing security controls?",
    "choice_a": "IaaS",
    "choice_b": "FaaS",
    "choice_c": "PaaS",
    "choice_d": "SaaS",
    "correct_answer": "D",
    "explanation": "The cloud service provider bears the most responsibility for implementing security controls in an SaaS environment and the least responsibility in an IaaS environment. This is due to the division of responsibilities under the cloud computing shared responsibility model.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      131,
      128,
      130,
      133,
      129
    ],
    "source": "801931 c07"
  },
  {
    "id": 442,
    "question": "Adam is conducting software testing by reviewing the source code of the application. What type of code testing is Adam conducting?",
    "choice_a": "Mutation testing",
    "choice_b": "Static code analysis",
    "choice_c": "Dynamic code analysis",
    "choice_d": "Fuzzing",
    "correct_answer": "B",
    "explanation": "Adam is conducting static code analysis by reviewing the source code. Dynamic code analysis requires running the program, and both mutation testing and fuzzing are types of dynamic analysis.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      150,
      149,
      145,
      148,
      147
    ],
    "source": "801931 c07"
  },
  {
    "id": 443,
    "question": "Helen would like to configure her organization’s switches so that they do not allow systems connected to a switch to spoof MAC addresses. Which one of the following features would be helpful in this configuration?",
    "choice_a": "Loop protection",
    "choice_b": "Port security",
    "choice_c": "Flood guard",
    "choice_d": "Traffic encryption",
    "correct_answer": "B",
    "explanation": "Port security restricts the number of unique MAC addresses that may originate from a single switch port. It is commonly used to prevent someone from unplugging an authorized device from the network and connecting an unauthorized device but may also be used to prevent existing devices from spoofing MAC addresses of other devices.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      120,
      121,
      125,
      32,
      41
    ],
    "source": "801931 c07"
  },
  {
    "id": 444,
    "question": "Tim is working on a change to a web application used by his organization to fix a known bug. What environment should he be working in?",
    "choice_a": "Test",
    "choice_b": "Development",
    "choice_c": "Staging",
    "choice_d": "Production",
    "correct_answer": "B",
    "explanation": "Developers working on active changes to code should always work in the development environment. The test environment is where the software or systems can be tested without impacting the production environment. The staging environment is a transition environment for code that has successfully cleared testing and is waiting to be deployed into production. The production environment is the live system. Software, patches, and other changes that have been tested and approved move to production.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      146,
      147,
      145,
      148,
      117
    ],
    "source": "801931 c07"
  },
  {
    "id": 445,
    "question": "Which one of the following statements about cloud computing is incorrect?",
    "choice_a": "Cloud computing offers ubiquitous, convenient access.",
    "choice_b": "Cloud computing customers store data on hardware that is shared with other customers.",
    "choice_c": "Cloud computing customers provision resources through the service provider’s sales team.",
    "choice_d": "Cloud computing resources are accessed over a network.",
    "correct_answer": "C",
    "explanation": "One of the important characteristics of cloud computing is that customers can access resources on-demand with minimal service provider interaction. Cloud customers do not need to contact a sales representative each time they wish to provision a resource but can normally do so on a self-service basis.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      126,
      128,
      130,
      129,
      131
    ],
    "source": "801931 c07"
  },
  {
    "id": 446,
    "question": "Patricia is using a computer at a hotel business center, and she is concerned that the operating system on the device may be compromised. What is the best way for her to use this computer in a secure fashion?",
    "choice_a": "Use live boot media.",
    "choice_b": "Connect to a VPN.",
    "choice_c": "Run a malware scan.",
    "choice_d": "Only access secure websites.",
    "correct_answer": "A",
    "explanation": "If Patricia’s major concern is a compromised operating system, she can bypass the operating system on the device by booting it from live boot media and running her own operating system on the hardware. Running a malware scan may provide her with some information but may not detect all compromises, and Patricia likely does not have the necessary permissions to correct any issues. Using a VPN or accessing secure sites would not protect her against a compromised operating system, as the operating system would be able to view the contents of her communication prior to encryption.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      118,
      104,
      107,
      136,
      119
    ],
    "source": "801931 c07"
  },
  {
    "id": 447,
    "question": "Karim is investigating an alert generated by his organization’s NIDS. The system alerted to a distributed denial-of-service attack, and Karim’s investigation revealed that this type of attack did take place. What type of report has the system generated?",
    "choice_a": "False positive",
    "choice_b": "True negative",
    "choice_c": "True positive",
    "choice_d": "False negative",
    "correct_answer": "C",
    "explanation": "In a true positive report, the system reports an attack when an attack actually exists. A false positive report occurs when the system reports an attack that did not take place. A true negative report occurs when the system reports no attack and no attack took place. A false negative report occurs when the system does not report an attack that did take place.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      123,
      100,
      82,
      42,
      153
    ],
    "source": "801931 c07"
  },
  {
    "id": 448,
    "question": "What type of security solution provides a hardware platform for the storage and management of encryption keys?",
    "choice_a": "HSM",
    "choice_b": "IPS",
    "choice_c": "SIEM",
    "choice_d": "SOAR",
    "correct_answer": "A",
    "explanation": "Hardware security modules (HSMs) provide an effective way to manage encryption keys. These hardware devices store and manage encryption keys in a secure manner that prevents humans from ever needing to work directly with the keys.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      133,
      137,
      143,
      142,
      40
    ],
    "source": "801931 c07"
  },
  {
    "id": 449,
    "question": "Ryan is investigating a security incident. He believes that the incident is originating from a single system on the Internet and targeting multiple systems on his network. What control could he put in place to stop the incident as quickly as possible?",
    "choice_a": "DDoS mitigation",
    "choice_b": "Host firewall rule",
    "choice_c": "Operating system update",
    "choice_d": "Network firewall rule",
    "correct_answer": "D",
    "explanation": "The attack in question could be most quickly stopped with a network firewall rule blocking all traffic from the origin system. Host firewall rules would also address the issue but would be more time-consuming to create on every system. An operating system update would not stop attack traffic. There is also no indication that a DDoS attack is underway, so a DDoS mitigation service would not be helpful.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      119,
      121,
      35,
      33,
      95
    ],
    "source": "801931 c07"
  },
  {
    "id": 450,
    "question": "Kevin discovered that his web server was being overwhelmed by traffic, causing a CPU bottleneck. Using the interface offered by his cloud service provider, he added another CPU to the server. What term best describes Kevin’s action?",
    "choice_a": "Elasticity",
    "choice_b": "Horizontal scaling",
    "choice_c": "Vertical scaling",
    "choice_d": "High availability",
    "correct_answer": "C",
    "explanation": "This is an example of adding additional capacity to an existing server, which is also known as vertical scaling. Kevin could also have used horizontal scaling by adding additional web servers. Elasticity involves the ability to both add and remove capacity on demand, and though it does describe this scenario, it’s not as good a description as vertical scaling. There is no mention of increasing the server’s availability.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      127,
      126,
      130,
      131,
      128
    ],
    "source": "801931 c07"
  },
  {
    "id": 451,
    "question": "Every time Susan checks code into her organization’s code repository, it is tested, validated, and then if accepted is immediately put into production. What is the term for this?",
    "choice_a": "Continuous integration",
    "choice_b": "Continuous delivery",
    "choice_c": "A security nightmare",
    "choice_d": "Agile development",
    "correct_answer": "B",
    "explanation": "Although this example includes continuous integration, the important thing to notice is that the code is then deployed into production. This means that Susan is operating in a continuous deployment environment, where code is both continually integrated and deployed. Agile is a development methodology that often uses CI/CD, but we cannot determine if Susan is using an Agile methodology.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      148,
      145,
      146,
      147,
      149
    ],
    "source": "801931 c07"
  },
  {
    "id": 452,
    "question": "Tom is building a multifactor authentication system that requires users to enter a passcode and then verifies that their face matches a photo stored in the system. What two factors is this system using?",
    "choice_a": "Something you know and something you have",
    "choice_b": "Something you have and something you know",
    "choice_c": "Something you have and something you are",
    "choice_d": "Something you know and something you are",
    "correct_answer": "D",
    "explanation": "Facial recognition technology is an example of a biometric authentication technique, or “something you are.” A passcode is an example of a knowledge-based authentication technique, or “something you know.”.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      152,
      153,
      151,
      144,
      154
    ],
    "source": "801931 c07"
  },
  {
    "id": 453,
    "question": "Frank is evaluating the effectiveness of a biometric system. Which one of the following metrics would provide him with the best measure of the system’s effectiveness?",
    "choice_a": "IRR",
    "choice_b": "CER",
    "choice_c": "FAR",
    "choice_d": "FRR",
    "correct_answer": "B",
    "explanation": "The false rejection rate (FRR) identifies the number of times that an individual who should be allowed access to a facility is rejected. The false acceptance rate (FAR) identifies the number of times that an individual who should not be allowed access to a facility is admitted. Both the FAR and FRR may be manipulated by changing system settings. The crossover error rate (CER) is the rate at which the FRR and FAR are equal and is less prone to manipulation. Therefore, the CER is the best measure for Fred to use. IRR is not a measure of biometric system effectiveness.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      153,
      152,
      151,
      81,
      40
    ],
    "source": "801931 c07"
  },
  {
    "id": 454,
    "question": "Gary is logging into a system and providing his fingerprint to gain access. What step of the IAM process is he performing?",
    "choice_a": "Identification",
    "choice_b": "Authorization",
    "choice_c": "Authentication",
    "choice_d": "Accounting",
    "correct_answer": "C",
    "explanation": "Gary is proving his identity with his fingerprint, a biometric mechanism. Steps that prove your identity are examples of authentication techniques.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      151,
      152,
      153,
      144,
      155
    ],
    "source": "801931 c07"
  },
  {
    "id": 455,
    "question": "John is designing a system that will allow users from Acme Corporation, one of his organization’s vendors, to access John’s accounts payable system using the accounts provided by Acme Corporation. What type of authentication system is John attempting to design?",
    "choice_a": "Single sign-on",
    "choice_b": "Federated authentication",
    "choice_c": "Transitive trust",
    "choice_d": "Multifactor authentication",
    "correct_answer": "B",
    "explanation": "This type of authentication, where one domain trusts users from another domain, is called federation. Federation may involve transitive trusts, where the trusts may be followed through a series of domains, but this scenario only describes the use of two domains. And it also only describes the use of credentials for a single system and not for a multiple-system scenario where single sign-on would be relevant. There is no requirement described for the use of multifactor authentication, which would require the use of two or more diverse authentication techniques.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      154,
      151,
      152,
      91,
      94
    ],
    "source": "801931 c07"
  },
  {
    "id": 456,
    "question": "Howard is assessing the legal risks to his organization based on its handling of PII. The organization is based in the United States, handles the data of customers located in Europe, and stores information in Japanese data centers. What law would be most important to Howard during his assessment?",
    "choice_a": "Japanese law",
    "choice_b": "European Union law",
    "choice_c": "U.S. law",
    "choice_d": "All should have equal weight.",
    "correct_answer": "D",
    "explanation": "The principle of data sovereignty states that data is subject to the legal restrictions of any jurisdiction where it is collected, stored, or processed. In this case, Howard needs to assess the laws of all three jurisdictions.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      132,
      64,
      62,
      90,
      91
    ],
    "source": "801931 c07"
  },
  {
    "id": 457,
    "question": "David would like to send Mike a message using an asymmetric encryption algorithm to provide confidentiality. What key should he use to encrypt the message?",
    "choice_a": "David’s public key",
    "choice_b": "David’s private key",
    "choice_c": "Mike’s public key",
    "choice_d": "Mike’s private key",
    "correct_answer": "C",
    "explanation": "When encrypting a confidential message using an asymmetric encryption algorithm, the person performing the encryption does so using the recipient’s public key.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      138,
      143,
      141,
      139,
      140
    ],
    "source": "801931 c07"
  },
  {
    "id": 458,
    "question": "David would like to send Mike a message using an asymmetric encryption algorithm to provide confidentiality. When Mike receives the message that David encrypted for him, what key should he use to decrypt the message?",
    "choice_a": "David’s public key",
    "choice_b": "David’s private key",
    "choice_c": "Mike’s public key",
    "choice_d": "Mike’s private key",
    "correct_answer": "D",
    "explanation": "In an asymmetric encryption algorithm, the recipient of a confidential message uses their own private key to decrypt messages that they receive.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      138,
      143,
      141,
      140,
      144
    ],
    "source": "801931 c07"
  },
  {
    "id": 459,
    "question": "If David wishes to digitally sign the message that he is sending Mike, what key would he use to create the digital signature?",
    "choice_a": "David’s public key",
    "choice_b": "David’s private key",
    "choice_c": "Mike’s public key",
    "choice_d": "Mike’s private key",
    "correct_answer": "B",
    "explanation": "The sender of a message may digitally sign the message by encrypting a message digest with the sender’s own private key.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      140,
      138,
      136,
      143,
      139
    ],
    "source": "801931 c07"
  },
  {
    "id": 460,
    "question": "When Mike receives the digitally signed message from David, what key should he use to verify the digital signature?",
    "choice_a": "David’s public key",
    "choice_b": "David’s private key",
    "choice_c": "Mike’s public key",
    "choice_d": "Mike’s private key",
    "correct_answer": "A",
    "explanation": "The recipient of a digitally signed message may verify the digital signature by decrypting it with the public key of the individual who signed the message.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      140,
      138,
      141,
      136,
      143
    ],
    "source": "801931 c07"
  },
  {
    "id": 461,
    "question": "Which one of the following is an example of a computer security incident?",
    "choice_a": "User accesses a secure file",
    "choice_b": "Administrator changes a file’s permission settings",
    "choice_c": "Intruder breaks into a building",
    "choice_d": "Former employee crashes a server",
    "correct_answer": "D",
    "explanation": "A former employee crashing a server is an example of a computer security incident because it is an actual violation of the availability of that system. An intruder breaking into a building may be a security event, but it is not necessarily a computer security event unless they perform some action affecting a computer system. A user accessing a secure file and an administrator changing a file permission settings are examples of security events but are not security incidents.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      156,
      159,
      160,
      161,
      162
    ],
    "source": "801931 c08"
  },
  {
    "id": 462,
    "question": "During which phase of the incident response process would an organization implement defenses designed to reduce the likelihood of a security incident?",
    "choice_a": "Preparation",
    "choice_b": "Detection and analysis",
    "choice_c": "Containment, eradication, and recovery",
    "choice_d": "Post-incident activity",
    "correct_answer": "A",
    "explanation": "Organizations should build solid, defense-in-depth approaches to cybersecurity during the preparation phase of the incident response process. The controls built during this phase serve to reduce the likelihood and impact of future incidents.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      158,
      157,
      168,
      167,
      161
    ],
    "source": "801931 c08"
  },
  {
    "id": 463,
    "question": "Alan is responsible for developing his organization’s detection and analysis capabilities. He would like to purchase a system that can combine log records from multiple sources to detect potential security incidents. What type of system is best suited to meet Alan’s security objective?",
    "choice_a": "IPS",
    "choice_b": "IDS",
    "choice_c": "SIEM",
    "choice_d": "Firewall",
    "correct_answer": "C",
    "explanation": "A security information and event management (SIEM) system correlates log entries from multiple sources and attempts to identify potential security incidents.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      159,
      156,
      168,
      169,
      162
    ],
    "source": "801931 c08"
  },
  {
    "id": 464,
    "question": "Ben is working to classify the functional impact of an incident. The incident has disabled email service for approximately 30 percent of his organization’s staff. How should Ben classify the functional impact of this incident according to the NIST scale?",
    "choice_a": "None",
    "choice_b": "Low",
    "choice_c": "Medium",
    "choice_d": "High",
    "correct_answer": "C",
    "explanation": "The definition of a medium functional impact is that the organization has lost the ability to provide a critical service to a subset of system users. That accurately describes the situation that Ben finds himself in. Assigning a low functional impact is only done when the organization can provide all critical services to all users at diminished efficiency. Assigning a high functional impact is only done if a critical service is not available to all users.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      173,
      157,
      168,
      161,
      156
    ],
    "source": "801931 c08"
  },
  {
    "id": 465,
    "question": "Which phase of the incident response process would include measures designed to limit the damage caused by an ongoing breach?",
    "choice_a": "Preparation",
    "choice_b": "Detection and analysis",
    "choice_c": "Containment, eradication, and recovery",
    "choice_d": "Post-incident activity",
    "correct_answer": "C",
    "explanation": "The containment protocols included in the containment, eradication, and recovery phases are designed to limit the damage caused by an ongoing security incident.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      157,
      160,
      161,
      159,
      162
    ],
    "source": "801931 c08"
  },
  {
    "id": 466,
    "question": "Grace is the CSIRT leader for a business unit within NASA, a federal agency. What is the minimum amount of time that Grace must retain incident handling records?",
    "choice_a": "Six months",
    "choice_b": "One year",
    "choice_c": "Two years",
    "choice_d": "Three years",
    "correct_answer": "D",
    "explanation": "National Archives General Records Schedule (GRS) 24 requires that all U.S. federal agencies retain incident handling records for at least three years.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      165,
      166,
      168,
      158,
      169
    ],
    "source": "801931 c08"
  },
  {
    "id": 467,
    "question": "Karen is responding to a security incident that resulted from an intruder stealing files from a U.S. federal government agency. Those files contained unencrypted information about protected critical infrastructure. How should Karen rate the information impact of this loss?",
    "choice_a": "None",
    "choice_b": "Privacy breach",
    "choice_c": "Proprietary breach",
    "choice_d": "Integrity loss",
    "correct_answer": "C",
    "explanation": "In a proprietary breach, unclassified proprietary information is accessed or exfiltrated. Protected critical infrastructure information (PCII) is an example of unclassified proprietary information.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      174,
      156,
      168,
      161,
      165
    ],
    "source": "801931 c08"
  },
  {
    "id": 468,
    "question": "Matt is concerned about the fact that log records from his organization contain conflicting timestamps due to unsynchronized clocks. What protocol can he use to synchronize clocks throughout the enterprise?",
    "choice_a": "NTP",
    "choice_b": "FTP",
    "choice_c": "ARP",
    "choice_d": "SSH",
    "correct_answer": "A",
    "explanation": "The Network Time Protocol (NTP) provides a common source of time information that allows the synchronizing of clocks throughout an enterprise.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      159,
      178
    ],
    "source": "801931 c08"
  },
  {
    "id": 469,
    "question": "Which one of the following document types would outline the authority of a CSIRT responding to a security incident?",
    "choice_a": "Policy",
    "choice_b": "Procedure",
    "choice_c": "Playbook",
    "choice_d": "Baseline",
    "correct_answer": "A",
    "explanation": "An organization’s incident response policy should contain a clear description of the authority assigned to the CSIRT while responding to an active security incident.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      169,
      168,
      158,
      157,
      165
    ],
    "source": "801931 c08"
  },
  {
    "id": 470,
    "question": "A cross-site scripting attack is an example of what type of threat vector?",
    "choice_a": "Impersonation",
    "choice_b": "Email",
    "choice_c": "Attrition",
    "choice_d": "Web",
    "correct_answer": "D",
    "explanation": "A web attack is an attack executed from a website or web-based application—for example, a cross-site scripting attack used to steal credentials or redirect to a site that exploits a browser vulnerability and installs malware.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      171,
      172,
      174,
      158,
      160
    ],
    "source": "801931 c08"
  },
  {
    "id": 471,
    "question": "Which one of the following parties is not commonly the target of periodic external communications during an incident involving the theft of sensitive product development plans?",
    "choice_a": "The perpetrator",
    "choice_b": "Law enforcement",
    "choice_c": "Vendors",
    "choice_d": "Information sharing partners",
    "correct_answer": "A",
    "explanation": "CSIRT members do not normally communicate directly with the perpetrator of a cybersecurity incident. Although team members may have contact with the perpetrator in the case of ransomware attacks, this would not normally be the case during an incident involving the theft of information. It is far more likely that the CSIRT would be in routine contact with vendors, law enforcement, and information sharing partners as the incident unfolds.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      170,
      169,
      158,
      168,
      165
    ],
    "source": "801931 c08"
  },
  {
    "id": 472,
    "question": "Robert is finishing a draft of a proposed incident response policy for his organization. Who would be the most appropriate person to sign the policy?",
    "choice_a": "CEO",
    "choice_b": "Director of security",
    "choice_c": "CIO",
    "choice_d": "CSIRT leader",
    "correct_answer": "A",
    "explanation": "The incident response policy provides the CSIRT with the authority needed to do their job. Therefore, it should be approved by the highest possible level of authority within the organization, preferably the CEO.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      169,
      168,
      200,
      158,
      165
    ],
    "source": "801931 c08"
  },
  {
    "id": 473,
    "question": "Which one of the following is not an objective of the containment, eradication, and recovery phase of incident response?",
    "choice_a": "Detect an incident in progress",
    "choice_b": "Implement a containment strategy",
    "choice_c": "Identify the attackers",
    "choice_d": "Eradicate the effects of the incident",
    "correct_answer": "A",
    "explanation": "Detection of a potential incident occurs during the detection and analysis phase of incident response. The other activities listed might all be objectives of the containment, eradication, and recovery phase.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      157,
      159,
      160,
      161,
      162
    ],
    "source": "801931 c08"
  },
  {
    "id": 474,
    "question": "Renee is responding to a security incident that resulted in the unavailability of a website critical to her company’s operations. She is unsure of the amount of time and effort that it will take to recover the website. How should Renee classify the recoverability effort?",
    "choice_a": "Regular",
    "choice_b": "Supplemented",
    "choice_c": "Extended",
    "choice_d": "Not recoverable",
    "correct_answer": "C",
    "explanation": "Extended recoverability effort occurs when the time to recovery is unpredictable. In those cases, additional resources and outside help are typically needed.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      173,
      191,
      157,
      190,
      197
    ],
    "source": "801931 c08"
  },
  {
    "id": 475,
    "question": "Which one of the following is an example of an attrition attack?",
    "choice_a": "SQL injection",
    "choice_b": "Theft of a laptop",
    "choice_c": "User installs file-sharing software",
    "choice_d": "Brute-force password attack",
    "correct_answer": "D",
    "explanation": "An attrition attack employs brute-force methods to compromise, degrade, or destroy systems, networks, or services—for example, a DDoS attack intended to impair or deny access to a service or application or a brute-force attack against an authentication mechanism.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      171,
      168,
      183,
      169,
      174
    ],
    "source": "801931 c08"
  },
  {
    "id": 476,
    "question": "Who is the best facilitator for a post-incident lessons-learned session?",
    "choice_a": "CEO",
    "choice_b": "CSIRT leader",
    "choice_c": "Independent facilitator",
    "choice_d": "First responder",
    "correct_answer": "C",
    "explanation": "Lessons learned sessions are most effective when facilitated by an independent party who was not involved in the incident response effort.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      227,
      165,
      183,
      169,
      158
    ],
    "source": "801931 c08"
  },
  {
    "id": 477,
    "question": "Which one of the following elements is not normally found in an incident response policy?",
    "choice_a": "Performance measures for the CSIRT",
    "choice_b": "Definition of cybersecurity incidents",
    "choice_c": "Definition of roles, responsibilities, and levels of authority",
    "choice_d": "Procedures for rebuilding systems",
    "correct_answer": "D",
    "explanation": "Procedures for rebuilding systems are highly technical and would normally be included in a playbook or procedure document rather than an incident response policy.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      168,
      158,
      169,
      162,
      183
    ],
    "source": "801931 c08"
  },
  {
    "id": 478,
    "question": "An on-path attack is an example of what type of threat vector?",
    "choice_a": "Attrition",
    "choice_b": "Impersonation",
    "choice_c": "Web",
    "choice_d": "Email",
    "correct_answer": "B",
    "explanation": "An impersonation attack involves the replacement of something benign with something malicious—spoofing, on-path attacks, rogue wireless access points, and SQL injection attacks all involve impersonation.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      171,
      157,
      159,
      161,
      160
    ],
    "source": "801931 c08"
  },
  {
    "id": 479,
    "question": "Tommy is the CSIRT leader for his organization and is responding to a newly discovered security incident. What document is most likely to contain step-by-step instructions that he might follow in the early hours of the response effort?",
    "choice_a": "Policy",
    "choice_b": "Baseline",
    "choice_c": "Playbook",
    "choice_d": "Textbook",
    "correct_answer": "C",
    "explanation": "Incident response playbooks contain detailed step-by-step instructions that guide the early response to a cybersecurity incident. Organizations typically have playbooks prepared for high-severity and frequently occurring incident types.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      168,
      158,
      159,
      169,
      183
    ],
    "source": "801931 c08"
  },
  {
    "id": 480,
    "question": "Hank is responding to a security event where the CEO of his company had her laptop stolen. The laptop was encrypted but contained sensitive information about the company’s employees. How should Hank classify the information impact of this security event?",
    "choice_a": "None",
    "choice_b": "Privacy breach",
    "choice_c": "Proprietary breach",
    "choice_d": "Integrity loss",
    "correct_answer": "A",
    "explanation": "The event described in this scenario would not qualify as a security incident with measurable information impact. Although the laptop did contain information that might cause a privacy breach, that breach was avoided by the use of encryption to protect the contents of the laptop.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      156,
      174,
      159,
      161,
      163
    ],
    "source": "801931 c08"
  },
  {
    "id": 481,
    "question": "Tracy is preparing for her organization’s annual business continuity exercise, but she encounters resistance from some managers who don’t see the exercise as important and feel that it is a waste of resources. She has already told the managers that it will only take half a day for their employees to participate. What argument could Tracy make to best address these concerns?",
    "choice_a": "The exercise is required by policy.",
    "choice_b": "The exercise is already scheduled, and canceling it would be difficult.",
    "choice_c": "The exercise is crucial to ensuring that the organization is prepared for emergencies.",
    "choice_d": "The exercise will not be very time-consuming.",
    "correct_answer": "C",
    "explanation": "This question requires that you exercise some judgment, as do many questions on the CISM exam. All of these answers are plausible things that Tracy could bring up, but we’re looking for the best answer. In this case, that is ensuring that the organization is ready for an emergency—a mission-critical goal. Telling managers that the exercise is already scheduled or required by policy doesn’t address their concerns that it is a waste of time. Telling them that it won’t be time-consuming is not likely to be an effective argument because they are already raising concerns about the amount of time requested.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      184,
      202,
      200,
      225,
      203
    ],
    "source": "801931 c09"
  },
  {
    "id": 482,
    "question": "The board of directors of Clashmore Circuits is conducting an annual review of the business continuity planning process to ensure that adequate measures are in place to minimize the effect of a disaster on the organization’s continued viability. What obligation are they satisfying with this review?",
    "choice_a": "Corporate responsibility",
    "choice_b": "Disaster requirement",
    "choice_c": "Due diligence",
    "choice_d": "Going concern responsibility",
    "correct_answer": "C",
    "explanation": "A firm’s officers and directors are legally bound to exercise due diligence in conducting their activities. This concept creates a fiduciary responsibility on their part to ensure that adequate business continuity plans are in place. This is an element of corporate responsibility, but that term is vague and not commonly used to describe a board’s responsibilities. Disaster requirement and going concern responsibilities are also not risk management terms.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      200,
      184,
      186,
      202,
      201
    ],
    "source": "801931 c09"
  },
  {
    "id": 483,
    "question": "Renee is reporting the results of her organization’s BIA to senior leaders. They express frustration at all of the details, and one of them says, “Look, we just need to know how much we should expect these risks to cost us each year.” What measure could Renee provide to best answer this question?",
    "choice_a": "ARO",
    "choice_b": "SLE",
    "choice_c": "ALE",
    "choice_d": "EF",
    "correct_answer": "C",
    "explanation": "The annualized loss expectancy (ALE) represents the amount of money a business expects to lose to a given risk each year. This figure is quite useful when performing a quantitative prioritization of business continuity resource allocation.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      193,
      195,
      191,
      197,
      190
    ],
    "source": "801931 c09"
  },
  {
    "id": 484,
    "question": "Jake is conducting a business impact analysis for his organization. As part of the process, he asks leaders from different units to provide input on how long the enterprise resource planning (ERP) system could be unavailable without causing irreparable harm to the organization. What measure is he seeking to determine?",
    "choice_a": "SLE",
    "choice_b": "EF",
    "choice_c": "MTD",
    "choice_d": "ARO",
    "correct_answer": "C",
    "explanation": "The maximum tolerable downtime (MTD) represents the longest period a business function can be unavailable before causing irreparable harm to the business. This figure is useful when determining the level of business continuity resources to assign to a particular function.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      191,
      197,
      190,
      215,
      184
    ],
    "source": "801931 c09"
  },
  {
    "id": 485,
    "question": "You are concerned about the risk that an avalanche poses to your $3 million shipping facility. Based on expert opinion, you determine that there is a 5 percent chance that an avalanche will occur each year. Experts advise you that an avalanche would completely destroy your building and require you to rebuild on the same land. Ninety percent of the $3 million value of the facility is attributed to the building, and 10 percent is attributed to the land itself. What is the single loss expectancy (SLE) of your shipping facility to avalanches?",
    "choice_a": "$3 million",
    "choice_b": "$2,700,000",
    "choice_c": "$270,000",
    "choice_d": "$135,000",
    "correct_answer": "B",
    "explanation": "The single loss expectancy (SLE) is the product of the asset value (AV) and the exposure factor (EF). From the scenario, you know that the AV is $3 million and the EF is 90 percent, based on that the same land can be used to rebuild the facility. This yields an SLE of $2,700,000.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      193,
      194,
      191,
      197,
      184
    ],
    "source": "801931 c09"
  },
  {
    "id": 486,
    "question": "You are concerned about the risk that a hurricane poses to your corporate headquarters in South Florida. The building itself is valued at $15 million. After consulting with the National Weather Service, you determine that there is a 10 percent likelihood that a hurricane will strike over the course of a year. You hire a team of architects and engineers who determine that the average hurricane would destroy approximately 50 percent of the building. What is the annualized loss expectancy (ALE)?",
    "choice_a": "$750,000",
    "choice_b": "$1.5 million",
    "choice_c": "$7.5 million",
    "choice_d": "$15 million",
    "correct_answer": "A",
    "explanation": "This problem requires you to compute the ALE, which is the product of the SLE and ARO. From the scenario, you know that the ARO is 0.10 (or 10 percent). From the scenario presented, you know that the SLE is $7.5 million. This yields an ALE of $750,000.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      193,
      194,
      184,
      197,
      192
    ],
    "source": "801931 c09"
  },
  {
    "id": 487,
    "question": "Brian is developing continuity plan provisions and processes for his organization. What resource should he protect as the highest priority in those plans?",
    "choice_a": "Physical plant",
    "choice_b": "Infrastructure",
    "choice_c": "Financial",
    "choice_d": "People",
    "correct_answer": "D",
    "explanation": "The safety of human life must always be the paramount concern in business continuity planning. Be sure that your plan reflects this priority, especially in the written documentation that is disseminated to your organization’s employees!",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      198,
      184,
      190,
      201,
      199
    ],
    "source": "801931 c09"
  },
  {
    "id": 488,
    "question": "Ricky is conducting the quantitative portion of his organization’s business impact analysis. Which one of the following concerns is <i>least</i> suitable for quantitative measurement during this assessment?",
    "choice_a": "Loss of a plant",
    "choice_b": "Damage to a vehicle",
    "choice_c": "Negative publicity",
    "choice_d": "Power outage",
    "correct_answer": "C",
    "explanation": "It is difficult to put a dollar figure on the business lost because of negative publicity. Therefore, this type of concern is better evaluated through qualitative analysis. The other items listed here are all more easily quantifiable.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      195,
      190,
      193,
      194,
      192
    ],
    "source": "801931 c09"
  },
  {
    "id": 489,
    "question": "Darren is concerned about the risk of a serious power outage affecting his organization’s data center. He consults the organization’s business impact analysis and determines that the ARO of a power outage is 20 percent. He notes that the assessment took place three years ago and no power outage has occurred. What ARO should he use in this year’s assessment, assuming that none of the circumstances underlying the analysis have changed?",
    "choice_a": "20 percent",
    "choice_b": "50 percent",
    "choice_c": "75 percent",
    "choice_d": "100 percent",
    "correct_answer": "A",
    "explanation": "The annualized rate of occurrence (ARO) is the likelihood that the risk will materialize in any given year. The fact that a power outage did not occur in any of the past three years doesn’t change the probability that one will occur in the upcoming year. Unless other circumstances have changed, the ARO should remain the same.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      194,
      193,
      190,
      197,
      184
    ],
    "source": "801931 c09"
  },
  {
    "id": 490,
    "question": "Of the individuals listed, who would provide the best endorsement for a business continuity plan’s statement of importance?",
    "choice_a": "Vice president of business operations",
    "choice_b": "Chief information officer",
    "choice_c": "Chief executive officer",
    "choice_d": "Business continuity manager",
    "correct_answer": "C",
    "explanation": "You should strive to have the highest-ranking person possible sign the BCP’s statement of importance. Of the choices given, the chief executive officer (CEO) is the highest ranking.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      200,
      199,
      201,
      184,
      186
    ],
    "source": "801931 c09"
  },
  {
    "id": 491,
    "question": "Kevin is attempting to determine an appropriate backup frequency for his organization’s database server and wants to ensure that any data loss is within the organization’s risk appetite. Which one of the following security process metrics would best assist him with this task?",
    "choice_a": "RTO",
    "choice_b": "MTD",
    "choice_c": "RPO",
    "choice_d": "MTBF",
    "correct_answer": "C",
    "explanation": "The recovery point objective (RPO) specifies the maximum amount of data that may be lost during a disaster and should be used to guide backup strategies. The maximum tolerable downtime (MTD) and recovery time objective (RTO) are related to the duration of an outage, rather than the amount of data lost. The mean time between failures (MTBF) is related to the frequency of failure events.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      191,
      223,
      185,
      201,
      226
    ],
    "source": "801931 c09"
  },
  {
    "id": 492,
    "question": "Brian’s organization recently suffered a disaster and wants to improve their disaster recovery program based on their experience. Which one of the following activities will best assist with this task?",
    "choice_a": "Training programs",
    "choice_b": "Awareness efforts",
    "choice_c": "BIA review",
    "choice_d": "Lessons learned",
    "correct_answer": "D",
    "explanation": "The lessons learned session captures discoveries made during the disaster recovery process and facilitates continuous improvement. It may identify deficiencies in training and awareness or the BIA.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      227,
      165,
      225,
      228,
      226
    ],
    "source": "801931 c09"
  },
  {
    "id": 493,
    "question": "Adam is reviewing the fault tolerance controls used by his organization and realizes that they currently have a single point of failure in the disks used to support a critical server. Which one of the following controls can provide fault tolerance for these disks?",
    "choice_a": "Load balancing",
    "choice_b": "RAID",
    "choice_c": "Clustering",
    "choice_d": "HA pairs",
    "correct_answer": "B",
    "explanation": "Redundant arrays of inexpensive disks (RAID) are a fault tolerance control that allows an organization’s storage service to withstand the loss of one or more individual disks. Load balancing, clustering, and HA pairs are all fault-tolerance services designed for server compute capacity, not storage.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      211,
      212,
      210,
      213,
      202
    ],
    "source": "801931 c09"
  },
  {
    "id": 494,
    "question": "Brad is helping to design a disaster recovery strategy for his organization and is analyzing possible storage locations for backup data. He is not certain where the organization will recover operations in the event of a disaster and would like to choose an option that allows them the flexibility to easily retrieve data from any DR site. Which one of the following storage locations provides the best option for Brad?",
    "choice_a": "Primary data center",
    "choice_b": "Field office",
    "choice_c": "Cloud computing",
    "choice_d": "IT manager’s home",
    "correct_answer": "C",
    "explanation": "Cloud computing services provide an excellent location for backup storage because they are accessible from any location. The primary data center is a poor choice, as it may be damaged during a disaster. A field office is reasonable, but it is in a specific location and is not as flexible as a cloud-based approach. The IT manager’s home is a poor choice, as the IT manager may leave the organization or may not have appropriate environmental and physical security controls in place.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      221,
      223,
      196,
      219,
      228
    ],
    "source": "801931 c09"
  },
  {
    "id": 495,
    "question": "Tonya is reviewing the flood risk to her organization and learns that their primary data center resides within a 100-year flood plain. What conclusion can she draw from this information?",
    "choice_a": "The last flood of any kind to hit the area was more than 100 years ago.",
    "choice_b": "The odds of a flood at this level are 1 in 100 in any given year.",
    "choice_c": "The area is expected to be safe from flooding for at least 100 years.",
    "choice_d": "The last significant flood to hit the area was more than 100 years ago.",
    "correct_answer": "B",
    "explanation": "The term <i>100-year flood plain</i> is used to describe an area where flooding is expected once every 100 years. It is, however, more mathematically correct to say that this label indicates a 1 percent probability of flooding in any given year.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      204,
      209,
      194,
      201,
      186
    ],
    "source": "801931 c09"
  },
  {
    "id": 496,
    "question": "Bryn runs a corporate website and currently uses a single server, which is capable of handling the site’s entire load. She is concerned, however, that an outage on that server could cause the organization to exceed its RTO. What action could she take that would best protect against this risk?",
    "choice_a": "Install dual power supplies in the server",
    "choice_b": "Replace the server’s hard drives with RAID arrays",
    "choice_c": "Deploy multiple servers behind a load balancer",
    "choice_d": "Perform regular backups of the server",
    "correct_answer": "C",
    "explanation": "All of these are good practices that could help improve the quality of service that Bryn provides from her website. Installing dual power supplies or deploying RAID arrays could reduce the likelihood of a server failure, but these measures only protect against a single risk each. Deploying multiple servers behind a load balancer is the best option because it protects against any type of risk that would cause a server failure. Backups are an important control for recovering operations after a disaster and different backup strategies could indeed alter the RTO, but it is even better if Bryn can design a web architecture that lowers the risk of the outage occurring in the first place.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      212,
      210,
      197,
      213,
      211
    ],
    "source": "801931 c09"
  },
  {
    "id": 497,
    "question": "Nolan is considering the use of several different types of alternate processing facilities for his organization’s data center. Which one of the following alternative processing sites takes the longest time to activate but has the lowest cost to implement?",
    "choice_a": "Hot site",
    "choice_b": "Mobile site",
    "choice_c": "Cold site",
    "choice_d": "Warm site",
    "correct_answer": "C",
    "explanation": "The cold site contains none of the equipment necessary to restore operations. All of the equipment must be brought in and configured and data must be restored to it before operations can commence. This often takes weeks, but cold sites also have the lowest cost to implement. Hot sites, warm sites, and mobile sites all have quicker recovery times.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      217,
      224,
      191,
      197,
      226
    ],
    "source": "801931 c09"
  },
  {
    "id": 498,
    "question": "Harry is conducting a disaster recovery test. He moved a group of personnel to the alternate recovery site where they are mimicking the operations of the primary site but do not have operational responsibility. What type of disaster recovery test is he performing?",
    "choice_a": "Checklist test",
    "choice_b": "Structured walkthrough",
    "choice_c": "Simulation test",
    "choice_d": "Parallel test",
    "correct_answer": "D",
    "explanation": "The parallel test involves relocating personnel to the alternate recovery site and implementing site activation procedures. Checklist tests, structured walkthroughs, and simulations are all test types that do not involve actually activating the alternate site.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      226,
      217,
      224,
      219,
      225
    ],
    "source": "801931 c09"
  },
  {
    "id": 499,
    "question": "What type of backup involves always storing copies of all files modified since the most recent full backup?",
    "choice_a": "Differential backups",
    "choice_b": "Partial backup",
    "choice_c": "Incremental backups",
    "choice_d": "Database backup",
    "correct_answer": "A",
    "explanation": "Differential backups involve always storing copies of all files modified since the most recent full backup regardless of any incremental or differential backups created during the intervening time period.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      223,
      210,
      219,
      203,
      184
    ],
    "source": "801931 c09"
  },
  {
    "id": 500,
    "question": "You operate a grain processing business and are developing your restoration priorities. Which one of the following systems would likely be your highest priority?",
    "choice_a": "Order-processing system",
    "choice_b": "Fire suppression system",
    "choice_c": "Payroll system",
    "choice_d": "Website",
    "correct_answer": "B",
    "explanation": "People should always be your highest priority in business continuity planning. As a life safety system, fire suppression systems should always receive high prioritization.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      198,
      184,
      191,
      195,
      201
    ],
    "source": "801931 c09"
  }
];
